import { Injectable } from '@angular/core';

import XYZ from 'ol/source/XYZ';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import MVT from 'ol/format/MVT';
import {createXYZ} from 'ol/tilegrid';
// import styleFunction from 'ol-mapbox-style/dist/stylefunction';
import { stylefunction } from 'ol-mapbox-style';

import Feature from 'ol/Feature';
import Group from 'ol/layer/Group';
import Heatmap from 'ol/layer/Heatmap';
import * as proj from 'ol/proj';
import { register } from 'ol/proj/proj4';
import * as condition from 'ol/events/condition';
import OSM from 'ol/source/OSM';
import Control from 'ol/control/Control';
import GeoJSON from 'ol/format/GeoJSON';
import TileLayer from 'ol/layer/Tile';
import View from 'ol/View';
import TileGrid from 'ol/tilegrid/TileGrid';
import TileImage from 'ol/source/TileImage';
import TileWMS from 'ol/source/TileWMS';
import Modify from 'ol/interaction/Modify';
import Select from 'ol/interaction/Select';
import Circle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import FullScreen from 'ol/control/FullScreen';
import Icon from 'ol/style/Icon';
import Draw, {createRegularPolygon, createBox, DrawEvent} from 'ol/interaction/Draw';
import * as olColor from 'ol/color';
import { getDistance } from 'ol/sphere';
import * as olExtent from 'ol/extent';
import * as olControl from 'ol/control';
// import * as olInteraction from 'ol/interaction';
import Map from 'ol/Map';
import LineString from 'ol/geom/LineString';
import MultiLineString from 'ol/geom/MultiLineString';
import MultiPoint from 'ol/geom/MultiPoint';
import MultiPolygon from 'ol/geom/MultiPolygon';
import Point from 'ol/geom/Point';
import Polygon, { makeRegular } from 'ol/geom/Polygon';
import { circular, fromCircle } from 'ol/geom/Polygon';
import CircleShape from 'ol/geom/Circle';
import {GeometryCollection} from 'ol/geom';
import Snap from 'ol/interaction/Snap';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import Text from 'ol/style/Text';
import LayerVector from 'ol/layer/Vector';
import SourceVector from 'ol/source/Vector';
import Zoom from 'ol/control/Zoom';
import proj4 from 'proj4';
import {SclUtilMapService} from './scl-util-map.service';
import {SclProjectionConstantService} from './scl-projection-constant.service';
import {SclMapViewsService} from './scl-map-views.service';
import {SclMapConstantService} from './scl-map-constant.service';
import {SclAssetLayersService} from './scl-asset-layers.service';
import Cluster from 'ol/source/Cluster';
import { defaults, MouseWheelZoom } from 'ol/interaction';
import {isNumber, cloneDeep, isInteger} from 'lodash';
import {boundingExtent} from 'ol/extent';
import { MapLibrary, MapDrawType, ShapeIdGroup, MapDrawAction, MapDrawTypeSpecial
, MapDrawMode, MapComponentName, MapSelectAssetMode, MapSelectAssetType, 
GEOJSON_TYPE,
FEATURE_TYPE} from './map-library';
import Overlay from 'ol/Overlay';
import * as uuid from 'uuid';
import {getLength} from 'ol/sphere.js';
import {unByKey} from 'ol/Observable.js';
import {getUid} from 'ol/util';
import Translate from 'ol/interaction/Translate';
import {createDefaultStyle} from 'ol/style/Style';


const sclUtilMap = new SclUtilMapService();
const sclProjectionConstant = SclProjectionConstantService;
const sclMapViews = new SclMapViewsService();
const sclAssetLayers = new SclAssetLayersService();



/** inherits has been removed in OpenLayers 6, according to
 * https://github.com/openlayers/openlayers/blob/master/changelog/upgrade-notes.md#removal-of-deprecated-methods
 * This function replaces it
 */
function olInherits(child, parent) {
  child.prototype = Object.create(parent.prototype);
  child.prototype.constructor = child;
}

@Injectable({
  providedIn: 'root'
})
export class SclMappingFunctionOpenLayersService extends MapLibrary {
  keyValueStorageService: any;

  constructor() {
    super();
    this.zoomFloor = 12; // 14254
    this.drawingToolsSupported = ['point', 'line', 'polygon', 'circle', 'square', 'box', 'text'
    , 'currentLocation', 'delete', 'arrowAtFirstPoint', 'arrowAtLastPoint', 'dimension'];
    this.totalDrawTool = 7; // total tool for drawing (point, line, polygon, circle, square, box)

  }

  source; // source vector
  view; // view
  vector; // vector
  proj4s = proj4;
  draw;
  select; modify;  selectMultiple;
  divWrapper;
  EPSG;
  mapViewLayers;
  wmsState = { hasTile: false, hasEvent: false, finishLoad: false, tileCount: 0, hasTransparency: false, waitMapRender: null };
  // this.stlBoundary;//styleBoundary
  fitObject = { hasCall : false , service : null, maxZoom : null, initialZoomChange: null };
  positionObject = { hasCall: false, lat: null, lon: null, zoom: null, epsg: null };
  setupMapDone;
  canvas = null;
  layersRedraw = false; layersRedrawCount = 0; assetOfLayers = {}; // <layerIndex, [assets]>;//for sc-selected-asset test re-draw
  mapId;
  // call this function for draw on map
  elementCtrl;
  testDiv;
  snap; 
  checkMapLoadDone; show;
  fromFitData = false; // 14930
  afterLoadSelectedAssetFn; // 15145
  selectPointerMove; // 15141#c57727
  
  hasClickButtonZoom = false; // 15860
  onMapWheelScroll = null; // 15973
  fitPadding = 0; countGetImgSrc = 0;
  minResolution = null; maxResolution = null; // 16045#c68427
  
  checkMapEmptyLogError;
  sketchGeomOnChange = null;
  sketchPoints = [];
  mapClickCount = 0;
  selectedFeature = null;
  hasClickMap = false;
  translate;
  isMoving = false;
  selectedFeatureCenter = null;
  textBoxAnchorPointCoor = null;
  textBoxAnchorLineCoor = null;
  configService = null;
  initialZoomChange = null;
  watchDocFn = null;
  mapTarget = null;
  checkCanvasIntervalId = null;
  currentUrl = '';
  supportedZoom = -1;
  currentTileSource = null;
  destinateZoom = null;
  isPBF = false;
  defaultMaxZoom = 19;
  zLevelExpiration = 604800;
  hasWheelScroll = false;

  load(keyValueStorageService, cb) {
    this.keyValueStorageService = keyValueStorageService;
    if (cb && typeof cb === 'function') {
      cb();
    }
  }

  calculateCenter(geometry: any) {
    let center: any, coordinates, minRadius;
    const type = geometry.getType();
    if (type === MapDrawType.POLYGON) {
      let x = 0;
      let y = 0;
      let i = 0;
      coordinates = geometry.getCoordinates()[0].slice(1);
      coordinates.forEach( (coordinate: any) => {
        x += coordinate[0];
        y += coordinate[1];
        i++;
      });
      center = [x / i, y / i];
    } else if (type === MapDrawType.LINE_STRING) {
      center = geometry.getCoordinateAt(0.5);
      coordinates = geometry.getCoordinates();
    } else {
      center = olExtent.getCenter(geometry.getExtent());
    }
    let sqDistances;
    if (coordinates) {
      sqDistances = coordinates.map( (coordinate: any) => {
        const dx = coordinate[0] - center[0];
        const dy = coordinate[1] - center[1];
        return dx * dx + dy * dy;
      });
      minRadius = Math.sqrt(Math.max.apply(Math, sqDistances)) / 3;
    } else {
      minRadius =
        Math.max(
          olExtent.getWidth(geometry.getExtent()),
          olExtent.getHeight(geometry.getExtent())
        ) / 3;
    }
    return {
      center: center,
      coordinates: coordinates,
      minRadius: minRadius,
      sqDistances: sqDistances,
    };
  }

  createShapeBoundingBox(feature) {
    const extent = feature.getGeometry().getExtent();
    this.boundingRectangle = new Polygon([[
      [extent[0] - this.boundPadding, extent[1] - this.boundPadding],
      [extent[0] - this.boundPadding, extent[3] + this.boundPadding],
      [extent[2] + this.boundPadding, extent[3] + this.boundPadding],
      [extent[2] + this.boundPadding, extent[1] - this.boundPadding],
      [extent[0] - this.boundPadding, extent[1] - this.boundPadding]
    ]]);
  }

  createDebugShapeBoundingBoxFeature() {
    if (this.isDebugRotate == false) { return; }
    this.boundingRectangleFeature = new Feature(this.boundingRectangle);
    this.boundingRectangleFeature.setStyle(
      new Style({
        stroke: new Stroke({
          color: 'black',
          width: 2,
          lineDash: [4, 4] // Dashed line
        })
      })
    );
    const p = this.boundingRectangleFeature.getProperties();
    p.isDebug = true;
    this.boundingRectangleFeature.setProperties(p);

    this.source.addFeature(this.boundingRectangleFeature);
  }

  removeDebugShapeBoundingBoxFeature() {
    if (this.isDebugRotate == false) { return; }
    if (this.boundingRectangleFeature) {
      this.source.removeFeature(this.boundingRectangleFeature);
    }
    this.boundingRectangleFeature = null;
  }

  updateDebugShapeBoundingBoxFeature() {
    if (this.isDebugRotate == false) { return; }
    this.boundingRectangleFeature.setGeometry(this.boundingRectangle);
  }

  createRotateIcon() {
    const rotateIcon = document.createElement('div');
    rotateIcon.id = this.rotateObjectId;
    rotateIcon.setAttribute('class', 'material-icons');
    rotateIcon.innerHTML = 'refresh'; // reload icon
    rotateIcon.onmousedown = () => {
      this.allowRotate = true;
    };
    rotateIcon.onmouseup = () => {
      this.allowRotate = false;
    };
    return rotateIcon;
  }
  createRotateOverlay(rotateIcon) {
    this.rotateObject = new Overlay({
      element: rotateIcon,
      positioning: 'center-center',
      id: this.rotateObjectId,
    });
    this.map.addOverlay(this.rotateObject);
    this.rotateObject.setPosition(undefined);
  }

  deselectFeature() {
    this.removeDebugShapeBoundingBoxFeature();

    this.allowRotate = false;
    this.isMoving = false;
    this.selectedFeatureCenter = null;
    this.boundingRectangleFeature = null;
    this.boundingRectangle = null;
  }

  interactionSelect() {
    this.select = new Select({
      filter: function(feature, layer) {
        return !feature.getProperties().hasOwnProperty('textId');
      }
    });
    this.select.on('select', (e) => {
      if (this.rotateObjectId == null) {
        this.rotateObjectId = `${this.keyName}_rotate`;
        this.createRotateOverlay(this.createRotateIcon());
      } else {
        const ov = this.map.getOverlayById(this.rotateObjectId);
        if (ov == null) {
          this.createRotateOverlay(this.createRotateIcon());
        } else {
          const elem = document.getElementById(this.rotateObjectId);
          if (elem == null) {
            // console.log(`**** select on, rotate element = `, elem);
            const rotateIcon = this.createRotateIcon();
            this.rotateObject.setElement(rotateIcon);
          }
        }
        
      }
      
      
      if (this.selectedFeature == null) {
        if (e.selected.length > 0) {
          this.selectedFeature = e.selected[0];
          console.log(`assign selectedFeature = `, this.selectedFeature);
        } else {
          console.log(`selectedFeature = `, this.selectedFeature);
        }
        
      } else {
        let currentSelectedUId = getUid(this.selectedFeature);
        // console.log(`currentSelectedUId = ${currentSelectedUId}`);
        let selectedUId = null;
        if (e.selected.length > 0) {
          selectedUId = getUid(e.selected[0]);
        }
        // console.log(`selectedUId = ${selectedUId}`);
        if (selectedUId != null && selectedUId != currentSelectedUId) {
          if (e.selected.length > 0) {
            this.selectedFeature = e.selected[0];
            // console.log(`assign new select feature = `, this.selectedFeature);
          } else {
            console.log(`no select feature, selectedFeature = `, this.selectedFeature);
          }
        } else {
          let deSelectedUId = null;
          if (e.deselected.length > 0) {
            deSelectedUId = getUid(e.deselected[0]);
          }
          // console.log(`deSelectedUId = ${deSelectedUId}
          // , hasClickMap = ${this.hasClickMap}`);
          if (this.hasClickMap && currentSelectedUId == deSelectedUId) {
            this.selectedFeature = null;
            // console.log(`reset select feature = `, this.selectedFeature);
          } else {
            console.log(`No click map and currentSelectedUId != deSelectedUId, selectedFeature = `
            , this.selectedFeature);
          }
        }
      }

      this.hasClickMap = false; // reset

      if (e.deselected.length > 0) {
        // console.log(`**** deselect`);
        this.deselectFeature();
      }
      if (e.selected.length > 0) {
        // console.log(`**** select`);
        const feature: any = e.selected[0];
        // If a feature is deselected
        if (!feature) {
          // console.log(`**** deselect 222`);
          // Hide the rotate icon
          this.rotateObject.setPosition(undefined);
          this.allowRotate = false;
          return;
        }
        // console.log(`**** select feature`);
        this.selectedFeatureCenter = this.calculateCenter(feature.getGeometry()).center;
      
        this.createShapeBoundingBox(feature);
  
        this.createDebugShapeBoundingBoxFeature();
      }
      
    });
  }

  interactionModify() {
    this.modify = new Modify({
      features: this.select.getFeatures()
    });
    this.modify.on('modifystart', (e) => {
      // console.log(`***** modify start, e = `, e);
    });
    this.modify.on('modifyend', (e) => {
      // console.log(`***** modify end, e = `, e);
      // update the bounding rectangle
      const feature = this.select.getFeatures().item(0);
      this.createShapeBoundingBox(feature);

      this.removeDebugShapeBoundingBoxFeature();

      this.hasDocumentChangeValue = false;
      if (this.setDirtyFunction && typeof this.setDirtyFunction === 'function' ) {
        this.setDirtyFunction();
      }
    });
  }

  interactionTranslate() {
    this.translate = new Translate({
      features: this.select.getFeatures(),
    });
    this.translate.on('translatestart', (e) => {
      this.isMoving = true;
    });

    this.translate.on('translateend', (e) => {
      // console.log(`***** translate end, e = `, e);
      this.isMoving = false;

      // update the bounding rectangle
      const feature = this.select.getFeatures().item(0);
      this.selectedFeatureCenter = this.calculateCenter(feature.getGeometry()).center;

      this.createShapeBoundingBox(feature);

      this.removeDebugShapeBoundingBoxFeature();

      this.hasDocumentChangeValue = false;

      if (this.setDirtyFunction && typeof this.setDirtyFunction === 'function' ) {
        this.setDirtyFunction();
      }
    });
  }

  interactionSelectMultiple(isActive, cb) {
    this.selectMultiple = new Select({
      multi: true,
      condition: condition.click,
      toggleCondition: condition.primaryAction,
      style: this.styleSelectedFunc.bind(this)
    });
    this.selectMultiple.setActive(isActive);
    const self = (this as any);
    this.selectMultiple.on('select',
      function(e) {
      // add feature to layer user
      const selected = e.target.getFeatures();
      for (let i = 0; i < selected.getLength(); i++) {
        const fea = selected.getArray()[i];
        if (fea === 'undefined' || fea == null) { continue; }
        const pro = fea.getProperties();
        if (pro == null) { continue; }

        if (!pro.layerDisplayOnly) {
          self.addFeature(fea, self.layerIndexUser);
        }
      }

      if (cb && typeof cb === 'function') {
        cb(e);
      }
    });
  }

  removeOverlays() {
    const overlays = this.map.getOverlays();
    const len = overlays.getLength();
    for (let i = len - 1; i > -1; i--) {
      const ov = overlays.item(i);
      // console.log(`*** removeOverlays id : ${ov.getId()}`);
      this.map.removeOverlay(ov);
    }
  }

  checkAndDrawGeoJson(geoJson) {
    const isValidGeo = this.checkGeoJson(geoJson);
    console.log(`**** is valid geo = ${isValidGeo}`);

    if (geoJson && isValidGeo) {
      if (this.mapType === MapComponentName.BOUNDARY
         && this.actionType === MapDrawAction.SELECT && this.selectedFeature) {
        return;
      }
      this.vector.getSource().clear();
      this.removeOverlays();

      geoJson = this.normalizeGeoJson(geoJson);

      // console.log(`**** normalize json = ${JSON.stringify(geoJson)}`);

      this.drawGeoJSON(geoJson);
    }
  }

  checkGeoJson(geojson) {
    if (!geojson || !Array.isArray(geojson.features) || geojson.features.length === 0) {
      return false;
    }
  
    for (const feature of geojson.features) {
      if (!feature || typeof feature.type === 'undefined') {
        return false;
      }
  
      const hasValidGeometry =
        feature.geometry &&
        typeof feature.geometry.type !== 'undefined' &&
        Array.isArray(feature.geometry.coordinates);
  
      const hasValidGeometries =
        Array.isArray(feature.geometries) &&
        feature.geometries.length > 0 &&
        feature.geometries.every(
          g => g && typeof g.type !== 'undefined' && Array.isArray(g.coordinates)
        );
  
      if (!hasValidGeometry && !hasValidGeometries) {
        return false;
      }
    }
  
    return true;
  }
  

  clampZoomFloor() {
    console.log('%c clampZoomFloor, currentZoom = ' + this.view.getZoom() + ', zoomFloor = ' + this.zoomFloor, 'color:blue');
    if (this.view.getZoom() > this.zoomFloor) { this.view.setZoom(this.zoomFloor); }
  }
  createMapboxStreetsV6Style(Style, Fill, Stroke, Icon, Text) {
    var fill = new Fill({color: ''});
    var stroke = new Stroke({color: '', width: 1});
    var polygon = new Style({fill: fill});
    var strokedPolygon = new Style({fill: fill, stroke: stroke});
    var line = new Style({stroke: stroke});
    var text = new Style({text: new Text({
      text: '', fill: fill, stroke: stroke
    })});
    var iconCache = {};
    function getIcon(iconName) {
      var icon = iconCache[iconName];
      if (!icon) {
        icon = new Style({image: new Icon({
          src: 'https://unpkg.com/@mapbox/maki@4.0.0/icons/' + iconName + '-15.svg',
          imgSize: [15, 15],
          crossOrigin: 'anonymous'
        })});
        iconCache[iconName] = icon;
      }
      return icon;
    }
    var styles = [];
    return function(feature, resolution) {
      if (!feature) { return; }
      var length = 0;
      var layer = feature.get('layer');
      var cls = feature.get('class');
      var type = feature.get('type');
      var scalerank = feature.get('scalerank');
      var labelrank = feature.get('labelrank');
      var adminLevel = feature.get('admin_level');
      var maritime = feature.get('maritime');
      var disputed = feature.get('disputed');
      var maki = feature.get('maki');
      var geom = feature.getGeometry().getType();
      if (layer == 'landuse' && cls == 'park') {
        fill.setColor('#d8e8c8');
        styles[length++] = polygon;
      } else if (layer == 'landuse' && cls == 'cemetery') {
        fill.setColor('#e0e4dd');
        styles[length++] = polygon;
      } else if (layer == 'landuse' && cls == 'hospital') {
        fill.setColor('#fde');
        styles[length++] = polygon;
      } else if (layer == 'landuse' && cls == 'school') {
        fill.setColor('#f0e8f8');
        styles[length++] = polygon;
      } else if (layer == 'landuse' && cls == 'wood') {
        fill.setColor('rgb(233,238,223)');
        styles[length++] = polygon;
      } else if (layer == 'waterway' &&
          cls != 'river' && cls != 'stream' && cls != 'canal') {
        stroke.setColor('#a0c8f0');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'waterway' && cls == 'river') {
        stroke.setColor('#a0c8f0');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'waterway' && (cls == 'stream' ||
          cls == 'canal')) {
        stroke.setColor('#a0c8f0');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'water') {
        fill.setColor('#a0c8f0');
        styles[length++] = polygon;
      } else if (layer == 'aeroway' && geom == MapDrawType.POLYGON) {
        fill.setColor('rgb(242,239,235)');
        styles[length++] = polygon;
      } else if (layer == 'aeroway' && geom == MapDrawType.LINE_STRING &&
          resolution <= 76.43702828517625) {
        stroke.setColor('#f0ede9');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'building') {
        fill.setColor('#f2eae2');
        stroke.setColor('#dfdbd7');
        stroke.setWidth(1);
        styles[length++] = strokedPolygon;
      } else if (layer == 'tunnel' && cls == 'motorway_link') {
        stroke.setColor('#e9ac77');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'tunnel' && cls == 'service') {
        stroke.setColor('#cfcdca');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'tunnel' &&
          (cls == 'street' || cls == 'street_limited')) {
        stroke.setColor('#cfcdca');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'tunnel' && cls == 'main' &&
          resolution <= 1222.99245256282) {
        stroke.setColor('#e9ac77');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'tunnel' && cls == 'motorway') {
        stroke.setColor('#e9ac77');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'tunnel' && cls == 'path') {
        stroke.setColor('#cba');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'tunnel' && cls == 'major_rail') {
        stroke.setColor('#bbb');
        stroke.setWidth(2);
        styles[length++] = line;
      } else if (layer == 'road' && cls == 'motorway_link') {
        stroke.setColor('#e9ac77');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'road' && (cls == 'street' ||
          cls == 'street_limited') && geom == MapDrawType.LINE_STRING) {
        stroke.setColor('#cfcdca');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'road' && cls == 'main' &&
          resolution <= 1222.99245256282) {
        stroke.setColor('#e9ac77');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'road' && cls == 'motorway' &&
          resolution <= 4891.96981025128) {
        stroke.setColor('#e9ac77');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'road' && cls == 'path') {
        stroke.setColor('#cba');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'road' && cls == 'major_rail') {
        stroke.setColor('#bbb');
        stroke.setWidth(2);
        styles[length++] = line;
      } else if (layer == 'bridge' && cls == 'motorway_link') {
        stroke.setColor('#e9ac77');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'bridge' && cls == 'motorway') {
        stroke.setColor('#e9ac77');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'bridge' && cls == 'service') {
        stroke.setColor('#cfcdca');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'bridge' &&
          (cls == 'street' || cls == 'street_limited')) {
        stroke.setColor('#cfcdca');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'bridge' && cls == 'main' &&
          resolution <= 1222.99245256282) {
        stroke.setColor('#e9ac77');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'bridge' && cls == 'path') {
        stroke.setColor('#cba');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'bridge' && cls == 'major_rail') {
        stroke.setColor('#bbb');
        stroke.setWidth(2);
        styles[length++] = line;
      } else if (layer == 'admin' && adminLevel >= 3 && maritime === 0) {
        stroke.setColor('#9e9cab');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'admin' && adminLevel == 2 &&
          disputed === 0 && maritime === 0) {
        stroke.setColor('#9e9cab');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'admin' && adminLevel == 2 &&
          disputed === 1 && maritime === 0) {
        stroke.setColor('#9e9cab');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'admin' && adminLevel >= 3 && maritime === 1) {
        stroke.setColor('#a0c8f0');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'admin' && adminLevel == 2 && maritime === 1) {
        stroke.setColor('#a0c8f0');
        stroke.setWidth(1);
        styles[length++] = line;
      } else if (layer == 'country_label' && scalerank === 1) {
        text.getText().setText(feature.get('name_en'));
        text.getText().setFont('bold 11px "Open Sans", "Arial Unicode MS"');
        fill.setColor('#334');
        stroke.setColor('rgba(255,255,255,0.8)');
        stroke.setWidth(2);
        styles[length++] = text;
      } else if (layer == 'country_label' && scalerank === 2 &&
          resolution <= 19567.87924100512) {
        text.getText().setText(feature.get('name_en'));
        text.getText().setFont('bold 10px "Open Sans", "Arial Unicode MS"');
        fill.setColor('#334');
        stroke.setColor('rgba(255,255,255,0.8)');
        stroke.setWidth(2);
        styles[length++] = text;
      } else if (layer == 'country_label' && scalerank === 3 &&
          resolution <= 9783.93962050256) {
        text.getText().setText(feature.get('name_en'));
        text.getText().setFont('bold 9px "Open Sans", "Arial Unicode MS"');
        fill.setColor('#334');
        stroke.setColor('rgba(255,255,255,0.8)');
        stroke.setWidth(2);
        styles[length++] = text;
      } else if (layer == 'country_label' && scalerank === 4 &&
          resolution <= 4891.96981025128) {
        text.getText().setText(feature.get('name_en'));
        text.getText().setFont('bold 8px "Open Sans", "Arial Unicode MS"');
        fill.setColor('#334');
        stroke.setColor('rgba(255,255,255,0.8)');
        stroke.setWidth(2);
        styles[length++] = text;
      } else if (layer == 'marine_label' && labelrank === 1 &&
          geom == MapDrawType.POINT) {
        text.getText().setText(feature.get('name_en'));
        text.getText().setFont(
            'italic 11px "Open Sans", "Arial Unicode MS"');
        fill.setColor('#74aee9');
        stroke.setColor('rgba(255,255,255,0.8)');
        stroke.setWidth(1);
        styles[length++] = text;
      } else if (layer == 'marine_label' && labelrank === 2 &&
          geom == MapDrawType.POINT) {
        text.getText().setText(feature.get('name_en'));
        text.getText().setFont(
            'italic 11px "Open Sans", "Arial Unicode MS"');
        fill.setColor('#74aee9');
        stroke.setColor('rgba(255,255,255,0.8)');
        stroke.setWidth(1);
        styles[length++] = text;
      } else if (layer == 'marine_label' && labelrank === 3 &&
          geom == MapDrawType.POINT) {
        text.getText().setText(feature.get('name_en'));
        text.getText().setFont(
            'italic 10px "Open Sans", "Arial Unicode MS"');
        fill.setColor('#74aee9');
        stroke.setColor('rgba(255,255,255,0.8)');
        stroke.setWidth(1);
        styles[length++] = text;
      } else if (layer == 'marine_label' && labelrank === 4 &&
          geom == MapDrawType.POINT) {
        text.getText().setText(feature.get('name_en'));
        text.getText().setFont(
            'italic 9px "Open Sans", "Arial Unicode MS"');
        fill.setColor('#74aee9');
        stroke.setColor('rgba(255,255,255,0.8)');
        stroke.setWidth(1);
        styles[length++] = text;
      } else if (layer == 'place_label' && type == 'city' &&
          resolution <= 1222.99245256282) {
        text.getText().setText(feature.get('name_en'));
        text.getText().setFont('11px "Open Sans", "Arial Unicode MS"');
        fill.setColor('#333');
        stroke.setColor('rgba(255,255,255,0.8)');
        stroke.setWidth(1);
        styles[length++] = text;
      } else if (layer == 'place_label' && type == 'town' &&
          resolution <= 305.748113140705) {
        text.getText().setText(feature.get('name_en'));
        text.getText().setFont('9px "Open Sans", "Arial Unicode MS"');
        fill.setColor('#333');
        stroke.setColor('rgba(255,255,255,0.8)');
        stroke.setWidth(1);
        styles[length++] = text;
      } else if (layer == 'place_label' && type == 'village' &&
          resolution <= 38.21851414258813) {
        text.getText().setText(feature.get('name_en'));
        text.getText().setFont('8px "Open Sans", "Arial Unicode MS"');
        fill.setColor('#333');
        stroke.setColor('rgba(255,255,255,0.8)');
        stroke.setWidth(1);
        styles[length++] = text;
      } else if (layer == 'place_label' &&
          resolution <= 19.109257071294063 && (type == 'hamlet' ||
          type == 'suburb' || type == 'neighbourhood')) {
        text.getText().setText(feature.get('name_en'));
        text.getText().setFont('bold 9px "Arial Narrow"');
        fill.setColor('#633');
        stroke.setColor('rgba(255,255,255,0.8)');
        stroke.setWidth(1);
        styles[length++] = text;
      } else if (layer == 'poi_label' && resolution <= 19.109257071294063 &&
          scalerank == 1 && maki !== 'marker') {
        styles[length++] = getIcon(maki);
      } else if (layer == 'poi_label' && resolution <= 9.554628535647032 &&
          scalerank == 2 && maki !== 'marker') {
        styles[length++] = getIcon(maki);
      } else if (layer == 'poi_label' && resolution <= 4.777314267823516 &&
          scalerank == 3 && maki !== 'marker') {
        styles[length++] = getIcon(maki);
      } else if (layer == 'poi_label' && resolution <= 2.388657133911758 &&
          scalerank == 4 && maki !== 'marker') {
        styles[length++] = getIcon(maki);
      } else if (layer == 'poi_label' && resolution <= 1.194328566955879 &&
          scalerank >= 5 && maki !== 'marker') {
        styles[length++] = getIcon(maki);
      }
      styles.length = length;
      if (styles.length == 0) {
        return createDefaultStyle(feature, resolution);
      }
      return styles;
    };
  }
  getStyleSourceNameOfVectorTiles(styleJson) {
    const keys = Object.keys(styleJson?.sources);
    let sourceName = keys.length > 0 ? keys[0] : null;
    if (sourceName == null) {
      const layers = styleJson?.layers;
      if (Array.isArray(layers) && layers.length > 0) {
        for (const layer of layers) {
          if (layer.hasOwnProperty('source')) {
            sourceName = layer.source;
            break;
          }
        }
      }
    }
    return sourceName;
  }

  getTile(mapView, isShow) {
    let tile;
    this.wmsState = { hasTile: false, hasEvent: false, finishLoad: false, tileCount: 0, hasTransparency: false, waitMapRender: null };
    
    let tileLoading = 0; let tileLoaded = 0;
    let crossOrigin = (mapView.crossOrigin ? mapView.crossOrigin: 'anonymous');
    let serverType = mapView.serverType;
    let tileSource;
    const tileSourceOption: any = {
      crossOrigin: crossOrigin,
      wrapDateLine: false, // not support 6.15.1
      wrapX: false,
      noWrap: true, // not support 6.15.1
    };

    const tileOption: any = {
      title: mapView.uiLabel, // not support 6.15.1
      visible: isShow,
    };

    if (mapView.serverType === 'tile') {
      tileSourceOption.url = mapView.url;
      tileSource = new OSM(tileSourceOption);
      tileOption.source = tileSource;

      tile = new TileLayer(tileOption);

    } else if (mapView.serverType === 'tilePBF') {
      tileSourceOption.format = new MVT({featureClass: Feature});
      const subDomainPatterns = /\{([a-z])-([a-z])\}/;
      const match = mapView.url.match(subDomainPatterns);
      tileSourceOption.url = mapView.url;

      if (match) {
        serverType = 'tilePBF-subdomain'
      } else {
        tileSourceOption.tileGrid = createXYZ({
          maxZoom: this.defaultMaxZoom
        });
      }
      

      tileSource = new VectorTileSource(tileSourceOption);

      tileOption.source = tileSource;
      tileOption.renderMode = 'vector';

      tile = new VectorTileLayer(tileOption);

      if (typeof mapView.styleLocationUrl === 'string') {
        if (this.isOnline === true) {
          fetch(mapView.styleLocationUrl)
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then(styleJson => {
            console.log('*** styleJson = ', styleJson);
            const sourceName = this.getStyleSourceNameOfVectorTiles(styleJson);
            console.log('*** sourceName = ', sourceName);
            if (typeof sourceName == 'string') {
              console.log('*** set style function ');
              tile.setStyle(stylefunction(tile, styleJson, sourceName));
            } else {
              console.log('*** create map box street style v6 ');
              tile.setStyle(this.createMapboxStreetsV6Style(Style, Fill, Stroke, Icon, Text));
            }
          })
          .catch((error) => {
            // if can't fetch online then find in cache
            caches.match(mapView.styleLocationUrl).then(response => {
              if (response) {
                console.log('Found in cache:', response);
              } else {
                console.log(`Not found in cache style url: ${mapView.styleLocationUrl}`);
              }
            }).catch(error => {
              console.error('Error check in cache style url: ${mapView.styleLocationUrl}', error);
              tile.setStyle(this.createMapboxStreetsV6Style(Style, Fill, Stroke, Icon, Text));
            });

          });
        } else {
          caches.match(mapView.styleLocationUrl).then(response => {
            if (response) {
              console.log('Found in cache:', response);
            } else {
              console.log(`Not found in cache style url: ${mapView.styleLocationUrl}`);
            }
          }).catch(error => {
            console.error('Error check in cache style url: ${mapView.styleLocationUrl}', error);
            tile.setStyle(this.createMapboxStreetsV6Style(Style, Fill, Stroke, Icon, Text));
          });
        }
        
      } else {
        tile.setStyle(this.createMapboxStreetsV6Style(Style, Fill, Stroke, Icon, Text));
      }
      
    } else {
      crossOrigin = 'anonymous';
      let tileGrid;
      if (mapView.extent) {
        tileGrid = new TileGrid({
          extent: mapView.extent,
          resolutions: mapView.resolutions,
          tileSize: mapView.tileSize
        });
      }
      tileSourceOption.url = mapView.url;
      tileSourceOption.params = mapView.params;
      tileSourceOption.projection = mapView.EPSG;
      tileSourceOption.serverType = mapView.serverType;
      tileSourceOption.tileGrid = tileGrid;
      tileSourceOption.crossOrigin = crossOrigin;

      tileSource = new TileWMS(tileSourceOption);

      tileOption.source = tileSource;
      tileOption.crossOrigin = crossOrigin;

      tile = new TileLayer(tileOption);
      if (mapView.extent) {
        tile.setExtent(mapView.extent);
      }
    }
    tileSource.set('originalTileUrl', mapView.url);
    tileSource.set('serverType', serverType);

    this.wmsState.hasTile = true;
    tileSource.on('tileloadstart', (event) => {
      // do some stuff start loading tiles...
      this.wmsState.hasEvent = true;
      tileLoading++;
      // console.log(`%c tile load start
      //   , currentZoom = ${this.view.getZoom()}
      //   , tileLoaded = ${tileLoaded}
      //   , tileLoading = ${tileLoading}`, 'color:blue');
    });
    tileSource.on('tileloadend', async (event) => {
      // do some stuff tiles were loaded...

      tileLoaded++;
      // console.log(`%c tile load end
      //   , currentZoom = ${this.view.getZoom()}
      //   , tileLoaded = ${tileLoaded}
      //   , tileLoading = ${tileLoading}`, 'color:blue');

      if (tileLoaded === tileLoading) {
        const currentZoom = Math.round(this.view.getZoom());
        // do stuff

        // console.log(`%c FINISH LOAD TILE for component: ${this.componentDefinition.name}
        //   \n\t, canvas = ${this.canvas}
        //   \n\t, loaded tiles = ${tileLoaded}/${tileLoading}
        //   \n\t, current zoom = ${currentZoom}
        //   \n\t, destinateZoom = ${this.destinateZoom}`, 'color:blue');

        // use for PBF tile
        if (this.destinateZoom !== currentZoom && this.isPBF === true) {
          this.view.setZoom(this.destinateZoom);
          // console.log(`%c FINISH SET ZOOM ${this.destinateZoom}`, 'color:blue');
          this.destinateZoom = currentZoom; // reset
        }

        this.wmsState.tileCount = tileLoaded;
        this.wmsState.finishLoad = true;
        

        if (this.mapType === MapComponentName.ADDRESS_MAP
          && typeof this.onTilesLoaded === 'function'
        ) {
          this.onTilesLoaded();
        }

        if (this.fromFitData) {
          this.checkMapEmpty(this.canvas);
        }
        if (this.afterLoadSelectedAssetFn && typeof this.afterLoadSelectedAssetFn === 'function') {
          this.afterLoadSelectedAssetFn();
        }
        if (this.canvas == null) {
          //console.log(`mapSize : canvas IS NULL, execute finding canvas`);
          this.findCanvas();
        }
        
      }
    });
    tileSource.on('tileloaderror', async (event) => {
      tileLoaded++;

      let currentZoom = Math.round(this.view.getZoom());

      console.log(`%c tile load error
        , currentZoom = ${currentZoom}
        , tileLoaded = ${tileLoaded}
        , tileLoading = ${tileLoading}`, 'color:purple');
    });

    return tile;
  }
  multiLayers(mapParameters) {
    this.mapViewLayers = [];
    const mapViews = mapParameters.mapViews;
    if (typeof mapViews !== 'undefined' && mapViews !== null) {

      let indexOfMapViewFirstShow = -1;
      for (let i = 0; i < mapViews.length; i++) {
        const mapView = mapViews[i];

        if (typeof mapView.uiLabel === 'string'
          && typeof mapParameters.showMapView === 'string'
          && mapParameters.showMapView === mapView.uiLabel
        ) {
          indexOfMapViewFirstShow = i;
          break;
        }
      }
      if (indexOfMapViewFirstShow === -1) {
        for (let i = 0; i < mapViews.length; i++) {
          const mapView = mapViews[i];
  
          if (mapView.isShow === true) {
            indexOfMapViewFirstShow = i;
            break;
          }
        }
      }
      if (indexOfMapViewFirstShow === -1) {
        indexOfMapViewFirstShow = 0;
      }

      
      for (let i = 0; i < mapViews.length; i++) {
        const mapView = mapViews[i];
        let isGroup = false;

        if (typeof mapView.EPSG !== 'undefined' && mapView.EPSG !== null) {
          proj4.defs(mapView.EPSG, sclProjectionConstant.EPSG[mapView.EPSG]);
        }

        let isVisible = true;
        if (mapView.visible !== null) { isVisible = mapView.visible; }
        if (isVisible === false) { continue; }// go to next element

        let isShow = false;
        if (indexOfMapViewFirstShow === i) {
          isShow = true;
        }

        if (i === 0) { this.currentUrl = mapView.url; }
        if (isShow === true) { this.currentUrl = mapView.url; }
        let tile = null;
        if (mapView.groupView) {
          const listLayers = [];
          for (let j = 0; j < mapView.groupView.length; j++) {
            const view = mapView.groupView[j];
            const member = this.getTile(view, isShow);
            if (isShow === true && j === 0) {
              this.currentUrl = view.url;
              this.currentTileSource = member.getSource();
            }
            listLayers.push(member);
          }
          const option = {
            visible: isShow,
            title: mapView.uiLabel, // not support 6.15.1
            layers: listLayers
          };
          tile = new Group(option);
          isGroup = true;
        } else {
          tile = this.getTile(mapView, isShow);
          if (isShow === true) {
            this.currentUrl = mapView.url;
            this.currentTileSource = tile.getSource();
          }
        }
        tile.set('isGroup', isGroup);
        this.mapViewLayers.push(tile);
      }

    }
  }

  setView(lng, lat, zoom, EPSG, minResolution, maxResolution, maxZoom) {
    lat = typeof lat !== 'undefined' ? lat : 0;
    lng = typeof lng !== 'undefined' ? lng : 0;
    zoom = typeof zoom !== 'undefined' ? zoom : 2;
    EPSG = typeof EPSG !== 'undefined' ? EPSG : SclMapConstantService.EPSG_3857;
    maxZoom = typeof maxZoom !== 'undefined' ? maxZoom : this.defaultMaxZoom; // 13924-2
    this.minResolution = minResolution;
    this.maxResolution = maxResolution;
    let view;
    if (EPSG !== SclMapConstantService.EPSG_3857) {
      const projection = sclProjectionConstant.EPSG;
      proj4.defs(EPSG, projection[EPSG]);
    }

    // the following gave an error that proj4 wasn't found in ol.proj. The register function
    // can be imported directly, as in
    // https://openlayers.org/en/latest/apidoc/module-ol_proj_proj4.html
    // if (proj.proj4 && proj.proj4.register) { proj.proj4.register(proj4); }
    register(proj4);
    const options: any = {
      projection: EPSG,
      center: proj.transform([lng, lat], SclMapConstantService.EPSG_4326, EPSG),
      zoom,
      // maxZoom: 12,//13885
      maxZoom,
      constrainResolution: true,
    }

    if (minResolution && maxResolution) {
      options.minResolution = minResolution;
      options.maxResolution = maxResolution;
    } else {
      options.minResolution = 0.0116670900008467;
      options.maxResolution = 2116.67090000847;
    }
    return new View(options);
  }

  createLayerSourceNormal(zIndex, pStyle, title, source, layerDisplayOnly) {
    // return new LayerVector({ title, source, zIndex, style: pStyle, isHeatMap: false, layerDisplayOnly });
    const options: any = {
      title, source, zIndex, style: pStyle, isHeatMap: false, layerDisplayOnly
    };
    return new LayerVector(options);
  }

  createLayerCluster(zIndex, pStyle, title, source, layerDisplayOnly, distance) {
    let d = 20; // default distance
    if (distance) { d = distance; }
    const clusterSource = new Cluster({
      distance: d,
      source: source
    });
    const options: any = {
      name: 'Cluster',
      source: clusterSource,
      // Cluster style
      style: pStyle,
      zIndex,
      isHeatMap: false,
      layerDisplayOnly,
      isCluster: true
    };
    const clusterLayer = new LayerVector(options);
    return clusterLayer;
  }

  createEmptyLayer(zIndex, pStyle, title, isHeatMap, options) {
    let newLayer;
    let src = new SourceVector();
    let layerDisplayOnly = false;
    if (options && options.layerDisplayOnly) { layerDisplayOnly = options.layerDisplayOnly; }
    if (isHeatMap) {
      let gradient = ['#00f', '#0ff', '#0f0', '#ff0', '#f00']; // default from ol
      if (options != null && typeof options.gradient !== 'undefined') { gradient = options.gradient; }
      let opacity = 1;
      if (options != null && typeof options.opacity !== 'undefined') { opacity = options.opacity; }
      let radius = 8; // default from ol
      if (options != null && typeof options.radius !== 'undefined') { radius = options.radius; }
      let blur = 15; // default from ol
      if (options != null && typeof options.blur !== 'undefined') { blur = options.blur; }
      let shadow = 250; // default from ol
      if (options != null && typeof options.shadow !== 'undefined') { shadow = options.shadow; }
      const optionsHeatmap: any = {
        source: src,
        zIndex,
        gradient,
        opacity,
        radius,
        blur,
        shadow,
        renderMode: 'image',
        title,
        isHeatMap,
        layerDisplayOnly
      };
      newLayer = new Heatmap(optionsHeatmap); // renderMode = image for better performance

    } else {
      if (options && options.type === 'cluster') {
        newLayer = this.createLayerCluster(zIndex, pStyle, title, src, layerDisplayOnly, options.clusterDistance);
      } else {
        newLayer = this.createLayerSourceNormal(zIndex, pStyle, title, src, layerDisplayOnly);
      }
      
    }
    // newLayer.set('isHeatMap', isHeatMap);
    return newLayer;
  }

  loadGeoJSON(layerIndex, geoJson) {
    const featuresJSON = (new GeoJSON())
      .readFeatures(geoJson,
        // {featureProjection: this.EPSG, dataProjection: SclMapConstantService.EPSG_4326}
      );
    this.layerAssets[layerIndex].getSource().addFeatures(featuresJSON);
    if (this.mapType === MapComponentName.SELECTED_ASSET
        && layerIndex !== this.layerIndexPrimary && layerIndex !== this.layerIndexSecondary) { // sc-selected-asset
        
        this.layerAssets[layerIndex].getSource().forEachFeature((feature) => {
          feature.setStyle(this.styleAsset(feature, layerIndex));
        });
        // console.log(`feature.len = ${this.layerAssets[layerIndex].getSource().getFeatures().length}`);
        // const self = this;
        // this.layerAssets[layerIndex].setStyle(function(feature){
        //   return self.styleAsset(feature, null);
        // });
    }
  }

  createLayerAsset(layerQuery, styleLayer, hasFilterQuery, styleFilter, hasSecondary, styleSecondary,
                   hasPrimary, stylePrimary, hasUserItems, styleSelected, hasAddressPoint, stylePoint) {
    // 1) UI controls (zoom, map selector. etc)
    // 2) Tooltips, other popup controls
    // 3) User added items : address pins, selections, etc
    // 4) Objects returned from "primaryAssetFilter"
    // 5) Objects returned from "secondaryAssetFilter"
    // 6) Objects returned from a "filter" query at the root of the component
    // 7) Items returned from the layers[0] entry
    // 8) items returned from layers[1] entry
    // 9) Items returned from layers[n] entry, where n is the last layer in the array
    // 10) Base map images
    let layerIndex = 0;
    if (this.layerAssets == null) { this.layerAssets = []; }
    if (layerQuery) {// 9,8,7
      for (let i = 0; i < layerQuery.length; i++) {
        if (layerQuery[i].query.indexOf('_layer') < 0) {
          continue;
        }
        layerIndex++;
        if (layerQuery[i].layer.type === 'cluster') {
          this.layerAssets.push(this.createEmptyLayer(layerIndex, styleLayer, 'layer' + layerIndex, layerQuery[i].isHeatMap,
          layerQuery[i].layer));
        } else {
          this.layerAssets.push(this.createEmptyLayer(layerIndex, null, 'layer' + layerIndex, layerQuery[i].isHeatMap,
          layerQuery[i].layer));
        }
      }
    }
    if (hasFilterQuery) {// 6
      layerIndex++;
      this.layerAssets.push(this.createEmptyLayer(layerIndex, styleLayer, 'filter', null, null));
      this.layerIndexFilter = layerIndex;
    }
    if (hasSecondary) {// 5
      layerIndex++;
      this.layerAssets.push(this.createEmptyLayer(layerIndex, styleSecondary, 'secondary', null, null));
      this.layerIndexSecondary = layerIndex;
    }
    if (hasPrimary) {// 4
      layerIndex++;
      this.layerAssets.push(this.createEmptyLayer(layerIndex, stylePrimary, 'primary', null, null));
      this.layerIndexPrimary = layerIndex;
    }

    if (hasUserItems) {// 3
      layerIndex++;
      this.layerAssets.push(this.createEmptyLayer(layerIndex, styleSelected, 'selectedItems', null, null));
      this.layerIndexUser = layerIndex;
    }
    if (hasAddressPoint) {// 3
      layerIndex++;
      this.layerAssets.push(this.createEmptyLayer(layerIndex, stylePoint, 'addressPoint', null, null));
      this.layerIndexAddress = layerIndex;
    }
    // tooltips
    this.layerIndexTooltips = layerIndex + 1;
    // controls button
    this.layerIndexControl = layerIndex + 2;
  }

  createLayers(initObj) {
    this.layerAssets = [];
    this.layerAssets.push(this.vector);

    if (this.mapType === MapComponentName.BOUNDARY) {// sc-boundary
      // this.createLayerAsset(initObj.layerAssets, this.styleBoundary.bind(this), true, null, false,
      //   null, false, null, false, null, true, this.styleBoundary.bind(this));
      this.createLayerAsset(initObj.layerAssets, this.styleAddress.bind(this), true, null,
       false, null, false, null, false, null, true, this.styleAddress.bind(this));
    } else if (this.mapType === MapComponentName.ADDRESS_MAP) {// sc-address-map
      // if (initObj.layerAssets) {
      //   this.createLayerAsset(initObj.layerAssets, this.styleAddress.bind(this), true, this.styleAddress.bind(this),
      //     false, null, false, null, true, this.styleSelectedFunc.bind(this), false, null);
      // } else { this.createLayerAsset([], this.styleAddress.bind(this), true, this.styleAddress.bind(this),
      //   false, null, false, null, true, this.styleSelectedFunc.bind(this), false, null); }
      if (initObj.layerAssets) {
        this.createLayerAsset(initObj.layerAssets, this.styleAddress.bind(this), true, null,
          false, null, false, null, true, null, false, null);
      } else { this.createLayerAsset([], null, true, null,
        false, null, false, null, true, null, false, null); }
    } else if (this.mapType === MapComponentName.STREET_ADDRESS) {// sc-street-address
      this.createLayerAsset(initObj.layerAssets, this.styleAddress.bind(this), true, null,
       false, null, false, null, false, null, true, this.styleStAddress.bind(this));
    } else if (this.mapType === MapComponentName.SELECTED_ASSET) {// sc-selected-asset
      // if (initObj.layerAssets) {
      //   this.createLayerAsset(initObj.layerAssets, this.styleAsset.bind(this), true, this.styleAsset.bind(this),
      //     true, this.styleSecondaryAssetFunc.bind(this), true, this.stylePrimaryAssetFunc.bind(this),
      //     false, null, true, this.styleAsset.bind(this));
      // } else { this.createLayerAsset([], this.styleAsset.bind(this), true, this.styleAsset.bind(this),
      //   true, this.styleSecondaryAssetFunc.bind(this), true, this.stylePrimaryAssetFunc.bind(this),
      //   false, null, true, this.styleAsset.bind(this)); }
      if (initObj.layerAssets) {
        this.createLayerAsset(initObj.layerAssets, null, true, null,
          true, null, true, null,
          false, null, true, null); // 15886: high CPU
      } else { this.createLayerAsset([], null, true, null,
        true, null, true, null,
        false, null, true, null); } // 15886: high CPU
    }

  }

  createHeatMap(layerIndex) {

    this.layerAssets[layerIndex].getSource().clear(); // reset

    const min = Math.min.apply(null, this.lstHeatWeight);
    const max = Math.max.apply(null, this.lstHeatWeight);

    for (let i = 0; i < this.heatDatas.length; i++) {
      let weight = (this.heatDatas[i].weight - min) / (max - min); // clamp weight 0..1

      if (isNaN(weight)) {
        if (max === min) { weight = 1; } else {  weight = 0; }
      }
      if (weight > 1) { weight = 1; }
      // created for owl range of data
      const coord = proj.transform(this.heatDatas[i].location, SclMapConstantService.EPSG_4326, this.EPSG) ;

      const lonLat = new Point(coord);

      const pf = new Feature({
        geometry: lonLat,
        weight // e.g. temperature
      });

      this.layerAssets[layerIndex].getSource().addFeature(pf);
    }

    this.heatDatas = []; // reset
    this.lstHeatWeight = []; // reset
  }

  drawGeoJSON(geoJson) {
    if (!geoJson || !geoJson.features) { return; }
    
    const textBoxJson = [];
    const dimensionJson = [];
    for (let i = geoJson.features.length - 1; i > -1; i--) {
      const feature = geoJson.features[i];
      const geometries = feature.geometries || [feature.geometry];
      if (feature.properties && Array.isArray(geometries)) {
        for (let g = 0; g < geometries.length; g++) {
          const geom = geometries[g];
          if (!geom || !geom.coordinates) { continue; }

          if (feature.properties.radius) {
            let center = null;
            if (geom.coordinates.length == 2 && geom.type == MapDrawType.POINT) {
    
              center = geom.coordinates;
              
            } else if (geom.coordinates.length == 1
                && geom.coordinates[0].length > 3
                && geom.type == MapDrawType.POLYGON) {
    
              center = sclUtilMap.calculateCircleCenterPoint(
                geom.coordinates[0][0],
                geom.coordinates[0][2]
              );
            }

            if (!center) {
              continue;
            }

            const radius = feature.properties.radius;
            const centerProj = proj.transform([center[0], center[1]], SclMapConstantService.EPSG_4326, this.EPSG);
            
    
            const circle = new CircleShape(centerProj, radius);
            const circleFeature = new Feature(circle);

            if (feature.properties) {
              let p = circleFeature.getProperties();
              if (!p) {
                p = {};
              }
              for(let key in feature.properties) {
                p[key] = feature.properties[key];
              }
              circleFeature.setProperties(p);
            }
            this.vector.getSource().addFeature(circleFeature);
    
            geoJson.features.splice(i, 1);

          } else if (typeof feature.properties.text === 'string'
            && feature.properties.text.trim().length > 0) {

            const cloned = cloneDeep(feature);
            cloned.geometry = geom;
            textBoxJson.push(cloned);

          } else if (typeof feature.properties.dimensionId === 'string'
            && feature.properties.dimensionId.trim().length > 0
            && geom.type === MapDrawType.LINE_STRING ) {

            const cloned = cloneDeep(feature);
            cloned.geometry = geom;
            dimensionJson.push(cloned);
          }
        }
      }
      
    }

    if (geoJson?.features?.length > 0) {
      const featuresJSON = (new GeoJSON())
      .readFeatures(geoJson,{featureProjection: this.EPSG, dataProjection: SclMapConstantService.EPSG_4326});
      this.vector.getSource().addFeatures(featuresJSON);
    }

    // console.log(`**** TOTAL FEATURE: ${this.vector.getSource()?.getFeatures()?.length}`);

    for (let i = 0; i < textBoxJson.length; i++) {
      const mapPoint: any = proj.transform(textBoxJson[i].geometry.coordinates
        , SclMapConstantService.EPSG_4326, this.EPSG);
      this.createTextBoxFeature(mapPoint, textBoxJson[i].geometry.coordinates
        , textBoxJson[i].properties.text, textBoxJson[i].properties.textId, false
        , textBoxJson[i].properties.font, textBoxJson[i].properties.fontSize);
    }
    for (let i = 0; i < dimensionJson.length; i++) {
      if (Array.isArray(dimensionJson[i].geometry.coordinates)
       && dimensionJson[i].geometry.coordinates.length > 0) {
        const dimensionId = dimensionJson[i].properties.dimensionId;
        const coorJson = dimensionJson[i].geometry.coordinates;
        const totalLength = sclUtilMap.totalLen(coorJson);
        const midDistance = totalLength / 2;
        const coord = sclUtilMap.getPointByDistance(coorJson, midDistance); // middle point
        let tooltipCoord: any = proj.transform(coord, SclMapConstantService.EPSG_4326, this.EPSG);
        const obj = this.createDimensionFeature(dimensionId, tooltipCoord, dimensionJson[i].properties.dimension
          , dimensionJson[i].properties.font, dimensionJson[i].properties.fontSize);
        const dimensionLabel = obj.dimensionLabel;
        const dimensionOverlay = obj.dimensionOverlay;
        let feature = null;
        
        this.vector.getSource().getFeatures().forEach((f) => {
          const p = f.getProperties();
          if (p.dimensionId === dimensionId) {
            feature = f;
            if (dimensionJson[i].properties.font) {
              p.font = dimensionJson[i].properties.font;
            }
            if (dimensionJson[i].properties.fontSize) {
              p.fontSize = dimensionJson[i].properties.fontSize;
            }
            f.setProperties(p);
            // console.log(`*** This feature with dimensionId = ${dimensionId} has already added to map`);
            return;
          }
        });
        if (feature) {
          feature.getGeometry().on('change', (evt) => {
            this.hasDocumentChangeValue = false;
            const geom = evt.target;
            let output;
            const p = feature.getProperties();
            if (geom instanceof LineString) {
              const length = getLength(geom); // meter
              output = sclUtilMap.formatDimension(length, this.dimensionsUnit
                , this.dimensionsPrecision);
              tooltipCoord = geom.getLastCoordinate();
              p.dimension = length;
              feature.setProperties(p);
            }
            dimensionLabel.innerHTML = output;
            dimensionOverlay.setPosition(tooltipCoord);
          });
        }
      } else {
        console.warn(`Invalid line's geometry data: ${JSON.stringify(dimensionJson[i])}`);
      }
      
    }

  }

  isOpenlayersCachedTile(zoom) {
    const center = this.view.getCenter();
    const tileGrid = this.currentTileSource.getTileGrid();
    const tileCoord = tileGrid.getTileCoordForCoordAndZ(center, zoom);
    const tile = this.currentTileSource.getTile(zoom, tileCoord[1], tileCoord[2]
      , 1, this.view.getProjection());

    if (tile.getState() === 2) {  // 2 = LOADED
      console.log('is Openlayers cached tile? -> Tile is already loaded from cache');
      return true;
    } else {
      console.log('is Openlayers cached tile? -> Tile needs to be loaded');
      return false;
    }
  }

  updateTileGridMaxZoom(newValue) {
    if (this.currentTileSource !== null && 
      this.currentTileSource.tileGrid !== null
    ) {
      this.currentTileSource.tileGrid.maxZoom = newValue;
      console.log(`**** max zoom = ${newValue}
        \n\t\t => tileGrid.maxZoom = ${this.currentTileSource.tileGrid.maxZoom}`);
    }
  }

  isExpired(cachedValue) {
    const currentTime = Date.now(); // miliseconds
    const isCacheValueInteger = isInteger(cachedValue?.expiration);

    const expired = (isCacheValueInteger === false ? true
     : (currentTime > cachedValue.expiration));

    // console.log(`**** is expired = ${expired}
    //   , isCacheValueInteger = ${isCacheValueInteger}
    // , \t\t cachedValue.expiration = ${cachedValue?.expiration}
    // , \t\t currentTime = ${currentTime}`);

    return expired;
  }

  async findSupportZoom(fromSource) {

    // find supported zoom
    this.destinateZoom = this.supportedZoom;
    // console.log(`**** BEGIN of find support zoom, this.supportedZoom = ${this.supportedZoom}
    //   , this.destinateZoom = ${this.destinateZoom}`);

    // find if this zoom level is cached
    const key = this.currentUrl.replace('{z}', this.destinateZoom);
    const obj = await this.keyValueStorageService.getItem(key);
    if (isInteger(obj?.value)) {
      if (this.isExpired(obj) === true) {
        await this.keyValueStorageService.removeItem(key);
      } else {
        this.supportedZoom = obj.value;
        this.updateTileGridMaxZoom(this.supportedZoom); // update max zoom
        
        // console.log(`**** END find support zoom, FROM CACHE, this.supportedZoom = ${this.supportedZoom}
        //   , this.destinateZoom = ${this.destinateZoom}`);
  
        return;

      }
    }

    // find supported zoom level from map tile provider
    this.supportedZoom = await this.fetchSupportZoomFromServer(fromSource, this.supportedZoom);
  }


  async init(initObj, keyName) {
    super.init(initObj, keyName);
    const currentUrl = window.location.href;
    // console.log(`**** currentUrl = ${currentUrl}`);
    if (currentUrl.indexOf('localhost') > -1) {
        this.isDebugRotate = true;
    } else {
        this.isDebugRotate = false;
    }
    this.EPSG = initObj.EPSG;
    if (this.EPSG === SclMapConstantService.EPSG_4326) { this.EPSG = SclMapConstantService.EPSG_3857; }
    if (this.EPSG !== SclMapConstantService.EPSG_4326) {
      const projection = sclProjectionConstant.EPSG;
      this.proj4s.defs(this.EPSG, projection[this.EPSG]);
    }
    this.divWrapper = initObj.divWrapper;
    this.selectedAssets = [];
    let savedGeoJSON;
    if (initObj.formatGeoJSON) {// use for sc-boundary
      savedGeoJSON = initObj.formatGeoJSON;
      if (initObj.formatGeoJSON.crs) {
        this.EPSG = initObj.formatGeoJSON.crs.properties.name;
      }
    }
    if (initObj.setupMapDone) { this.setupMapDone = initObj.setupMapDone; }
    // 13835
    this.source = new SourceVector();

    if (initObj.selectionStyle) { this.selectionStyle = initObj.selectionStyle; }
    if (initObj.primaryAssetSelection) { this.primaryAssetSelection = initObj.primaryAssetSelection; }
    if (initObj.secondaryAssetSelection) { this.secondaryAssetSelection = initObj.secondaryAssetSelection; }
    
    if (initObj.layersRedraw) { this.layersRedraw = initObj.layersRedraw; }
    
    if (initObj.mapId) { this.mapId = initObj.mapId; }
    
    if (initObj.onMapWheelScroll) { this.onMapWheelScroll = initObj.onMapWheelScroll; }
    this.checkMapEmptyLogError = initObj.checkMapEmptyLogError;

    this.defaultLat = (initObj.defaultLat ? initObj.defaultLat : -37.8);
    this.defaultLon = (initObj.defaultLon ? initObj.defaultLon : 144.9);
    this.defaultZoom = (initObj.defaultZoom ? initObj.defaultZoom : 10);
    if (initObj.watchDocFn) { this.watchDocFn = initObj.watchDocFn; }
    if (initObj.target) { this.mapTarget = initObj.target; }
    if (initObj.configService) { this.configService = initObj.configService; }
    if (initObj.initialZoomChange) { this.initialZoomChange = initObj.initialZoomChange; }
    if (isInteger(initObj.componentDefinition?.mapParameters?.zLevelExpiration)) {
      this.zLevelExpiration = initObj.componentDefinition.mapParameters.zLevelExpiration;
    }

    if (this.mapType === MapComponentName.BOUNDARY) {
      this.vector = this.createLayerSourceNormal(0, this.styleBoundary.bind(this), 'layerTile', this.source, false);
      
    } else if (this.mapType === MapComponentName.ADDRESS_MAP) {
      this.vector = this.createLayerSourceNormal(0, this.styleAddress.bind(this), 'layerTile', this.source, false);

    } else if (this.mapType === MapComponentName.STREET_ADDRESS) {
      this.vector = this.createLayerSourceNormal(0, this.styleStAddress.bind(this), 'layerTile', this.source, false);
    
    } else if (this.mapType === MapComponentName.SELECTED_ASSET) {
      this.addressImageAnchor = initObj.addressImageAnchor;
      this.primaryImageAnchor = initObj.primaryImageAnchor;
      this.secondaryImageAnchor = initObj.secondaryImageAnchor;
      this.vector = this.createLayerSourceNormal(0, this.styleAsset.bind(this), 'layerTile', this.source, false);
    
    }
    if (initObj.mapViewLayers) {
      this.mapViewLayers = initObj.mapViewLayers;
    }

    this.createLayers(initObj);

    const mZoom = (this.mapType === MapComponentName.ADDRESS_MAP ? 12 : 19); // 13885 && 13924-2
    this.view = this.setView(this.defaultLon, this.defaultLat, this.defaultZoom, this.EPSG,
      initObj.minResolution, initObj.maxResolution, mZoom); //
    this.supportedZoom = this.defaultZoom;
    this.destinateZoom = this.defaultZoom;

    // if (savedGeoJSON) {
    //   this.clampZoomFloor();
    // }

    if (this.currentTileSource !== null
      && this.currentTileSource.get('serverType') === 'tilePBF') {
      this.isPBF = true;
      await this.findSupportZoom('init component');
    }

    const controls = (initObj.controls) ? initObj.controls : [];
    this.map = this.initializeMap(initObj, controls, this.view  , null , this.mapViewLayers);
    

    // 13835 : zoom-in/out, i, fullscreen control
    const lst: any = document.querySelectorAll('.ol-overlaycontainer-stopevent'); // ol v4.6.5
    if (lst != null && lst.length > 0) {
      for (let i = 0; i < lst.length; i++) {
        lst[i].style.zIndex = this.layerIndexControl;
        const childs = lst[i].children;
        if (childs == null || childs.length === 0) { continue; }

        for (let j = 0; j < childs.length; j++) {
          childs[j].style.zIndex = this.layerIndexControl;
        }
      }
    }

    let numInFlightTiles = 0;
    this.map.getLayers().forEach(function(layer) {
      if (layer.type && layer.type === 'TILE') {
        const source = layer.getSource();
        if (source instanceof TileImage) {
          source.on('tileloadstart', function() {numInFlightTiles++; });
          source.on('tileloadend', function() {numInFlightTiles--; });
        }
      }

    });
    this.map.on('postrender', (evt) => {
      const frameState = evt.frameState;
      if (!frameState) {
        return;
      }
      

      let numHeldTiles = 0;
      const wanted = evt.frameState.wantedTiles;
      for (const layer in wanted) {
        if (wanted.hasOwnProperty(layer)) {
          numHeldTiles += Object.keys(wanted[layer]).length;
        }
      }

      const ready = numInFlightTiles === 0 && numHeldTiles === 0;
      if (this.map.get('ready') !== ready) {
        this.map.set('ready', ready);
        if (this.mapType === MapComponentName.SELECTED_ASSET && this.bounds) {
          if (this.hasClickButtonZoom === true) {
            this.bounds = null; // reset
            this.hasClickButtonZoom = false; // reset
            console.log(`%c **** map ready but has click button so don't execute FIT`, 'color:blue');
            return;
          }
          if (this.hasWheelScroll === true) {
            this.bounds = null; // reset
            this.hasWheelScroll = false; // reset
            console.log(`%c **** map ready but has wheel scroll so don't execute FIT`, 'color:blue');
            return;
          }
          console.log(`%c **** map ready, FIT`, 'color:blue');
          // console.log(`\t\t====> zoom BEFORE: ${this.view.getZoom()}, this.bounds`, this.bounds);

          this.view.fit(this.bounds);

          // console.log(`\t\t====> zoom AFTER: ${this.view.getZoom()}, this.bounds`, this.bounds);

          if (this.fitCoordCount === 1) {
            let currentZoom = Math.round(this.view.getZoom());
            currentZoom = currentZoom - 2;
            if (currentZoom < 0) { currentZoom = 1; }
            // console.log(`\t\t====> currentZoom: ${currentZoom}`);
            this.view.setZoom(currentZoom);
            // console.log(`\t\t====> zoom AFTER 2: ${this.view.getZoom()}`);
          }
          this.clampZoomFloor();
          // console.log('%c , map.ready = ' + ready + ', sc-selected-asset clamp Zoom' , 'color:blue' );
          this.bounds = null; // reset
        }
        if (ready) {
          if (this.canvas == null) { this.canvas = document.querySelector(initObj.mapId + ' canvas'); }
          this.checkMapEmpty(this.canvas);
          this.isMapReady = true;

          if (this.mapType === MapComponentName.BOUNDARY) {
            if (savedGeoJSON && this.actionType === MapDrawAction.NA) {
              // console.log(`**** checkAndDrawGeoJson savedGeoJSON = `, savedGeoJSON);
              this.checkAndDrawGeoJson(savedGeoJSON);
              this.clampZoomFloor();
            }
            this.interactionSelect();
            this.interactionModify();
            this.interactionTranslate();

            this.map.on('pointerup', (event) => {
              // console.log(`**** pointerup`);
              this.allowRotate = false;
              if (this.actionType === MapDrawAction.SELECT) {
                if (this.hasRotate) {
                  this.hasDocumentChangeValue = false;
                  this.hasRotate = false; // reset
                  this.removeDebugShapeBoundingBoxFeature();
  
                  if (typeof this.setDirtyFunction === 'function') {
                    this.setDirtyFunction();
                  }
                } else if (typeof this.textBoxOnMouseUp === 'function') {
                  this.textBoxOnMouseUp();
                  this.textBoxOnMouseUp = null; // reset
                }
                
              }
            });
          } else if ((this.mapType === MapComponentName.SELECTED_ASSET
             || this.mapType === MapComponentName.STREET_ADDRESS)
            && savedGeoJSON) {
            this.checkAndDrawGeoJson(savedGeoJSON);
            console.log(`%c *** DONE check and draw geo json`, 'color:red');
            this.clampZoomFloor();
          }
        }
      }

    });
    this.map.set('ready', false);
    function whenMapIsReady(callback) {
      if (this.map.get('ready')) {
        callback();
      } else {
        this.map.once('change:ready', whenMapIsReady.bind(null, callback));
      }
    }

    const lstCv = initObj.target.getElementsByTagName('canvas');
    if (lstCv && lstCv.length > 0) {
      const cv = lstCv[0];
      this.canvas = cv;
    }
    // console.log(`**** INIT MAP, comp.keyName = ${this.keyName}, componentDefinition.visible = ${this.componentDefinition?.visible}`);
    if (this.componentDefinition && (typeof this.componentDefinition.visible === 'undefined' ||
    this.componentDefinition.visible )) {
      let mapWidth = this.map.getSize()[0]; let mapHeight = this.map.getSize()[1];
      let wrapperWitdh = ( this.divWrapper ? this.divWrapper.offsetWidth : mapWidth );
      let wrapperHeight = ( this.divWrapper ? this.divWrapper.offsetHeight : mapHeight );

      this.findCanvas();

      setTimeout(() => {
        if (mapWidth === wrapperWitdh &&
          this.wmsState.hasTile &&
          this.wmsState.hasEvent === false &&
          this.wmsState.finishLoad === false) {
          // Changed Notification to logger message as errors are not helpful in most cases
          console.log('There has been an error returned from the mapping service tileloader - is the map visible?');
        }
      }, 1000);

      

    }



    // test test
    this.checkMapLoadDone = setInterval(() => {
      if (this.wmsState.finishLoad) {
        // console.log('%c checkMapLoadDone FINISH', 'color:blue');
        clearInterval(this.checkMapLoadDone);
        this.checkMapLoadDone = null;

        if (this.setupMapDone) { this.setupMapDone(); }

        if (this.setupTooltipUI && (typeof this.setupTooltipUI === 'function')) {
          this.setupTooltipUI();
          this.setupTooltipUI = null; // call one time when init map
        }

      }
    }, 500);
  }
  isElementInvisible(el) {
    const style = window.getComputedStyle(el);
    return (style.visibility === 'hidden' || style.opacity === '0');
  }
  isParentHidden(el) {
    while (el) {
        var style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
            return true;
        }
        el = el.parentElement;
    }
    return false;
  }
  findCanvasCounter = 0; // make sure checkCanvasIntervalId don't run forever if some exception cases happening ( total time out is 120sec )
  findCanvasLimit = 400;
  findCanvas() {
    this.mapControlStyle(this.elementCtrl, 180 * this.heightNum);
    if (this.checkCanvasIntervalId != null) {
      console.log(`mapSize: findCanvas func: don't execute new thread because the previous thread has not finished yet.
      \n previous thread: interval id: ${this.checkCanvasIntervalId}, ${this.findCanvasCounter}/${this.findCanvasLimit}`);
      return;
    }
    let mapWidth = this.map.getSize()[0]; let mapHeight = this.map.getSize()[1];
    let wrapperWitdh = ( this.divWrapper ? this.divWrapper.offsetWidth : mapWidth );
    let wrapperHeight = ( this.divWrapper ? this.divWrapper.offsetHeight : mapHeight );
    
    const timeout = 300; // milisecond

    this.checkCanvasIntervalId = setInterval(() => {
      const isHidden = this.isElementInvisible(this.mapTarget);
      const isParentHidden = this.isParentHidden(this.mapTarget);
      if (isHidden || isParentHidden) {
        clearInterval(this.checkCanvasIntervalId);
        this.checkCanvasIntervalId = null;
        this.findCanvasCounter = 0;
        clearInterval(this.setupMapControlInterval);
        this.setupMapControlInterval = null;
        this.setupMapControlIntervalCount = 0;

        //console.log(`mapSize: ${this.componentDefinition.name}, visible = ${this.componentDefinition.visible}
        //, stop finding canvas because the component or it's parent is hidden`);
        return;
      }
      if (!this.map || !this.map.getSize()) {
        return;
      }

      mapWidth = this.map.getSize()[0];
      mapHeight = this.map.getSize()[1];
      wrapperWitdh = ( this.divWrapper ? this.divWrapper.offsetWidth : mapWidth );
      wrapperHeight = ( this.divWrapper ? this.divWrapper.offsetHeight : mapHeight );
	  /*
      console.log(`mapSize: ${this.componentDefinition.name}, visible = ${this.componentDefinition.visible}
      , findCanvas func, interval id:${this.checkCanvasIntervalId}, ${this.findCanvasCounter}/${this.findCanvasLimit} of trying to find canvas, canvas: ${this.canvas}
      , map width: ${mapWidth}, map height: ${mapHeight}
      , map wrapper width: ${wrapperWitdh}, map wrapper height: ${wrapperHeight}
      , current timeout of interval: ${timeout}`);
	  */
      

      if (this.canvas) {
        const isCanvasNotDisplay = (this.canvas.style.display === 'none') ? true: false;
        const isMapWidthZero = (mapWidth <= 0) ? true: false;
        const isMapWidthNotEqual = (wrapperWitdh !== mapWidth) ? true: false;
        const isMapHeightZero = (mapHeight <= 0) ? true: false;
        const isMapHeightNotEqual = (wrapperHeight !== mapHeight) ? true: false;
        let sLogReason = ``;
        if (isCanvasNotDisplay) { sLogReason += `\n- canvas is not display`; } else { sLogReason += `\n- canvas is display`; }
        if (isMapHeightZero) { sLogReason += `\n- map width is zero`; } else { sLogReason += `\n- map width ${mapWidth}`; }
        if (isMapHeightZero) { sLogReason += `\n- map height is zero`; } else { sLogReason += `\n- map height ${mapHeight}`; }
        if (isMapWidthNotEqual) { sLogReason += `\n- map width[${mapWidth}] IS NOT EQUAL map's wrapper width[${wrapperWitdh}]`; } else { sLogReason += `\n- map width[${mapWidth}] IS EQUAL map's wrapper width[${wrapperWitdh}]`; }
        if (isMapHeightNotEqual) { sLogReason += `\n- map height[${mapHeight}] IS NOT EQUAL map's wrapper height[${wrapperHeight}]`; } else { sLogReason += `\n- map height[${mapHeight}] IS EQUAL map's wrapper height[${wrapperHeight}]`; }
        if (isCanvasNotDisplay || isMapWidthZero || isMapWidthNotEqual
          || isMapHeightZero || isMapHeightNotEqual) {
          //console.log(`mapSize: findCanvas func, interval id:${this.checkCanvasIntervalId}, the canvas is INVALID for one of the reasons below : ${sLogReason}`);
          this.show = true;
          this.canvas.style.display = 'block';
          this.map.setSize(wrapperWitdh, wrapperHeight);
          this.map.updateSize();
          if (this.watchDocFn === 'function') {
            const extent = this.vector.getSource().getExtent();
            if (extent != null && extent.length === 4 && isFinite(extent[0])
            && isFinite(extent[1]) && isFinite(extent[2]) && isFinite(extent[3])) {
              // console.log(`%c **** find canvas and has watchDocFn, FIT`, 'color:red');
              this.map.getView().fit(extent, [500, 500], { maxZoom: 15 });
              this.clampZoomFloor();
            }
          }
          if (this.mapType === MapComponentName.STREET_ADDRESS) {
            // console.log(`%c **** find canvas, FIT`, 'color:red');
            this.fit(this.configService, null, this.initialZoomChange, null); // test test
          }
          // console.log('map update size , width = ' + mapWidth + ', height = ' + mapHeight
          // + ', wrapperWitdh = ' + wrapperWitdh + ', wrapperHeight = ' + wrapperHeight);
        } else {
          //console.log(`mapSize: findCanvas func, interval id:${this.checkCanvasIntervalId}, the canvas is VALID for one of the reasons below : ${sLogReason}`);
          clearInterval(this.checkCanvasIntervalId);
          this.checkCanvasIntervalId = null; // reset
        }
        // if we have map control then put to map
        this.setupMapControl();

      } else {
        const lstCv1 = this.mapTarget.getElementsByTagName('canvas');
        //console.log(`mapSize: findCanvas func, interval id:${this.checkCanvasIntervalId}, Find ${lstCv1?.length} canvas`);
        if (lstCv1 && lstCv1.length > 0) {
          const cv = lstCv1[0];
          this.canvas = cv;
          //console.log(`mapSize: findCanvas func, interval id:${this.checkCanvasIntervalId}, ASSIGN canvas: ${this.canvas}`);
          // if we have map control then put to map
          this.setupMapControl();
        }
      }

      
      if (this.layersRedraw === true && this.testDiv !== null) {
        const offsetHeight = this.testDiv.offsetHeight;
        const top = mapHeight - offsetHeight;
        const css = {top: top + 'px', left: '10px', display: 'flex'};
        Object.assign(this.testDiv.style, css);
      }

      this.findCanvasCounter++;
      if (this.findCanvasCounter > this.findCanvasLimit) {
        //console.log(`%c mapSize: findCanvas func, interval id:${this.checkCanvasIntervalId}, out of limit check canvas`, 'color:blue');
        // console.log(`mapSize :  out of limit check canvas, componentDefinition.visible = ${this.componentDefinition.visible}`);
        clearInterval(this.checkCanvasIntervalId);
        this.checkCanvasIntervalId = null;
      }

    }, timeout);
    //console.log(`mapSize: findCanvas func, execute NEW finding canvas interval id: ${this.checkCanvasIntervalId} at ${this.findCanvasCounter}/${this.findCanvasLimit}`);
  }
  checkIsFullScreenSupport() {
    const body: any = document.body;
    return !!(
        body.webkitRequestFullscreen ||
        (body.mozRequestFullScreen) ||
        (body.msRequestFullscreen) ||
        (body.requestFullscreen)
    );
  }
  setupMapControlInterval = null;
  setupMapControlIntervalLimit = 10;
  setupMapControlIntervalCount = 0;
  setupMapControl() {
    if (this.setupMapControlInterval !== null) {
	  /*
      console.log(`mapSize: setupMapControl func, can't execute setup control button position because the previous thread hasn't done yet.
      \n previous thread at ${this.setupMapControlIntervalCount}/${this.setupMapControlIntervalLimit}, interval id: ${this.setupMapControlInterval}`);
	  */
      return;
    }
    this.setupMapControlInterval = setInterval(() => {
      // console.log(`**** setupMapControl, elementCtrl = ${this.elementCtrl}`);
      if (this.elementCtrl != null && this.canvas != null) {
        const css = (this.isBottom ? 'ol-custom-control-bottom': 'ol-custom-control');
        this.elementCtrl.classList.add(css); // must define this class in css of each component
        this.mapControlStyle(this.elementCtrl, this.mapDiv.offsetHeight);
        //console.log(`mapSize: setupMapControl func, setup control button position DONE at ${this.setupMapControlIntervalCount}/${this.setupMapControlIntervalLimit} of interval id: ${this.setupMapControlInterval}, mapHeight: ${this.mapDiv.offsetHeight}`);
        
        clearInterval(this.setupMapControlInterval); // reset
        this.setupMapControlInterval = null;
        this.setupMapControlIntervalCount = 0;
      } else {
        this.setupMapControlIntervalCount++;
        //console.log(`mapSize: setupMapControl func, interval id: ${this.setupMapControlInterval}, ${this.setupMapControlIntervalCount}/${this.setupMapControlIntervalLimit}, calling setup control button position...`);
        if (this.setupMapControlIntervalCount > this.setupMapControlIntervalLimit) {
          //console.log(`mapSize: setupMapControl func, interval id: ${this.setupMapControlInterval}, out of waiting to get canvas and the <_Drawing_Menu_>`);
          clearInterval(this.setupMapControlInterval); // reset
          this.setupMapControlInterval = null;
          this.setupMapControlIntervalCount = 0;
        }
      }
    }, 500);
    //console.log(`mapSize: setupMapControl func, interval id: ${this.setupMapControlInterval}, ${this.setupMapControlIntervalCount}/${this.setupMapControlIntervalLimit}, execute NEW setup control button position`);
  }
  mapControlStyle(elem, mapHeight) {
    if (this.elementCtrl == null) { return {}; }

    //console.log(`mapSize : mapControlStyle func: set position for button with mapHeight = ${mapHeight}`);
    if (this.isBottom) {
      elem.style.bottom = '10px';
      elem.style.display = 'flex';
    } else {
      const offsetHeight = this.elementCtrl.offsetHeight;
      const offsetWidth = this.elementCtrl.offsetWidth;
      let elemHeight = offsetHeight;
      if (offsetHeight < offsetWidth) { elemHeight = offsetWidth; }
      const top = (mapHeight / 2) - (elemHeight / 2);
      elem.style.top = top + 'px';
      // console.log('%c ****mapControlStyle, offsetHeight = ' + offsetHeight + ', offsetWidth = ' + offsetWidth
      //  + ', elemHeight = ' + elemHeight  + ', mapHeight = ' + mapHeight + ', top = ' + top
      //   + ', elem.style.top = ' + elem.style.top, 'color:blue');
      elem.style.setProperty ('display', 'grid', 'important');

    }
  }

  mapMoveEnd(moveEndFunc) {
    this.map.on('moveend', async() => {

      if (typeof moveEndFunc === 'function') {
        moveEndFunc();
      }
      
    });
  }

  createTextStyle(label, color, type) {

    const currentZoom = Math.round(this.view.getZoom());
    const displayZoom = (!label.labelDisplayZoom ? 9: (label.labelDisplayZoom > 17 ? 17 : label.labelDisplayZoom));
    const text = (currentZoom < displayZoom ? '': (label.labelText ? label.labelText: ''));
    const align = (label.labelTextAlign === '' || label.labelTextAlign == null) ? undefined : label.labelTextAlign;
    const baseLine = (label.labelTextBaseline === '' || label.labelTextBaseline == null) ? undefined : label.labelTextBaseline;
    const fillColor = (label.labelColor === '' || label.labelColor == null ) ? color : label.labelColor;
    const outlineColor = (label.labelOutlineColor === '' || label.labelOutlineColor == null) ? 'white' : label.labelOutlineColor;
    const outlineWidth = (label.labelOutlineWidth === '' || label.labelOutlineWidth == null
     || label.labelOutlineWidth === 0) ? 5 : label.labelOutlineWidth;
    const offsetX = (label.labelOffsetX === '' || label.labelOffsetX == null || label.labelOffsetX === 0) ? 0 : label.labelOffsetX;
    const offsetY = (label.labelOffsetY === '' || label.labelOffsetY == null || label.labelOffsetY === 0) ? 0 : label.labelOffsetY;
    let placement = (label.labelPlacement === '' || label.labelPlacement == null) ? 'point' : label.labelPlacement;
    const maxAngle = (label.labelMaxAngle === '' || label.labelMaxAngle == null) ? 90 : parseFloat(label.labelMaxAngle);
    const overflow = (typeof label.labelOverflow !== 'undefined' && label.labelOverflow !== null) ? label.labelOverflow : true;
    const rotationWithView = ( label.labelRotationWithView === true);
    const rotation = (label.labelRotation === '' || label.labelRotation == null) ? 0 : label.labelRotation;
    const padding = (label.labelPadding === '' || label.labelPadding == null) ? undefined : label.labelPadding;
    const weight = (label.labelFontWeight === '' || label.labelFontWeight == null) ? 'normal' : label.labelFontWeight;
    let size = (label.labelFontSize === '' || label.labelFontSize == null || label.labelFontSize === 0) ? '12px' : label.labelFontSize;
    const fontValue = (label.labelFont === '' || label.labelFont == null) ? 'Arial' : label.labelFont;

    if (typeof size === 'string') { size = size.replace('px', ''); }
    const font = weight + ' ' + size + 'px ' + fontValue;
    // rotation = rotation * 3.14 / 180;
    if (type === MapDrawType.POINT) { placement = 'point'; }
    const options: any = {
      textAlign: align,
      textBaseline: baseLine,
      font,
      text,
      fill: new Fill({color:  fillColor}),
      stroke: new Stroke({color: outlineColor, width: outlineWidth}),
      offsetX,
      offsetY,
      placement,
      maxAngle,
      overflow,
      rotationWithView, // not support 6.15.1
      rotation,
      padding
    };
    return new Text(options);
  }
  updateLabelByZoom() {
    const currentZoom = Math.round(this.view.getZoom());

    for (let i = 1; i < this.layerAssets.length; i++) {
        try {
            if (this.layerAssets[i].get('isCluster') || !this.layerAssets[i].getSource()) {
                continue;
            }
            this.layerAssets[i].getSource().getFeatures().forEach((fea) => {
                const lb = fea.get('label');
                if (lb) {
                  const displayZoom = (!lb.labelDisplayZoom ? 9: (lb.labelDisplayZoom > 17 ? 17 : lb.labelDisplayZoom));
                  const text = (currentZoom < displayZoom ? '': (lb.labelText ? lb.labelText: ''));
                  const style = fea.getStyle();
                  if (style && style.length > 0) {
                    const txt = style[0].getText();
                    if (txt) {
                      txt.setText(text);
                      fea.setStyle(style);
                    }
                  }
                }
            });
        } catch (err) {
            console.log(err);
        }
    }
  }
  getAnchor(icon, anchor) {
    if (( icon === SclMapConstantService.MAP_MARKER || icon === SclMapConstantService.MAP_PRIMARY_ASSET
      || icon === SclMapConstantService.MAP_SECONDARY_ASSET ) && anchor == null) {
      anchor = [0.5, 1.0]; // system defined Images
    }
    if (anchor == null) { anchor = [0.5, 0.5]; }// no image anchor & is override image

    return anchor;
  }
  updateLabel(feature, label) {
    const currentZoom = Math.round(this.view.getZoom());
    const displayZoom = (!label.labelDisplayZoom ? 9: (label.labelDisplayZoom > 17 ? 17 : label.labelDisplayZoom));
    const text = (currentZoom < displayZoom ? '': (label.labelText ? label.labelText: ''));
    if (this.mapType === MapComponentName.ADDRESS_MAP) { // sc-address-map
      const style = feature.getStyle();
      if (style && style.length > 0) {
        const txt = feature.getStyle()[0].getText();
        if (txt) { txt.setText(text); }
      }
    }
  }

  getCircleStyle(properties, label, t ) {
    let strokeColor = 'blue';
    let fillColor = olColor.asArray('blue'); // 'blue';
    let width = 2;
    if (properties.color) { strokeColor = properties.color; }
    if (properties.fillColor) { fillColor = properties.fillColor; }
    if (properties.lineWidth) {width = properties.lineWidth; }
    
    const stroke = new Stroke({
      color: strokeColor,
      width: width
    });
    if (properties && properties.fillColor && properties.fillOpacity) {
      let color = olColor.asArray(properties.fillColor);
      color = color.slice();
      color[3] = properties.fillOpacity;  // change the alpha of the color

      fillColor = color;
    }
    const fill = new Fill({
      color: fillColor
    });

    let image = new Circle({
      radius: properties.radius,
      fill: new Fill({
        color: fillColor// '#ffcc33'
      })
    });

    const style = new Style({
      image: image,
      fill: fill,
      stroke: stroke
    }); 

    // return style;
    const styles = [style];

    // label style
    if (label != null) {
      style.setText(this.createTextStyle(label, strokeColor, t));
    }
    return styles;
  }

  getPointStyle(color, icon, imageAnchor, geom, label, t, rotation, useCache) {
    let pointColor = 'green';
    if (color) {pointColor = color; }
    let image = null;
    if (icon) {
      let anchor = imageAnchor;
      anchor = this.getAnchor(icon, anchor);
      const angle = (rotation ? (rotation * (Math.PI/180)): 0);
      let imageSrc = icon;
      if (useCache) {
        const iconIndex = this.cacheImageUrls.indexOf(icon);
        if (iconIndex > -1) {
          imageSrc = this.cacheImageBase64s[iconIndex];
        }
      }
      image = new Icon(({
        src: imageSrc,
        anchor,
        rotation: angle
      }));
      
    } else {
      image = new Circle({
        radius: 7,
        fill: new Fill({
          color: pointColor// '#ffcc33'
        })
      });
    }
    const style = new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.2)'
      }),
      stroke: new Stroke({
        color: pointColor,
        width: 2
      }),
      image
    });
    // return style;
    const styles = [style];

    // label style
    if (label != null) {
      style.setText(this.createTextStyle(label, color, t));
    }
    return styles;
  }
  getPointStyleScale(feature, p, style) {
    let scaleX = 1;
    let scaleY = 1;
    if (p.scale) {
      if (Array.isArray(p.scale) && p.scale.length == 2) {
        // console.log('getPointStyleScale, scale is array, p.scale = ', p.scale);
        scaleX = p.scale[0];
        scaleY = p.scale[1];
      } else if (isNumber(p.scale)) {
        // console.log('getPointStyleScale, scale is number, p.scale = ' + p.scale);
        scaleX = p.scale;
        scaleY = p.scale;
      }
      
    }
    const iconIndex = this.cacheImageUrls.indexOf(p.icon);
    let img = p.icon;
    let strBase64 = '';
    if (iconIndex > -1) {
      img = this.cacheImages[iconIndex];
      strBase64 = this.cacheImageBase64s[iconIndex];
    }
    

    this.countGetImgSrc++;
    feature.set('size', [img.width, img.height]);
    let maxSize = img.width;
    if (img.width < img.height) { maxSize = img.height; }
    if (this.fitPadding < maxSize) {
      this.fitPadding = maxSize;
    }
    if (scaleX != 1 || scaleY != 1) {
      // console.log('image scale & flip');
      style.setImage(this.drawImage(img, scaleX, scaleY, style));
    }
  }

  getMultiPointStyle(properties) {
    let strokeColor = 'blue';
    let fillColor = olColor.asArray('blue');
    if (properties.color) { strokeColor = properties.color; }
    if (properties.fillColor) { fillColor = properties.fillColor; }
    let image: any = new Circle({
      radius: 7,
      fill: new Fill({
        color: fillColor// '#ffcc33'
      })
    });
    const styles = [];
    const style = new Style({
      image
    });
    if (properties.icon) {
      const iconIndex = this.cacheImageUrls.indexOf(properties.icon);
      let strBase64 = '';
      if (iconIndex > -1) {
        strBase64 = this.cacheImageBase64s[iconIndex];
      }

      let anchor = [0.5, 1];
      if (properties.anchor) { anchor = properties.anchor; }

      anchor = this.getAnchor(properties.icon, anchor);

      image = new Icon(
        ({
          src: strBase64,
          anchor
        })
      );
    }

    const stroke = new Stroke({
      color: strokeColor,
      width: 2
    });
    style.setStroke(stroke);
    if (properties && properties.fillColor) {
      let color = olColor.asArray(properties.fillColor);
      color = color.slice();
      if (properties.fillOpacity) {color[3] = properties.fillOpacity; }  // change the alpha of the color

      fillColor = color;
    }
    const fill = new Fill({
      color: fillColor
    });
    style.setFill(fill);
    styles.push(style);

    return styles;
  }

  getLineStyle(pColor, properties, geom, t) {
    let lineColor = 'blue';
    if (pColor) { lineColor = pColor; }
    const styles = [];
    const style = new Style({
      image: new Circle({
        radius: 7,
        fill: new Fill({
          color: '#ffcc33'
        })
      })
    });
    const stroke = new Stroke({
      color: lineColor,
      width: 2
    });
    if (properties) {
      if (properties.lineWidth) {stroke.setWidth(properties.lineWidth); }
      if (properties.lineDash) {stroke.setLineDash(properties.lineDash); }
      if (properties.lineCap) {stroke.setLineCap(properties.lineCap); }
    }
    style.setStroke(stroke);
    let fillColor = 'rgba(255, 255, 255, 0.2)';
    if (properties && properties.fillColor) {
      let color = olColor.asArray(properties.fillColor);
      color = color.slice();
      if (properties.fillOpacity) {color[3] = properties.fillOpacity; }  // change the alpha of the color
      fillColor = 'rgba(' + color[0] + ', ' + color[1] + ', ' + color[2] + ', ' + color[3] + ')';
    }
    const fill = new Fill({
      color: fillColor
    });
    style.setFill(fill);
    styles.push(style);

    // label style
    if (typeof properties.label !== undefined && properties.label != null ) {
      style.setText(this.createTextStyle(properties.label, pColor, t));
    }

    return styles;
  }

  lableStyle(geom, label, color, t) {
    return new Style({
      geometry: geom,
      text : this.createTextStyle( label, color, t)
    });
  }

  colorWithAlpha(color, alpha) {
    let c = olColor.asArray(color);
    c = c.slice();
    c[3] = alpha;
    return c;
  }

  // sc-boundary
  styleArrow(feature, p, colorByMode, isDrawing) {
    let styles = [];
    const color = (p.color ? p.color : colorByMode);
    const geom = feature.getGeometry();
    const type = geom.getType();
    let lineStrings = [];
    const isMulti = (type.indexOf('Multi') > -1);
    if (isMulti) {
      lineStrings = geom.getLineStrings();
    } else {
      lineStrings.push(geom);
    }
    for( let i = 0; i < lineStrings.length; i++) {
      const coords = lineStrings[i].getCoordinates();
      if ( (coords.length < 3 && isDrawing == true
         && p.arrowHead === MapDrawTypeSpecial.ARROW_AT_FIRST_POINT) 
       || (coords.length < 2 && isDrawing == false
        && p.arrowHead === MapDrawTypeSpecial.ARROW_AT_FIRST_POINT)) {
        continue;
      }
      let indexOfSegmentFinal = (p.arrowHead === MapDrawTypeSpecial.ARROW_AT_FIRST_POINT)
       ? 0 : (coords.length - 2);
      let index = 0;
      for (let j = 0; j < coords.length - 1; j++) {
        if (index == indexOfSegmentFinal) {
          const start = coords[j];
          const end = coords[j + 1];
          
          const dx = end[0] - start[0];
          const dy = end[1] - start[1];
          let rotation = Math.atan2(dy, dx);
          let pos = end;
          if (p.arrowHead === MapDrawTypeSpecial.ARROW_AT_FIRST_POINT) {
            rotation = Math.atan2(dy, dx) + Math.PI;
            pos = start;
          }
          // arrows
          styles.push(new Style({
            geometry: new Point(pos),
            image: new Icon({
              src: this.iconArrowWhiteBase64,
              anchor: [0.25, 0.5],
              rotateWithView: true,
              rotation: -rotation,
              color,
            }),
          }));
          break;
        }
        index++;
        // console.log(`**** index = ${index}`);
      }
    }
    return styles;
  }
  // sc-boundary
  styleBoundary(feature) {
    if (feature == null) { return; }// feature is null
    const type = feature.getGeometry().getType();
    const p = feature.getProperties();
    if ( (typeof p.text === 'string' && p.text.trim().length > 0 && type === MapDrawType.POINT) 
     || (this.currentTextBoxId === p.textId && typeof p.textId === 'string'
      && p.textId.trim().length > 0 && type === MapDrawType.POINT)) {
      return null;
    }
    let width = 2; // default
    if (p?.lineWidth) { width = p.lineWidth; }
    let lineDash = null;
    if (p?.lineDash) { lineDash = p.lineDash; }
    let color = p?.color;
    let styles = [];

    if (type?.indexOf('Multi') > -1) {
      color = (p.color ? p.color : this.multiColor);

      if (type === MapDrawType.MULTI_LINE_STRING && p.arrowHead) {
        const st = this.styleArrow(feature, p, this.multiColor, false)
        for (let i = 0; i < st.length; i++) {
          styles.push(st[i]);
        }
      }
      
    } else {
      color = (p.color ? p.color : this.singleColor);

      if (type === MapDrawType.LINE_STRING && p.arrowHead) {
        const st = this.styleArrow(feature, p, this.singleColor, false);
        for (let i = 0; i < st.length; i++) {
          styles.push(st[i]);
        }
      }
    }

    let icon = p?.icon;
    if (p?.point) { icon = p?.point; }
    if (icon) {
      let anchor = [0.5, 1]; // system defined image
      if (icon === SclMapConstantService.MAP_PRIMARY_ASSET || p.icon === SclMapConstantService.MAP_SECONDARY_ASSET
        || icon === SclMapConstantService.MAP_MARKER) {
        anchor = [0.5, 1]; // system defined image
      } else {
        anchor = [0.5, 0.5]; // no image anchor & is override image , sc-boundary has no anchor config entry
      }
      if (p?.point && p?.anchor) { anchor = p.anchor; }
      const iconStyle = new Icon(({
        src: icon,
        anchor
      }));
      styles.push(new Style({
        image: iconStyle
      }));
    } else {
      const st = new Style({
        fill: new Fill({
          color: this.colorWithAlpha(color, 0.3)// 'rgba(255, 255, 255, 0.2)'
        }),
        stroke: new Stroke({
          color,
          width,
          lineDash,
        }),
        image: new Circle({
          radius: 7,
          fill: new Fill({
            color
          })
        })
      });
      styles.push(st);
    }

    
    return styles;
  }

  // sc-address-map
  styleAddress(feature, resolution) {
    if (feature == null) { return; }// feature is null
    let p = feature.getProperties();
    if (p.features && p.features.length > 0) { // cluster style
      p = p.features[0].getProperties();
    }
    const fIndex = p.zIndex;

    const geom = feature.getGeometry();
    if (!geom) { return; }

    //
    let color = p.color;

    if (p.radius) {
      if (fIndex === this.layerIndexUser) {
        return this.getCircleSelectionStyle(p, this.selectionStyle);
      } else {
        return this.getCircleStyle(p, p.label, MapDrawType.POINT);
      }
      
    }
    
    //
    let t = geom.getType();
    if (!t) { return; }

    

    let style: any = [];
    if (t === MapDrawType.POINT) {
      
      // style = this.getPointStyle(color, p.icon, p.anchor, feature.getGeometry(), p.label, t);
      if (fIndex === this.layerIndexUser) {
        color = (this.selectionStyle && this.selectionStyle.selectionColor ? this.selectionStyle.selectionColor : p.color);
        style = this.getPointSelectionStyle(feature, color, this.selectionStyle, true);
      } else {
        style = this.getPointStyle(color, p.icon, p.anchor, feature.getGeometry(), p.label, t, p.rotation, true);
        if (p.icon && !p.size) {
          // console.log('getPointStyleScale');
          this.getPointStyleScale(feature, p, style[0]);
        } else {
          // console.log('getPointStyle');
          this.countGetImgSrc++;
        }
      }
      
      
    } else if (t === MapDrawType.MULTI_POINT) {
      if (fIndex === this.layerIndexUser) {
        color = (this.selectionStyle && this.selectionStyle.selectionColor ? this.selectionStyle.selectionColor : p.color);
        style = this.getMultiPointSelectedStyle(p, this.selectionStyle);
      } else {
        style = this.getMultiPointStyle(p);
      }
    } else {
      t = 'Line';
      if (fIndex === this.layerIndexUser) {
        color = (this.selectionStyle && this.selectionStyle.selectionColor ? this.selectionStyle.selectionColor : p.color);
        style = this.getLineSelectionStyle(p, color, this.selectionStyle);
      } else {
        style = this.getLineStyle(color, p, feature.getGeometry(), t);
      }
    }

    return style;
  }
  drawImage(img, scaleX, scaleY, oldStyle) {
    // console.log(`******** draw image *******`);
    const x = Math.round(img.width * scaleX);
    const y = Math.round(img.height * scaleY);
    const canvas = document.createElement('canvas');
    canvas.width = Math.abs(x);
    canvas.height = Math.abs(y);
    var ctx = canvas.getContext('2d');

    ctx.translate(Math.abs(Math.min(0,x)), Math.abs(Math.min(0,y)));
    ctx.scale(x<0 ? -1 : 1, y<0 ? -1 : 1);

    ctx.drawImage(img, 0, 0, Math.abs(x), Math.abs(y));
    const dataUrl = canvas.toDataURL();
    canvas.remove();

    const anchor = oldStyle.getImage().anchor_;
    const angle = oldStyle.getImage().getRotation();
    const iconOptions = {
      src: dataUrl,
      anchor,
      rotation: angle
    };
    return new Icon(iconOptions);
  }

  // sc-street-address
  styleStAddress(feature, resolution) {
    if (feature == null) { return; }// feature is null
    const option: any = {
      image: SclMapConstantService.MAP_MARKER,
      anchor: [0.5, 1]// system defined image
    };
    const styles = {
      Point: [new Style(option)],
      LineString: [new Style({
        stroke: new Stroke({
          color: 'blue',
          width: 2
        })
      })]
    };
    if (feature.getProperties() && feature.getGeometry().getType() === MapDrawType.POINT) {
      const type = feature.getProperties().typeFeature;
      if (type && type === 'tree') {
        console.log('TODO - determine what image should be displayed for the tree type');
        return new Style({
          //     image
        });
      }
      if (feature.getProperties().icon) {
        const style = new Style({
          image: new Icon(({
            src: feature.getProperties().icon,
            anchor: [0.5, 1]// system defined image
          }))
        });
        return style;
      }
    }

    return styles[feature.getGeometry().getType()];
  }
  

  // sc-selected-asset
  styleAsset(feature, resolution) {
    if (feature == null) { return; }// feature is null

    let p = feature.getProperties();
    if (p.features && p.features.length > 0) { // cluster style
      p = p.features[0].getProperties();
    }

    const color = p.color;
    const geom = feature.getGeometry();
    if (!geom) { return; }
    if (p.radius) {
      return this.getCircleStyle(p, p.label, MapDrawType.POINT);
    }
    let t = geom.getType();
    if (!t) { return; }
    if (t === MapDrawType.POINT ) {
      let anchor = p.anchor;

      const assetType = feature.get('assetType');
      const id = p.id;
      const zIndex = '';
      if (id === 'address') {
        // zIndex = 1000;
        anchor = this.addressImageAnchor;
      }
      if (assetType === MapSelectAssetType.PRIMARY) {
        // zIndex = 1000;
        if (p.primary) { anchor = p.primary.anchor;
        } else { anchor = this.primaryImageAnchor; }
      }
      if (assetType === MapSelectAssetType.SECONDARY) {
        // zIndex = 1000;
        if (p.secondary) { anchor = p.secondary.anchor;
        } else { anchor = this.secondaryImageAnchor; }
        
      }
      anchor = this.getAnchor(p.icon, anchor);

      const pointStyle = this.getPointStyle(color, p.icon, anchor, feature.getGeometry(), p.label, t, p.rotation, true);
      if (p.icon && !p.size) {
        this.getPointStyleScale(feature, p, pointStyle[0]);
      }
      feature.set('feaStyle', pointStyle);
      return pointStyle;
    } else if (t === MapDrawType.MULTI_POINT) {
      return this.getMultiPointStyle(p);
    } else {
      t = 'Line';
      const lineStyle = this.getLineStyle(color, p, feature.getGeometry(), t);
      return lineStyle;
    }
    return null;
  }
  stylePinAddress(feature) {
    if (feature == null) { return; }// feature is null

    let p = feature.getProperties();
    if (p.features && p.features.length > 0) { // cluster style
      p = p.features[0].getProperties();
    }
    const color = p.color;
    const geom = feature.getGeometry();
    if (!geom) { return; }
    if (p.radius) {
      return this.getCircleStyle(p, p.label, MapDrawType.POINT);
    }
    let t = geom.getType();
    if (!t) { return null; }
    if (t === MapDrawType.POINT ) {
      let anchor = p.anchor;

      const assetType = feature.get('assetType');
      const id = p.id;
      const zIndex = '';
      if (id === 'address') {
        // zIndex = 1000;
        anchor = this.addressImageAnchor;
      }
      if (assetType === MapSelectAssetType.PRIMARY) {
        // zIndex = 1000;
        if (p.primary) { anchor = p.primary.anchor;
        } else { anchor = this.primaryImageAnchor; }
      }
      if (assetType === MapSelectAssetType.SECONDARY) {
        // zIndex = 1000;
        if (p.secondary) { anchor = p.secondary.anchor;
        } else { anchor = this.secondaryImageAnchor; }
        
      }
      anchor = this.getAnchor(p.icon, anchor);

      const pointStyle = this.getPointStyle(color, p.icon, anchor, feature.getGeometry(), p.label, t, p.rotation, false);
      if (p.icon && !p.size) {
        this.getPointStyleScale(feature, p, pointStyle[0]);
      }
      feature.set('feaStyle', pointStyle);
      return pointStyle;
    }
    return null;
  }
  

  // use for primary selected asset
  stylePrimaryAssetFunc(feature, resolution) {
    return this.styleSelectedAssetFunc(feature, this.primaryAssetSelection, true);
  }

  // use for secondary selected asset
  styleSecondaryAssetFunc(feature, resolution) {
    return this.styleSelectedAssetFunc(feature, this.secondaryAssetSelection, false);
  }

  styleSelectedAssetFunc(feature, assetSelection, isPrimary) {
    if (feature == null) { return; }
    let style: any = [];
    const p = feature.getProperties();
    if (isPrimary) {
      if (p.primary) {
        assetSelection.selectionImageFileNo = p.primary.image;
        assetSelection.selectionImageAnchor = p.primary.anchor;
        assetSelection.selectionImageRotation = p.primary.rotation;
        assetSelection.selectionColor = p.primary.color;
        assetSelection.selectionFill = p.primary.fillColor;
        assetSelection.selectionFillOpacity = p.primary.fillOpacity;
        assetSelection.selectionLineCap = p.primary.lineCap;
        assetSelection.selectionLineDash = p.primary.lineDash;
        assetSelection.selectionLineWidth = p.primary.lineWidth;
      } else if (!assetSelection.selectionImageFileNo) {
        assetSelection.selectionImageFileNo = SclMapConstantService.MAP_PRIMARY_ASSET;
      }
    } else {
      if (p.secondary) {
        assetSelection.selectionImageFileNo = p.secondary.image;
        assetSelection.selectionImageAnchor = p.secondary.anchor;
        assetSelection.selectionImageRotation = p.secondary.rotation;
        assetSelection.selectionColor = p.secondary.color;
        assetSelection.selectionFill = p.secondary.fillColor;
        assetSelection.selectionFillOpacity = p.secondary.fillOpacity;
        assetSelection.selectionLineCap = p.secondary.lineCap;
        assetSelection.selectionLineDash = p.secondary.lineDash;
        assetSelection.selectionLineWidth = p.secondary.lineWidth;
      } else if (!assetSelection.selectionImageFileNo) {
        assetSelection.selectionImageFileNo = SclMapConstantService.MAP_SECONDARY_ASSET;
      }
    }
    assetSelection = sclUtilMap.checkStyleValue(assetSelection, isPrimary);

    const geom = feature.getGeometry();
    if (!geom) { return; }
    let t = geom.getType();
    
    if (p && p.layerDisplayOnly) {
      if (t === MapDrawType.POINT) {
        if (p.radius) {
          style = this.getCircleStyle(p, p.label, t);
        } else {
          style = this.getPointStyle(p.color, p.icon, p.anchor, null, null, null, p.rotation, false);
        }
        
        feature.set('feaStyle', style);
      } else {
        style = this.getLineStyle(p.color, p, null, null);
      }
      return style;
    }
    let color = (assetSelection && assetSelection.selectionColor ? assetSelection.selectionColor : p.color) ;
    if (t === MapDrawType.POINT) {
      if (p.radius) {
        style = this.getCircleSelectionStyle(p, assetSelection);
      } else {
        style = this.getPointSelectionStyle(feature, color, assetSelection, false);  
      }
      feature.set('feaStyle', style);
    } else if (t === MapDrawType.MULTI_POINT) {
      style.push(this.getMultiPointSelectedStyle(p, assetSelection));
    } else {
      style.push(this.getLineSelectionStyle(p, color, assetSelection));
    }
    if (typeof p.label !== undefined && p.label != null) {
      color = p.color;
      style.push(this.lableStyle(geom, p.label, color, t));
    }
    
    return style;
  }

  getCircleSelectionStyle(properties, selection) {

    let strokeColor = olColor.asArray('#ffcc33');
    let fillColor = olColor.asArray('#ffcc33');
    if (properties.color) { strokeColor = properties.color; }
    if (properties.fillColor) { fillColor = properties.fillColor;
    } else { fillColor = strokeColor; }
    if (selection) {
      if (selection.selectionColor) { strokeColor = selection.selectionColor; }
      if (selection.selectionFill) {
        let color1 = olColor.asArray(selection.selectionFill);
        color1 = color1.slice();
        if (selection.selectionFillOpacity) {color1[3] = selection.selectionFillOpacity; }
        fillColor = color1;
      }
    }
    let image: any = new Circle({
      radius: properties.radius,
      fill: new Fill({
        color: fillColor
      })
    });
    const style = new Style({
      image
    });
    let icon = properties.icon;
    if (selection && selection.selectionImageFileNo) { icon = selection.selectionImageFileNo; }
    if (icon) {
      let anchor = properties.anchor;
      let rotation = 0;
      if (selection) {
        if (selection.selectionImageAnchor) { anchor = selection.selectionImageAnchor; }
        if (selection.selectionImageRotation) { rotation = selection.selectionImageRotation; }
      } else {
        if (icon === SclMapConstantService.MAP_PRIMARY_ASSET) {
          anchor = this.primaryImageAnchor;
        } else if (icon === SclMapConstantService.MAP_SECONDARY_ASSET) {
          anchor = this.secondaryImageAnchor;
        }
      }
      if (anchor === undefined || anchor === null) {
        if (icon === SclMapConstantService.MAP_PRIMARY_ASSET || icon === SclMapConstantService.MAP_SECONDARY_ASSET) {
          anchor = [0.5, 1]; // system defined image
        } else {
          if (typeof properties.assetType !== 'undefined' && properties.assetType === MapSelectAssetType.PRIMARY) {
            if (this.primaryImageAnchor !== undefined) { anchor = this.primaryImageAnchor; }
            if (properties.primary && properties.primary.anchor) { anchor = properties.primary.anchor; }
          } else if (typeof properties.assetType !== 'undefined' && properties.assetType === MapSelectAssetType.SECONDARY) {
            if (this.secondaryImageAnchor !== undefined) { anchor = this.secondaryImageAnchor; }
            if (properties.secondary && properties.secondary.anchor) { anchor = properties.secondary.anchor; }
          } else {
            anchor = [0.5, 0.5];
          } // no image anchor & is override image
        }
      }
      const angle = (rotation ? (rotation * (Math.PI/180)): 0);
      const iconIndex = this.cacheImageUrls.indexOf(icon);
      if (iconIndex > -1) {
        const strBase64 = this.cacheImageBase64s[iconIndex];
        image = new Icon(
          ({
            src: strBase64,
            anchor,
            rotation: angle
          })
        );
      }
      
    }

    const stroke = new Stroke({
      color: strokeColor,
      width: 2
    });
    style.setStroke(stroke);
    if (properties && properties.fillColor) {
      let color = olColor.asArray(properties.fillColor);
      color = color.slice();
      if (properties.fillOpacity) { color[3] = properties.fillOpacity; }  // change the alpha of the color
      fillColor = color;
    }
    if (selection & selection.selectionFill) {
      let color1 = olColor.asArray(selection.selectionFill);
      color1 = color1.slice();
      if (selection.selectionFillOpacity) {color1[3] = selection.selectionFillOpacity; }
      fillColor = color1;
    }
    const fill = new Fill({
      color: fillColor
    });
    style.setFill(fill);

    return style;
  }

  // copy from sclStyleUtil.getPointSelectionStyle
  getPointSelectionStyle(feature, color, selection, useCache) {

    const p = feature.getProperties();
    let icon = p.icon;
    let anchor = p.anchor;
    let rotation = 0;
    if (selection) {
      if (selection.selectionImageFileNo) {
        icon = selection.selectionImageFileNo; // 15783 // '/api/getFile/' + selection.selectionImageFileNo;
      }
      if (selection.selectionImageAnchor) {
        anchor = selection.selectionImageAnchor;
      }
      if (selection.selectionImageRotation) {
        rotation = selection.selectionImageRotation;
      }
    }
    if (icon === SclMapConstantService.MAP_PRIMARY_ASSET) { anchor = this.primaryImageAnchor;
    } else if (icon === SclMapConstantService.MAP_SECONDARY_ASSET) { anchor = this.secondaryImageAnchor;
    } else if (icon === SclMapConstantService.MAP_MARKER) { anchor = [0.5, 1]; }// system defined image

    if (anchor === undefined || anchor === null) {
      if (icon === SclMapConstantService.MAP_PRIMARY_ASSET || icon === SclMapConstantService.MAP_SECONDARY_ASSET
        || icon === SclMapConstantService.MAP_MARKER) {
        anchor = [0.5, 1]; // system defined image
      } else {
        if (typeof p.assetType !== 'undefined' && p.assetType === MapSelectAssetType.PRIMARY) {
          if (this.primaryImageAnchor !== undefined) { anchor = this.primaryImageAnchor; }
          if (p.primary) { anchor = p.primary.anchor; }
        } else if (typeof p.assetType !== 'undefined' && p.assetType === MapSelectAssetType.SECONDARY) {
          if (this.secondaryImageAnchor !== undefined) { anchor = this.secondaryImageAnchor; }
          if (p.secondary) { anchor = p.secondary.anchor; }
        } else { anchor = [0.5, 0.5]; }// no image anchor & is override image
      }
    }
    const angle = (rotation ? (rotation * (Math.PI/180)): 0);
    let iconStyle = null;
    let strBase64 = null;
    if (icon) {
      strBase64 = icon;
      if (useCache) {
        const iconIndex = this.cacheImageUrls.indexOf(icon);
        if (iconIndex > -1) {
          strBase64 = this.cacheImageBase64s[iconIndex];
        }
      }
      iconStyle = new Icon(({
        src: strBase64,
        anchor,
        rotation: angle
      }));
    } else {
      iconStyle = new Circle({
        radius: 7,
        fill: new Fill({
          color: color // '#ffcc33'
        })
      });
    }
    if (selection ) {
      if (selection.selectionImageAnchor ) {
        iconStyle = new Icon(({
          src: strBase64,
          anchor,
          rotation: angle
        }));
      }
      
    }
    const stylePoint = [new Style({
      image: iconStyle,
      // zIndex: 10
    })];
    return stylePoint;
  }

  // copy from sclStyleUtil.getLineSelectionStyle
  getLineSelectionStyle(properties, color, selection) {
    if (properties.type === MapDrawType.MULTI_POINT) {
      const multiPointStyle =  this.getMultiPointSelectedStyle(properties, selection);

      return multiPointStyle;
    } else {
      if (selection && selection.selectionColor) { color = selection.selectionColor; }
      const lineStyle =  this.getLineStyle2(color, properties);
      if (selection) {
        if (selection.selectionColor) {
          lineStyle.getStroke().setColor(selection.selectionColor);
        }
        if (selection.selectionLineDash) {
          if (Array.isArray(selection.selectionLineDash)) { lineStyle.getStroke().setLineDash(selection.selectionLineDash); }
        }
        if (selection.selectionLineWidth) {lineStyle.getStroke().setWidth(selection.selectionLineWidth); }
        if (selection.selectionLineCap) {lineStyle.getStroke().setLineCap(selection.selectionLineCap); }
        if (selection.selectionFill) {
          let color1 = olColor.asArray(selection.selectionFill);
          color1 = color1.slice();
          if (selection.selectionFillOpacity) {color1[3] = selection.selectionFillOpacity; }
          lineStyle.getFill().setColor(color1);
        }
      }
      return lineStyle;
    }
  }

  getLineStyle2(color, properties) {
    let lineColor = 'blue';
    if (color) { lineColor = color; }

    const style = new Style({
      image: new Circle({
        radius: 7,
        fill: new Fill({
          color: '#ffcc33'
        })
      })
    });

    const stroke = new Stroke({
      color: lineColor,
      width: 2
    });
    if (properties) {
      if (properties.lineWidth) {stroke.setWidth(properties.lineWidth); }
      if (properties.lineDash) {stroke.setLineDash(properties.lineDash); }
      if (properties.lineCap) {stroke.setLineCap(properties.lineCap); }
    }
    style.setStroke(stroke);
    let fillColor = olColor.asArray('rgba(255, 255, 255, 0.2)');
    if (properties && properties.fillColor) {
      let color1 = olColor.asArray(properties.fillColor);
      color1 = color1.slice();
      if (properties.fillOpacity) {color1[3] = properties.fillOpacity; }  // change the alpha of the color
      fillColor = color1;
    }
    const fill = new Fill({
      color: fillColor
    });
    style.setFill(fill);
    return style;
  }

  getMultiPointSelectedStyle(properties, selection) {
    let strokeColor = olColor.asArray('#ffcc33');
    let fillColor = olColor.asArray('#ffcc33');
    if (properties.color) { strokeColor = properties.color; }
    if (properties.fillColor) { fillColor = properties.fillColor;
    } else { fillColor = strokeColor; }
    if (selection) {
      if (selection.selectionColor) { strokeColor = selection.selectionColor; }
      if (selection.selectionFill) {
        let color1 = olColor.asArray(selection.selectionFill);
        color1 = color1.slice();
        if (selection.selectionFillOpacity) {color1[3] = selection.selectionFillOpacity; }
        fillColor = color1;
      }
    }
    let image: any = new Circle({
      radius: 7,
      fill: new Fill({
        color: fillColor
      })
    });
    const style = new Style({
      image
    });
    let icon = properties.icon;
    if (selection && selection.selectionImageFileNo) { icon = selection.selectionImageFileNo; }
    if (icon) {
      let anchor = properties.anchor;
      let rotation = 0;
      if (selection) {
        if (selection.selectionImageAnchor) { anchor = selection.selectionImageAnchor; }
        if (selection.selectionImageRotation) { rotation = selection.selectionImageRotation; }
      } else {
        if (icon === SclMapConstantService.MAP_PRIMARY_ASSET) {
          anchor = this.primaryImageAnchor;
        } else if (icon === SclMapConstantService.MAP_SECONDARY_ASSET) {
          anchor = this.secondaryImageAnchor;
        }
      }
      if (anchor === undefined || anchor === null) {
        if (icon === SclMapConstantService.MAP_PRIMARY_ASSET || icon === SclMapConstantService.MAP_SECONDARY_ASSET) {
          anchor = [0.5, 1]; // system defined image
        } else {
          if (typeof properties.assetType !== 'undefined' && properties.assetType === MapSelectAssetType.PRIMARY) {
            if (this.primaryImageAnchor !== undefined) { anchor = this.primaryImageAnchor; }
            if (properties.primary && properties.primary.anchor) { anchor = properties.primary.anchor; }
          } else if (typeof properties.assetType !== 'undefined' && properties.assetType === MapSelectAssetType.SECONDARY) {
            if (this.secondaryImageAnchor !== undefined) { anchor = this.secondaryImageAnchor; }
            if (properties.secondary && properties.secondary.anchor) { anchor = properties.secondary.anchor; }
          } else {
            anchor = [0.5, 0.5];
          } // no image anchor & is override image
        }
      }
      const angle = (rotation ? (rotation * (Math.PI/180)): 0);
      image = new Icon(
        ({
          src: icon,
          anchor,
          rotation: angle
        })
      );
    }

    const stroke = new Stroke({
      color: strokeColor,
      width: 2
    });
    style.setStroke(stroke);
    if (properties && properties.fillColor) {
      let color = olColor.asArray(properties.fillColor);
      color = color.slice();
      if (properties.fillOpacity) { color[3] = properties.fillOpacity; }  // change the alpha of the color
      fillColor = color;
    }
    if (selection & selection.selectionFill) {
      let color1 = olColor.asArray(selection.selectionFill);
      color1 = color1.slice();
      if (selection.selectionFillOpacity) {color1[3] = selection.selectionFillOpacity; }
      fillColor = color1;
    }
    const fill = new Fill({
      color: fillColor
    });
    style.setFill(fill);

    return style;
  }

  styleSelectedFunc(feature, resolution) {
    if (feature == null) { return; }
    let style = [];
    const p = feature.getProperties();
    const geom = feature.getGeometry();
    let t = geom.getType();
    let color = (this.selectionStyle && this.selectionStyle.selectionColor ? this.selectionStyle.selectionColor : p.color) ;
    if (geom && t === MapDrawType.POINT) {
      t = MapDrawType.POINT;
      style = this.getPointSelectionStyle(feature, color, this.selectionStyle, false);
    } else {
      style.push(this.getLineSelectionStyle(p, color, this.selectionStyle));
    }
    if (typeof p.label !== undefined && p.label != null) {
      color = p.color;
      style.push(this.lableStyle(geom, p.label, color, t));
    }
    return style;
  }

  async checkZoomSupport(fromSource, tileUrl, nextZoom) {
    return new Promise(async (resolve, reject) => {
      if (this.currentTileSource == null) {
        resolve(false);
        return;
      }
      
      const center = this.view.getCenter();
      const tileGrid = this.currentTileSource.getTileGrid();
      const tileCoord = tileGrid.getTileCoordForCoordAndZ(center, nextZoom);
      const [z, x, y] = tileCoord;

      if (Number.isInteger(z) && Number.isInteger(x) && Number.isInteger(y)) {
        const url = tileUrl.replace('{z}', z.toString())
                         .replace('{x}', x.toString())
                         .replace('{y}', y.toString());

        if (this.isOnline === true) {
          try {
            const response = await fetch(url, { method: 'HEAD' });
            // console.log(`*** from ${fromSource}, checkTileSupport for z: ${z}, x: ${x}, y: ${y}, response = `, response);
            if (response.ok === true) {
              resolve(1);
            } else {
              // if can't fetch online then find in cache
              const response1 = await caches.match(url);
              if (response1) {
                resolve(1);
                console.log(`*** Can not fetch online then found in cache: `, response1);
              } else {
                console.log(`*** Can not found in cache url ${url}, response = `, response1);
                resolve(0);
              }
            }
          } catch (error) {
            console.error(`Error check tile at zoom ${z}:`, error);
            resolve(0);
          }
        } else {
          try {
            const response = await caches.match(url);
            if (response) {
              resolve(1);
              console.log(`*** Found in cache: `, response);
            } else {
              console.log(`*** Can not found in cache url ${url}, response = `, response);
              resolve(0);
            }
          } catch (error) {
            console.error(`Error get cache tile at zoom ${z}:`, error);
            resolve(0);
          }
        }
      } else {
        console.log('*** checkTileSupport, tileCoor has INVALID value:', tileCoord);
        resolve(0);
      }
      
    });
    
  }

  async fetchSupportZoomFromServer(fromSource, assumingSupportZoom) {
    const minZoom = 0;
    const maxZoom = this.defaultMaxZoom;

    const hasTile = await this.checkZoomSupport(fromSource, this.currentUrl, assumingSupportZoom);
    if (hasTile === 0) {
      let zoom = assumingSupportZoom;
      let traversedZooms = [];
      let isSupport = false;
      while (zoom > minZoom) {
        zoom--;
        const support = await this.checkZoomSupport(fromSource, this.currentUrl, zoom);
        traversedZooms.push(zoom);
        if (support === 1) {
          isSupport = true;
          break;
        }
      }
      if (isSupport === false) {
        zoom = assumingSupportZoom;
        traversedZooms = [];
        while (zoom < maxZoom) {
          zoom++;
          const support = await this.checkZoomSupport(fromSource, this.currentUrl, zoom);
          traversedZooms.push(zoom);
          if (support === 1) {
            isSupport = true;
            break;
          }
        }
      }
      if (isSupport === true) {
        traversedZooms.push(assumingSupportZoom); // assumingSupportZoom = current zoom
        

        assumingSupportZoom = zoom;

        // console.log(`*** traversedZooms = `, traversedZooms);
        if (traversedZooms.indexOf(this.destinateZoom) < 0) {
          traversedZooms.push(this.destinateZoom);
        }
        for (const traverseZoom of traversedZooms) {
          if (traverseZoom === zoom) {continue;}
          const key = this.currentUrl.replace('{z}', traverseZoom + '');
          const expiration = Date.now() + (this.zLevelExpiration * 1000);
          await this.keyValueStorageService.setItem(key, {value: zoom, expiration});
          // console.log(`*** cache value = ${zoom} for zoom ${traverseZoom}
          //   , \t\t expiration = ${expiration}
          //   , \t\t this.zLevelExpiration = ${this.zLevelExpiration}`);
        }

        const currentZoom = Math.round(this.view.getZoom());
        // console.log(`**** done all caching, current zoom = ${currentZoom}
        //   , destinate zoom = ${this.destinateZoom}`);
      }
    }
    this.updateTileGridMaxZoom(assumingSupportZoom); // update max zoom

    return assumingSupportZoom;
  }

  async findCachedZoomWithNextZoom(fromSource, currentZoom, nextZoom) {
    // console.log(`*** ${fromSource}, current zoom: ${currentZoom}
    //   , next zoom = ${nextZoom}`);

    // check if next zoom is cached
    let zoom = nextZoom;
    let hasFindCache = false;
    // find if zoom has cached and it's value in cache
    const key = this.currentUrl.replace('{z}', zoom + '');
    const obj = await this.keyValueStorageService.getItem(key);
    if (isInteger(obj?.value)) {
      if (this.isExpired(obj) === true) {
        await this.keyValueStorageService.removeItem(key);
      } else {
        this.supportedZoom = obj.value;
        // console.log(`*** get supported zoom FROM CACHE, value = ${this.supportedZoom}
        //   for zoom ${zoom}`);
        hasFindCache = true;
      }
      
    }

    if (hasFindCache === true) {
      this.updateTileGridMaxZoom(this.supportedZoom); // update max zoom

      return true;
    }
    
    // check if support next zoom
    const hasTile = await this.checkZoomSupport(fromSource, this.currentUrl, nextZoom);
    if (hasTile === 1) {
      this.supportedZoom = nextZoom;
      // console.log(`*** find supported zoom: ${this.supportedZoom} BY FETCHING for zoom ${zoom}`);

      this.updateTileGridMaxZoom(this.supportedZoom); // update max zoom
      
      hasFindCache = true;

    } else if (hasTile === 0) {
      this.supportedZoom = currentZoom;

      
      if (hasFindCache === false) {
        const minZoom = 0;
        const maxZoom = this.defaultMaxZoom;
        if (hasFindCache === false) {
          zoom = nextZoom;
          while(zoom > minZoom) {
            zoom--;
            // find if zoom has cached and it's value in cache
            const key = this.currentUrl.replace('{z}', zoom + '');
            const obj = await this.keyValueStorageService.getItem(key);
            if (isInteger(obj?.value)) {
              if (this.isExpired(obj) === true) {
                await this.keyValueStorageService.removeItem(key);
              } else {
                this.supportedZoom = obj.value;
                // console.log(`*** traverse at zoom: ${zoom} & can get supported zoom FROM CACHE
                //   , value = ${obj.value} for next zoom: ${nextZoom}`);
                hasFindCache = true;
                break;
              }
              
            }
          }
        }
        
        if (hasFindCache === false) {
          zoom = nextZoom;
          while(zoom < maxZoom) {
            zoom++;
            // find if zoom has cached and it's value in cache
            const key = this.currentUrl.replace('{z}', zoom + '');
            const obj = await this.keyValueStorageService.getItem(key);
            if (isInteger(obj?.value)) {
              if (this.isExpired(obj) === true) {
                await this.keyValueStorageService.removeItem(key);
              } else {
                this.supportedZoom = obj.value;
                // console.log(`*** traverse at zoom: ${zoom} & can get supported zoom FROM CACHE
                //   , value = ${obj.value} for next zoom: ${nextZoom}`);
                hasFindCache = true;
                break;
              }
              
            }
          }
        }

        if (hasFindCache === true) {
          // cache current zoom for this value
          const expiration = Date.now() + (this.zLevelExpiration * 1000);
          await this.keyValueStorageService.setItem(
            this.currentUrl.replace('{z}', nextZoom + ''),
            {
              value: this.supportedZoom,
              expiration
            }
          );
          this.updateTileGridMaxZoom(this.supportedZoom); // update max zoom

          // console.log(`*** cache supported zoom = ${this.supportedZoom}
          //   for next zoom: ${nextZoom}
          //   , \t\t expiration = ${expiration}
          //   , \t\t this.zLevelExpiration = ${this.zLevelExpiration}`);
        }
      }
      
      // if (hasFindCache === false) {
      //   // cache this zoom
      //   zoom = nextZoom;
      //   const key = this.currentUrl.replace('{z}', zoom + '');
      //   await this.keyValueStorageService.setItem(key, currentZoom);
      //   console.log(`*** *** cache supported zoom = ${currentZoom}
      //     for zoom ${zoom}`);
      // }

      // console.log(`*** *** update tile grid max zoom to = ${this.supportedZoom}`);
      // this.updateTileGridMaxZoom(this.supportedZoom); // update max zoom
    } else {
      console.log(`*** dont update max zoom for tileGrid and cache zoom because there has invalid tiles`);
    }

    return hasFindCache;
  }

  addStyleControlButton(btn, zoomOptions) {
    btn.onmouseover = () => {
      if (btn.style.backgroundColor === 'grey') { return; }
      btn.style.backgroundColor = 'lightgrey';
      if (zoomOptions) {
        const zoom = Math.round(this.view.getZoom());
        if (zoomOptions.isZoomIn) {
          btn.setAttribute('title', 'Zoom in (' + zoom + ')');
        } else {
          btn.setAttribute('title', 'Zoom out (' + zoom + ')');
        }
      }
    };
    btn.onmouseout = () => {
      if (btn.style.backgroundColor === 'grey') { return; }
      btn.style.backgroundColor = 'white';
    };

    btn.onclick = async () => {
      
      this.hasClickButtonZoom = true;
      if (this.isPBF === false) {
        return;
      }

      // console.log(`*** click button zoom -> find supported zoom`);

      // this is use for PBF tile
      let currentZoom = Math.round(this.view.getZoom());
      let nextZoom = currentZoom;
      if (zoomOptions.isZoomIn) {
        nextZoom += 1;
      } else {
        nextZoom -= 1;
        if (nextZoom < 0) { nextZoom = 0; }
      }
      this.destinateZoom = nextZoom;

      const hasFindCache = await this.findCachedZoomWithNextZoom('click button zoom', currentZoom, nextZoom);
      if (hasFindCache === false) {
        this.supportedZoom = await this.fetchSupportZoomFromServer('click button zoom', currentZoom);
      }

      
    };
  }

  initializeMap(initObj, controls, view, mapLayers, multiLayers) {
    const ConfigService = initObj.configService;
    const disableMouseWheel = initObj.disableMouseWheel;
    let sourceXYZ = [];
    if (multiLayers && multiLayers.length > 0) {
      sourceXYZ = multiLayers;
    } else {
      if (mapLayers) {
        sourceXYZ.push(mapLayers);
      } else {
        const optionOSM = {
          url: 'https://osm.formbird.com/tiles/{z}/{x}/{y}.png', // ConfigService.clientConfig().openLayers.tileServer.url,
          // crossOrigin: ConfigService.clientConfig().openLayers.tileServer.crossOrigin,
          wrapDateLine: false, // not support 6.15.1
          wrapX: false,
          noWrap: true // not support 6.15.1
        };
        const tile = new TileLayer({
          source: new OSM(optionOSM)
        });
        sourceXYZ.push(tile);
      }
    }

    let mouseWheel = true;
    if (disableMouseWheel) {
      mouseWheel = false;
    }

    // define full screen button icon
    const fspan = document.createElement('i');
    fspan.setAttribute('class', 'material-icons');
    fspan.innerHTML = 'fullscreen';
    fspan.style.fontSize = '30px';

    const fSpanActive = document.createElement('i');
    fSpanActive.setAttribute('class', 'material-icons');
    fSpanActive.innerHTML = 'fullscreen_exit';
    fSpanActive.style.fontSize = '30px';
    const fullscreenCtrl: any = new FullScreen({
      label: fspan, labelActive: fSpanActive, tipLabel: 'Fullscreen'
    });
    const fullscreenBtn = fullscreenCtrl.element.childNodes[0];
    this.addStyleControlButton(fullscreenBtn, null);


    document.addEventListener('webkitfullscreenchange mozfullscreenchange fullscreenchange', (evt) => {
     this.fullscreenChangeHandle(fspan);
    });

    // define zoom button
    const zoomBtn: any = new Zoom({
      className: 'ol-zoom my-new-class-name'
    });
    const zoomBtnIn = zoomBtn.element.childNodes[0]; const zoomBtnOut = zoomBtn.element.childNodes[1];
    this.addStyleControlButton(zoomBtnIn, {isZoomIn: true});
    this.addStyleControlButton(zoomBtnOut, {isZoomIn: false});

    if (this.componentDefinition) {
      let clConfig;
      if ( initObj.configService) {
        clConfig = initObj.configService.clientConfig();
      }
      if (this.componentDefinition.tileServerGL && clConfig && clConfig.openLayers && clConfig.openLayers.tileServerGL) {
        const mapViewOffline: any = {
          serverType: 'tilePBF',
          url: clConfig.openLayers.tileServerGL.url,
          EPSG: clConfig.openLayers.tileServerGL.EPSG ? clConfig.openLayers.tileServerGL.EPSG :
          SclMapConstantService.EPSG_3857,
          crossOrigin: (clConfig.openLayers.tileServerGL.crossOrigin ? 
            clConfig.openLayers.tileServerGL.crossOrigin: 'anonymous')
        };
        if (typeof clConfig.openLayers.tileServerGL.urlStyle === 'string') {
          mapViewOffline.styleLocationUrl = clConfig.openLayers.tileServerGL.urlStyle;
        }
        const tile = this.getTile(mapViewOffline, true);
        this.currentUrl = mapViewOffline.url;
        this.currentTileSource = tile.getSource();
        sourceXYZ = [tile];
      }

    }
    const map = new Map({
      controls: olControl.defaults({
        attribution : false,
        zoom: false,
      }).extend([
        fullscreenCtrl,
        zoomBtn
      ]),
      interactions: defaults({mouseWheelZoom: mouseWheel})
      .extend(
        mouseWheel ?
        [
          new MouseWheelZoom({
            constrainResolution: true, // force zooming to a integer zoom
          })
        ]
        : []
      )
      ,
      layers: sourceXYZ,
      target: this.mapDiv,
      view
    });
    // console.log('%c initializeMap, zoom = ' + view.getZoom() , 'color:blue');
    if (controls != null && controls.length) {
      for (let i = 0; i < controls.length; i++) {
        controls[i].element.style.zIndex = this.layerIndexControl;
        map.addControl(controls[i]);
      }
    }

    // if (interactions != null && interactions.length) {
    //   for (let i = 0; i < interactions.length; i++) {
    //     map.addInteraction(interactions[i]);
    //   }
    // }

    if (this.layerAssets.length > 0) {
      for (let iLa = 0; iLa < this.layerAssets.length; iLa++) {
        map.addLayer(this.layerAssets[iLa]);
      }
    }

    if (mouseWheel) {
      if (this.onMapWheelScroll && typeof this.onMapWheelScroll === 'function') {

        this.mapDiv.onwheel = async(evt) => {
          this.hasWheelScroll = true;
          if (this.isPBF === true) {
            // console.log(`*** on wheel scroll -> find supported zoom`);

            // detect zoom in or out
            let currentZoom = Math.round(this.view.getZoom());
            let nextZoom = currentZoom;
            if (evt.deltaY < 0) { // zoom in
              nextZoom += 1;
            } else if (evt.deltaY > 0) { // zoom out
              nextZoom -= 1;
            }

            if (nextZoom !== currentZoom) {
              const hasFindCache = await this.findCachedZoomWithNextZoom('wheel-scroll', currentZoom, nextZoom);
              if (hasFindCache === false) {
                this.supportedZoom = await this.fetchSupportZoomFromServer('wheel-scroll', currentZoom);
              }
            }

          }

          this.onMapWheelScroll(evt);
          
        };
      }

    }

    return map;
  }

  fullscreenChangeHandle(fspan) {
    this.isFullScreen = false;
    if (fspan.innerHTML === 'fullscreen') {
      fspan.innerHTML = 'fullscreen_exit';
      this.isFullScreen = true;
    } else { fspan.innerHTML = 'fullscreen'; }

    // update control position
    if (!window.screenTop && !window.screenY) {
      //  console.log('NOT FULL SCREEN');
      let heightMap = this.heightMapInit;
      if (heightMap <= 0) { heightMap = this.mapDiv.offsetHeight; }
      this.handleFullScreen(this.isFullScreen, heightMap);
      // console.log('mapHeight = ' + this.mapDiv.offsetHeight);
    } else {
      //  console.log('FULL SCREEN');
       this.handleFullScreen(this.isFullScreen, this.mapDiv.offsetHeight);
    }
    // console.log('%c fullscreenchange... isFullScreen = ' + isFullScreen + '\n\t, canvas.offsetHeight = ' + this.canvas.offsetHeight
    //     + '\n\t, canvas.clientHeight = ' + this.canvas.clientHeight + '\n\t, mapDiv.offsetHeight = ' + this.mapDiv.offsetHeight
    //     + '\n\t, screen.height = ' + screen.height + '\n\t, map init height = ' + this.heightMapInit, 'color:blue');
    if (this.mapType === MapComponentName.BOUNDARY) {
      this.updateMenuChildCss();
    }
    
  }
  handleFullScreen(isFullScreen, mapHeight) {
    // const mapHeight = this.mapDiv.offsetHeight; // this.canvas.offsetHeight;
    // // if(isFullScreen) mapHeight = window.innerHeight;
    if (this.elementCtrl != null) {
      this.mapControlStyle(this.elementCtrl, mapHeight);
    }
    if (this.fullScreenEvent != null && typeof this.fullScreenEvent === 'function') {
      this.fullScreenEvent(mapHeight, isFullScreen);
    }
  }

  addInteractionSnap() {
    this.snap = [];
    for (let i = 0; i < this.layerAssets.length; i++) {
      if (this.layerAssets[i].get('isHeatMap') || this.layerAssets[i].get('layerDisplayOnly') ) { continue; }// ignore heat layer
      const iSnap = new Snap({
        source: this.layerAssets[i].getSource(),
        pixelTolerance: 5
      });
      this.snap.push(iSnap);
      this.map.addInteraction(iSnap);
    }
  }

  removeInteractionSnap() {
    if (!this.snap) { return; }
    for (let i = 0; i < this.snap.length; i++) {
      this.map.removeInteraction(this.snap[i]);
    }
    this.snap = []; // reset
  }

  drawDefaultStyle(drawStart, drawEnd) {
    this.draw = new Draw({
      source: this.source,
      type: this.drawType,
      snapTolerance: 1
    });

    this.map.addInteraction(this.draw);
    if (drawStart) {
      this.draw.on('drawstart', (evt) => {
        if (typeof drawStart === 'function') { drawStart(evt); }
      });
    }
    if (drawEnd) {
      this.draw.on('drawend', (evt) => {
        if (typeof drawEnd === 'function') { drawEnd(evt); }
      });
    }
  }

  drawPrimaryStyle(drawStart, drawEnd) {
    if (this.drawType == MapDrawType.NA) { this.drawType = MapDrawType.POINT; }
    let color = '#0099FF'; // default ol blue
    if (this.compActionType === 'primary') { color = 'LimeGreen'; }
    if (this.compActionType === 'secondary') { color = 'black'; }

    // remove old interaction
    if (this.selectPointerMove !== null) {
      this.map.removeInteraction(this.selectPointerMove);
    }
    this.selectPointerMove = new Select({
      condition: condition.pointerMove,
      style: this.selectInteractionStyle.bind(this),
      filter: function(f) {
        if ((f.getGeometry() && f.getGeometry().getType() !== MapDrawType.POINT) ) {
          return true;
        }
      }
    });

    if (this.selectPointerMove !== null) {
      this.map.addInteraction(this.selectPointerMove);
    }


    //
    this.draw = new Draw({
      source: this.source,
      type: this.drawType,
      style: new Style({
        image: new Circle({
          radius: 7,
          fill: new Fill({
            color
          }),
          stroke: new Stroke({
            color: 'white',
            width: 2
          })
        })
      })
    });

    this.map.addInteraction(this.draw);
    if (drawStart) {
      this.draw.on('drawstart', (evt) => {
        if (typeof drawStart === 'function') { drawStart(evt); }
      });
    }
    if (drawEnd) {
      this.draw.on('drawend', (evt) => {
        const fea = evt.feature;
        if (fea) {
          const geom = fea.getGeometry();
          // let type = geom.getType();
          const coord = geom.getCoordinates();
          const coor: any = proj.transform(coord, this.EPSG, SclMapConstantService.EPSG_4326);
          evt.latLng = { lat: parseFloat(coor[1]), lng: parseFloat(coor[0]) };
        }
        if (typeof drawEnd === 'function') { drawEnd(evt); }
      });

    }
  }

  drawFeature(feature, lineLength, dimensionId) {
    let color2 = (this.colorCurrentSelected ? this.colorCurrentSelected : this.singleColor);
    if (!this.isDrawModeSingle ) {
      color2 = (this.colorCurrentSelected ? this.colorCurrentSelected : this.multiColor);
    }
    let fillColor = olColor.asArray(color2);
    fillColor = this.colorWithAlpha(fillColor, 0.3);

    const width = (this.lineWidthCurrentSelected ? this.lineWidthCurrentSelected : 2);
    const lineDash = (this.lineDashCurrentSelected ? this.lineDashCurrentSelected: null);
    const imageSrc = (this.iconCurrentSelected ? this.iconCurrentSelected : null);

    let st = new Style({
      fill: new Fill({
        color: fillColor
      }),
      stroke: new Stroke({
        color: color2,
        width,
        lineDash
      }),
      image: new Circle({
        radius: 7,
        fill: new Fill({
          color: color2
        })
      })
    });
    if (this.drawTypeSpecific === MapDrawTypeSpecial.ICON
        && imageSrc) {
      st.setImage(new Icon({
        src: imageSrc,
        anchor: this.iconAnchorCurrentSelected,
      }));
    }
    
    let s = [st];
    
    if (feature) {
      const p = feature.getProperties();

      if ( (this.drawTypeSpecific === MapDrawTypeSpecial.ARROW_AT_FIRST_POINT
          || this.drawTypeSpecific === MapDrawTypeSpecial.ARROW_AT_LAST_POINT)
          && (this.drawType === MapDrawType.LINE_STRING
            || this.drawType === MapDrawType.MULTI_LINE_STRING) ) {
        const st = this.styleArrow(feature, p, color2, false);
        for (let i = 0; i < st.length; i++) {
          s.push(st[i]);
        }
        p.arrowHead = this.drawTypeSpecific;
      } else if (this.drawTypeSpecific === MapDrawTypeSpecial.ICON) {
        p.point = imageSrc;
        p.anchor = this.iconAnchorCurrentSelected;
      } else if (this.drawTypeSpecific === MapDrawTypeSpecial.DIMENSION) {
        p.dimension = lineLength;
        p.dimensionId = dimensionId;
      }
      feature.setStyle(s);
      
      if (this.colorCurrentSelected) {
        p.fillColor = color2;
        p.color = color2;
      }
      
      
      if (this.lineWidthCurrentSelected) {
        p.lineWidth = this.lineWidthCurrentSelected;
      }
      if (this.lineDashCurrentSelected) {
        p.lineDash = this.lineDashCurrentSelected;
      }
      if (this.fontCurrentSelected) {
        p.font = this.fontCurrentSelected;
      }
      if (this.fontSizeCurrentSelected) {
        p.fontSize = this.fontSizeCurrentSelected;
      }
      
      
      if (!this.isDrawModeSingle) {
        if (this.drawType === MapDrawType.POINT
            || this.drawType === MapDrawType.MULTI_POINT) {
          p.idGroup = ShapeIdGroup.MULTI_POINT;
        } else if (this.drawType === MapDrawType.LINE_STRING
            || this.drawType === MapDrawType.MULTI_LINE_STRING) {
          if (this.drawTypeSpecific === MapDrawTypeSpecial.ARROW_AT_FIRST_POINT) {
            p.idGroup = ShapeIdGroup.MULTI_ARROW_AT_FIRST_POINT;
          } else if (this.drawTypeSpecific === MapDrawTypeSpecial.ARROW_AT_LAST_POINT) {
            p.idGroup = ShapeIdGroup.MULTI_ARROW_AT_LAST_POINT;
          } else {
            p.idGroup = ShapeIdGroup.MULTI_LINE_STRING;
          }
        } else if (this.drawType === MapDrawType.POLYGON
            || this.drawType === MapDrawType.MULTI_POLYGON) {
          p.idGroup = ShapeIdGroup.MULTI_POLYGON;
        } else if (this.drawType === MapDrawType.CIRCLE) {
          p.idGroup = ShapeIdGroup.MULTI_CIRCLE;
        } else if (this.drawType === MapDrawType.SQUARE) {
          p.idGroup = ShapeIdGroup.MULTI_SQUARE;
        } else if (this.drawType === MapDrawType.BOX) {
          p.idGroup = ShapeIdGroup.MULTI_RECTANGLE;
        }
      }
      feature.setProperties(p);
    }

    return feature;
  }

  drawCustomCursorStyle() {
    let color = this.singleColorDraging;
    if (!this.isDrawModeSingle) { // multi mode
      color = this.multiColorDraging;
    }
    return new Style({
      image: new Circle({
        radius: 7,
        fill: new Fill({
          color
        }),
        stroke: new Stroke({
          color: 'white',
          width: 2
        })
      })
    });
  }

  drawCustomStyle(drawStart, drawEnd) {
    if (this.drawType === MapDrawType.TEXT) { return; }
    let geometryFunction;
    if (this.drawType == MapDrawType.NA) { this.drawType = MapDrawType.POINT; }
    
    let drawType = this.drawType;
    let dimensionLabel;
    let dimensionOverlay;
    let lineLength = 0;
    let dimensionId = null;
    if (this.drawType === MapDrawType.CIRCLE) {
      // geometryFunction = function (coordinates, geometry, projection) {
      //   if (!geometry) {
      //     geometry = new Polygon([]);
      //   }
      //   // proj.transform([lng, lat], SclMapConstantService.EPSG_4326, EPSG),
      //   const center = proj.transform(coordinates[0], projection, SclMapConstantService.EPSG_4326);
      //   const last = proj.transform(coordinates[1], projection, SclMapConstantService.EPSG_4326);
      //   const radius = getDistance(center, last);
      //   const circle = circular(center, radius, 128);
      //   circle.transform(SclMapConstantService.EPSG_4326, projection);
      //   geometry.setCoordinates(circle.getCoordinates());
      //   return geometry;
      // };
    } else if (this.drawType === MapDrawType.SQUARE) {
      drawType = MapDrawType.CIRCLE;
      geometryFunction = createRegularPolygon(4);
    } else if (this.drawType === MapDrawType.BOX) {
      drawType = MapDrawType.CIRCLE;
      geometryFunction = createBox();
    }

    this.draw = new Draw({
      source: this.source,
      type: drawType,
      geometryFunction: geometryFunction,
      style: this.drawCustomCursorStyle(),
    });

    this.map.addInteraction(this.draw);


    if (drawStart) {
      this.draw.on('drawstart', (evt) => {
        this.hasDocumentChangeValue = false;

        this.sketch = evt.feature;
        
        let color1 = this.singleColorDraging;
        const width = (this.lineWidthCurrentSelected ? this.lineWidthCurrentSelected : 2);
        const lineDash = (this.lineDashCurrentSelected ? this.lineDashCurrentSelected: null);
        if (!this.isDrawModeSingle &&
          (this.drawType === MapDrawType.LINE_STRING
             || this.drawType === MapDrawType.POLYGON
             || this.drawType === MapDrawType.MULTI_LINE_STRING
             || this.drawType === MapDrawType.MULTI_POLYGON
             || this.drawType === MapDrawType.CIRCLE
             || this.drawType === MapDrawType.SQUARE
             || this.drawType === MapDrawType.BOX)) {
          color1 = this.multiColorDraging;
        }
        const p = this.sketch.getProperties();
        let hasUpdateProperty = false;
        switch(this.drawTypeSpecific) {
          case MapDrawTypeSpecial.DIMENSION:
            dimensionId = uuid.v1();
            const obj = this.createDimensionFeature(dimensionId, evt.coordinate, null
              , this.fontCurrentSelected, this.fontSizeCurrentSelected);
            dimensionOverlay = obj.dimensionOverlay;
            dimensionLabel = obj.dimensionLabel;

            hasUpdateProperty = true;
            p.dimensionId = dimensionId;

            let tooltipCoord = evt.coordinate;
            this.sketchGeomOnChange = this.sketch.getGeometry().on('change', (evt) => {
              const geom = evt.target;
              let output;
              if (geom instanceof LineString) {
                const length = getLength(geom); // meter
                output = sclUtilMap.formatDimension(length, this.dimensionsUnit
                  , this.dimensionsPrecision);
                const coords = geom.getCoordinates();
                const totalLength = sclUtilMap.totalLen(coords);
                const midDistance = totalLength / 2;
                tooltipCoord = sclUtilMap.getPointByDistance(coords, midDistance);
                lineLength = length;
              }
              dimensionLabel.innerHTML = output;
              dimensionOverlay.setPosition(tooltipCoord);
            });
            break;
          case MapDrawTypeSpecial.ARROW_AT_FIRST_POINT:
          case MapDrawTypeSpecial.ARROW_AT_LAST_POINT:
            hasUpdateProperty = true;
            p.arrowHead = this.drawTypeSpecific;
            break;
          default: break;
        }
        if (hasUpdateProperty) {
          this.sketch.setProperties(p);
        }

        const s = [
          new Style({
            stroke: new Stroke({
              color: color1,
              width,
              lineDash
            }),
            image: new Circle({
              radius: 7,
              fill: new Fill({
                color: color1
              }),
              stroke: new Stroke({
                color: 'white',
                width,
                lineDash
              })
            })
          })
        ];
        this.sketch.setStyle(s);

        if (typeof drawStart === 'function') { drawStart(evt); }
      });
    }
    if (drawEnd) {
      this.draw.on('drawend', (evt) => {
        if (this.drawTypeSpecific === MapDrawTypeSpecial.DIMENSION) {
          unByKey(this.sketchGeomOnChange);
          dimensionLabel.className = 'ol-tooltip';
          dimensionOverlay.setOffset([0, -7]);
          if (this.fontCurrentSelected) {
            dimensionLabel.style['font-family'] = this.fontCurrentSelected;
          }
          if (this.fontSizeCurrentSelected) {
            dimensionLabel.style['font-size'] = this.fontSizeCurrentSelected;
          }
        }

        evt.feature = this.drawFeature(this.sketch, lineLength, dimensionId);
        this.sketch = null;
        this.sketchPoints = []; // reset

        if (typeof drawEnd === 'function') { drawEnd(evt); }
      });
    }
  }

  

  createDimensionFeature(id, coordinate, dimensionValue, fontFamily, fontSize) {
    let overlayIsAdded = false;
    if (this.map.getOverlayById(id)) {
      overlayIsAdded = true;
    }
    if (overlayIsAdded) {
      console.log(`This dimension box ${id} is added in map before`);
      return;
    }

    // console.log(`Create dimension box ${id}, coordinate = ${coordinate}`);


    const dimensionContainer = document.createElement('div');
    dimensionContainer.className = 'ol-tooltip';
    dimensionContainer.id = id;

    // show dimension value
    const idLabel = `${id}_label`;
    const dimensionLabel = document.createElement('div');
    dimensionLabel.id = idLabel;
    dimensionLabel.style.display = 'block';
    

    dimensionContainer.appendChild(dimensionLabel);

    const dimensionOverlay = new Overlay({
      element: dimensionContainer,
      offset: [0, -15],
      positioning: 'bottom-center',
      stopEvent: false,
      insertFirst: false,
      id,
    });
    this.map.addOverlay(dimensionOverlay);
    dimensionOverlay.setPosition(coordinate);

    if (dimensionValue !== null) {

      dimensionContainer.innerHTML = sclUtilMap.formatDimension(dimensionValue, this.dimensionsUnit
        , this.dimensionsPrecision);
      dimensionContainer.className = 'ol-tooltip';
      dimensionOverlay.setOffset([0, -7]);
    }
    if (fontFamily) {
      dimensionContainer.style['font-family'] = fontFamily;
      dimensionLabel.style['font-family'] = fontFamily;
    }
    if (fontSize) {
      dimensionContainer.style['font-size'] = fontSize;
      dimensionLabel.style['font-size'] = fontSize;
    }

    const closeDimensionEditorFn = (e) => {
      this.dimensionEditorContainer.style.display = 'none';
      dimensionLabel.style.display = 'block';
      const value = parseFloat(this.dimensionEditorInput.value);
      dimensionLabel.innerHTML = sclUtilMap.formatDimension(value, this.dimensionsUnit
        , this.dimensionsPrecision);
      

      this.vector.getSource().getFeatures().forEach((f) => {
        const p = f.getProperties();
        if (p.dimensionId === id) {
          p.dimension = value;
          if (fontFamily) {
            p.font = fontFamily;
          }
          if (fontSize) {
            p.fontSize = fontSize;
          }
          
          f.setProperties(p);

          if (this.previousDimensionValue != value) {
            this.hasDocumentChangeValue = false;
            if (typeof this.setDirtyFunction === 'function') {
              this.setDirtyFunction();
            }
          }

          return;
        }
      });

      this.closeDimensionEditorFn = null; // reset
      this.reCalculateDimensionFn = null; // reset
    };

    const reCalculateDimensionFn = (e) => {
      let feature = null;
      this.vector.getSource().getFeatures().forEach((f) => {
        const p = f.getProperties();
        if (p.dimensionId === id) {
          feature = f;
          return;
        }
      });
      if (feature) {
        const p = feature.getProperties();
        const geom = feature.getGeometry();
        if (geom instanceof LineString) {
          const length = getLength(geom); // meter
          p.dimension = length;
          if (fontFamily) {
            p.font = fontFamily;
          }
          if (fontSize) {
            p.fontSize = fontSize;
          }
          feature.setProperties(p);

          this.dimensionEditorInput.value = length;
        }
      }
    };

    // add click event for container
    dimensionContainer.onclick = (e) => {


      this.dimensionEditorContainer.style.display = 'flex';
      dimensionLabel.style.display = 'none';

      const containerPos = dimensionContainer.getBoundingClientRect();
      const containerHeight = dimensionContainer.offsetHeight / 2;
      const editorHeight = this.dimensionEditorContainer.offsetHeight;

      this.dimensionEditorContainer.style.top = `${containerPos.top - editorHeight - containerHeight}px`;
      this.dimensionEditorContainer.style.left = `${containerPos.left}px`;
      const content = dimensionContainer.innerHTML.replace(this.dimensionsUnit, '');
      this.previousDimensionValue = parseFloat(content);
      this.dimensionEditorInput.value = this.previousDimensionValue;

      this.closeDimensionEditorFn = closeDimensionEditorFn.bind(this);
      this.reCalculateDimensionFn = reCalculateDimensionFn.bind(this);
      
    };

    return { dimensionLabel, dimensionOverlay };
  }
  

  selectInteractionStyle(feature, resolution) {
    const type = feature.getGeometry().getType();
    let color = 'rgba(0,153,255,1.0)';
    if (this.compActionType === 'primary') {
      color = 'LimeGreen';
    } else if (this.compActionType === 'secondary') { color = 'black'; }
    if (type === MapDrawType.POINT) {
      return feature.get('feaStyle');
    } else if (type === MapDrawType.MULTI_POINT) {
      const image = new Circle({
        radius: 7,
        fill: new Fill({
          color: color
        })
      });
      return new Style({
        image
      });
    } else {
      return new Style({
        stroke: new Stroke({
            color: color,
            width: 0,
        }),
        fill: new Fill({
          color: 'rgba(255,255,255,0.5)',
        })
      });
    }
  }

  selectInteraction() {
    // remove old interaction
    if (this.selectPointerMove !== null) {
      this.map.removeInteraction(this.selectPointerMove);
    }
    this.selectPointerMove = new Select({
      condition: condition.pointerMove,
      style: this.selectInteractionStyle.bind(this),
      // filter: function(f) {
      //   if ((f.getGeometry() && f.getGeometry().getType() !== 'Point') ) {
      //     return true;
      //   }
      // }
    });

    if (this.selectPointerMove !== null) {
      this.map.addInteraction(this.selectPointerMove);
      this.selectPointerMove.on('select', this.toolTipOnFeatureHover);
    }
  }

  addInteractionDraw( drawStart, drawEnd) {
    if (this.drawType == MapDrawType.NA) { this.drawType = MapDrawType.POINT; }
    this.map.removeInteraction(this.selectPointerMove);
    if (this.mapType === MapComponentName.BOUNDARY) {// sc-boundary
      this.drawCustomStyle(drawStart, drawEnd);
    } else if (this.mapType === MapComponentName.SELECTED_ASSET) {// sc-selected-asset
      // this.map.removeInteraction(this.selectPointerMove);
      this.drawPrimaryStyle(drawStart, drawEnd);
    } else {
      this.drawDefaultStyle(drawStart, drawEnd);
    }
  }

  removeInteractionDraw() {
    this.map.removeInteraction(this.draw);
    if (this.mapType === MapComponentName.SELECTED_ASSET) {// sc-selected-asset
      if (this.compActionType === '') {
        this.selectInteraction();
      }
    }
  }

  addInteraction() {
    this.addInteractionDraw({}, {});

    this.vector.getSource().on('addfeature', event => {// finish drawing
      if (this.drawType === MapDrawType.TEXT) {
        return;
      }
      if (this.setDirtyFunction && typeof this.setDirtyFunction === 'function' ) {
        this.setDirtyFunction();
      }
    });
  }

  deselectAllControlBtn(currentBtnId) {
    for (let i = 0; i < this.controlBtns.length; i++) {
      if (!this.controlBtns[i] || this.controlBtns[i].id === currentBtnId) { continue; }
      this.controlBtns[i].style.backgroundColor = 'white';
    }
  }

  modeAction(e) {
    e.stopPropagation();

    this.hideDrawTools();
    this.showMenu(false);
    this.showMenuButton(true);
    this.showTooltip = true;

    this.deselectAllControlBtn(e.currentTarget.id);

    this.map.removeInteraction(this.select);
    this.map.removeInteraction(this.draw);
    this.map.removeInteraction(this.modify);
    this.map.removeInteraction(this.translate);
    

    // hide circle, box, square
    const cssOnlySingleMode = (this.isDrawModeSingle ? 'block' : 'none');
    for (let i = 0; i < this.drawButtonsForOnlySingleMode.length; i++) {
      this.drawButtonsForOnlySingleMode[i].style.display = cssOnlySingleMode;
    }

    if (this.allowDrawingMode !== MapDrawMode.ALL) { return; }
    
    if (this.isDrawModeSingle) {
      if (e && e.currentTarget && e.currentTarget.title ) {
        e.currentTarget.title = 'Multi mode';
      }
      this.isDrawModeSingle = false;
      this.modeLabel.innerHTML = 'layers';
    } else {
      if (e && e.currentTarget && e.currentTarget.title ) {
        e.currentTarget.title = 'Single mode';
      }
      this.isDrawModeSingle = true;
      this.modeLabel.innerHTML = 'layers_clear';
    }
    

    this.actionType = MapDrawAction.MODE;

    
  }

  selectAction(e) {
    e.stopPropagation();

    this.hideDrawTools();
    this.showMenuButton(true);

    this.deselectAllControlBtn(e.currentTarget.id);
    this.map.removeInteraction(this.draw);

    this.drawType = MapDrawType.NA;
    this.drawTypeSpecific = null;
    
    if (e.currentTarget.style.backgroundColor === 'grey') {
      e.currentTarget.style.backgroundColor = 'white';
      
      this.actionType = MapDrawAction.NA;

      this.showTooltip = true;
      this.selectInteraction();
    } else {
      e.currentTarget.style.backgroundColor = 'grey';
      this.actionType = MapDrawAction.SELECT;

      this.map.addInteraction(this.select);
      this.map.addInteraction(this.modify);
      this.map.addInteraction(this.translate);

      this.showTooltip = false;
      this.map.removeInteraction(this.selectPointerMove);
    }
  }

  updateMenuChildCss() {
    this.showStylingSubMenu(null, false);
    
    const mapDivSize = (this.isBottom ? this.mapDiv?.offsetHeight : this.mapDiv?.offsetWidth);
    this.updateDrawingSubMenuCss(mapDivSize);
  }

  showMenu(isShow) {
    if (!this.drawMenuChild) { return; }
    const displayBottom = (this.isBottom ? 'block': 'flex');
    const display = (isShow ? displayBottom: 'none');
    this.drawMenuChild.style.display = display;
    this.showMenuChilds(isShow);

    const cssOnlySingleMode = (this.isDrawModeSingle ? 'block' : 'none');
    // hide circle, box, square for multi mode
    for (let i = 0; i < this.drawButtonsForOnlySingleMode.length; i++) {
      this.drawButtonsForOnlySingleMode[i].style.display = cssOnlySingleMode;
    }
    this.updateMenuChildCss();
  }
  showMenuChilds(isShow) {
    super.showMenuChilds(isShow);
    const display = isShow ? 'block': 'none';
    if (this.menuSquareBtn) { this.menuSquareBtn.style.display = display; }
  }
  

  menuAction(e) {
    e.stopPropagation();

    this.deselectAllControlBtn(e.currentTarget.id);
    this.map.removeInteraction(this.draw);
    
    if (e.currentTarget.style.backgroundColor === 'grey') {
      e.currentTarget.style.backgroundColor = 'white';
      
      this.actionType = MapDrawAction.NA;
      this.showMenu(false);
      this.showTooltip = true;
    } else {
      e.currentTarget.style.backgroundColor = 'grey';
      this.actionType = MapDrawAction.MENU;
      this.showMenu(true);
      this.showTooltip = false;
    }
  }

  hideDrawTools() {
    super.hideDrawTools();
    this.hideDrawTool(this.squareBtn);
  }

  cancelDrawing() {
    this.mapClickCount = 0;
    this.map.removeInteraction(this.modify);
    this.map.removeInteraction(this.draw);
    this.map.removeInteraction(this.select);
    this.map.removeInteraction(this.translate);
    this.addInteraction();
  }
  finishDrawing() {
    if (this.sketch) {
      const geom = this.sketch.getGeometry();
      const type = geom.getType();
      const coords = geom.getCoordinates();
      const p = this.sketch.getProperties();
      let segmentCount = 0;
      let allowFinish = true;
      switch(type) {
        case MapDrawType.LINE_STRING:
          if (coords) {
            segmentCount = coords.length;
          }
          if (segmentCount < 3) { allowFinish = false; }
          break;
        case MapDrawType.POLYGON:
          if (coords[0]) {
            segmentCount = coords[0].length;
          }
          if (segmentCount < 5) { allowFinish = false; }
          break;
        default: break;
      }
      if (allowFinish) {
        this.draw?.finishDrawing();
      } else {
        this.cancelDrawing();
        if (typeof p.dimensionId === 'string') {
          const ov = this.map.getOverlayById(p.dimensionId);
          if (ov) {
            this.map.removeOverlay(ov);
          }
        }
      }
    } else {
      this.cancelDrawing();
    }
    this.sketch = null;
    this.sketchPoints = []; // reset
  }

  shapeAction(e, drawTypeSingle, drawTypeMulti, drawTypeSpecific = null) {
    e.stopPropagation();

    this.deselectAllControlBtn(e.currentTarget.id);
    this.map.removeInteraction(this.modify);
    this.map.removeInteraction(this.draw);
    this.map.removeInteraction(this.select);
    this.map.removeInteraction(this.translate);
    this.drawTypeSpecific = null;
    this.sketch = null;
    this.sketchPoints = [];
    this.mapClickCount = 0;
    if (this.drawTextCursor) {
      this.vector.getSource().removeFeature(this.drawTextCursor);
    }

    if (e.currentTarget.style.backgroundColor === 'grey') {
      e.currentTarget.style.backgroundColor = 'white';
      this.actionType = MapDrawAction.NA;
      this.drawType = MapDrawType.NA;
      
      this.showMenu(true);
      this.hideDrawTools();
      this.showMenuButton(true);
    } else {
      e.currentTarget.style.backgroundColor = 'grey';
      this.actionType = MapDrawAction.EDIT;
      if (drawTypeSpecific === MapDrawTypeSpecial.TEXT_BOX) {
        this.drawType = drawTypeSpecific;
      } else {
        this.drawType = (this.isDrawModeSingle ? drawTypeSingle : drawTypeMulti);
        this.addInteraction();
      }
      this.showMenu(false);
    }
  }

  pointAction(e) {
    
    this.shapeAction(e, MapDrawType.POINT, MapDrawType.MULTI_POINT);
  }

  lineAction(e) {
    this.shapeAction(e, MapDrawType.LINE_STRING, MapDrawType.MULTI_LINE_STRING);
  }

  polygonAction(e) {
    this.shapeAction(e, MapDrawType.POLYGON, MapDrawType.MULTI_POLYGON);
  }

  circleAction(e) {
    this.shapeAction(e, MapDrawType.CIRCLE, MapDrawType.CIRCLE);
  }

  squareAction(e) {
    this.shapeAction(e, MapDrawType.SQUARE, MapDrawType.SQUARE);
  }

  boxAction(e) {
    this.shapeAction(e, MapDrawType.BOX, MapDrawType.BOX);
  }

  textAction(e) {
    this.shapeAction(e, MapDrawType.POINT, MapDrawType.POINT, MapDrawTypeSpecial.TEXT_BOX);
    if (this.drawType === MapDrawTypeSpecial.TEXT_BOX) {
      if (this.drawTextCursor == null) {
        this.drawTextCursor = this.parseToPoint([0, 0], this.drawTextCursorId, this.EPSG);
        this.drawTextCursor.setStyle(this.drawCustomCursorStyle());
      } else {
        const fea = this.vector.getSource().getFeatureById(this.drawTextCursorId);
        if (fea === null) {
          this.vector.getSource().addFeature(this.drawTextCursor);
        }
      }
      
      
    }
  }

  arrowAtFirstPointAction(e) {
    this.shapeAction(e, MapDrawType.LINE_STRING, MapDrawType.MULTI_LINE_STRING);
    this.drawTypeSpecific = MapDrawTypeSpecial.ARROW_AT_FIRST_POINT;
  }

  arrowAtLastPointAction(e) {
    this.shapeAction(e, MapDrawType.LINE_STRING, MapDrawType.MULTI_LINE_STRING);
    this.drawTypeSpecific = MapDrawTypeSpecial.ARROW_AT_LAST_POINT;
  }
  drawIconAction(e) {
    this.shapeAction(e, MapDrawType.POINT, MapDrawType.MULTI_POINT);
    this.drawTypeSpecific = MapDrawTypeSpecial.ICON;
  }
  dimensionAction(e) {
    if (!this.isDrawModeSingle) { return; }
    this.shapeAction(e, MapDrawType.LINE_STRING, MapDrawType.LINE_STRING);
    this.drawTypeSpecific = MapDrawTypeSpecial.DIMENSION;
  }

  deleteAction(e) {
    e.stopPropagation();

    this.hideDrawTools();
    this.showMenuButton(true);

    this.map.removeInteraction(this.modify);
    this.map.removeInteraction(this.draw);
    this.map.removeInteraction(this.translate);

    this.deselectAllControlBtn(e.currentTarget.id);
    if (e.currentTarget.style.backgroundColor === 'grey') {
      e.currentTarget.style.backgroundColor = 'white';
      this.actionType = MapDrawAction.NA;
      this.showTooltip = true;
    } else {
      e.currentTarget.style.backgroundColor = 'grey';
      this.actionType = MapDrawAction.DELETE;
      this.showTooltip = false;
    }
    if (this.drawType === MapDrawType.TEXT) {
      this.drawType = MapDrawType.POINT;
    }
    
  }
  deleteSelectedShape() {
    if (this.selectedFeature !== null && this.drawType === MapDrawType.NA
       && this.actionType === MapDrawAction.SELECT) {

      this.vector?.getSource()?.getFeatures()?.forEach((f) => {
        const fUId = getUid(f);
        const currentUId = getUid(this.selectedFeature);
        if (fUId == currentUId) {
          this.vector.getSource().removeFeature(f);
        }
      });

      
      this.hasDocumentChangeValue = false;
      
      if (this.setDirtyFunction && typeof this.setDirtyFunction === 'function' ) {
        this.setDirtyFunction();
      }
    }
    
  }

  resetCheckLocationUI() {
    this.locationChecked = false;
    if (this.locationElementIcon) {
        this.locationElementIcon.setAttribute('class', 'material-icons');
    }
  }

  locationAction(e) {
    e.stopPropagation();

    this.hideDrawTools();
    this.showMenuButton(true);

    this.actionType = MapDrawAction.LOCATION;

    this.deselectAllControlBtn(e.currentTarget.id);

    if (this.locationChecked) {
      this.actionType = MapDrawAction.NA;
      if (this.locationElementIcon) {
          this.locationElementIcon.setAttribute('class', 'material-icons');
      }
    } else {
        this.actionType = MapDrawAction.LOCATION;
        if (this.locationElementIcon) {
            this.locationElementIcon.setAttribute('class', 'material-icons button-location-pulse');
        }
        if (this.getLocationFn && typeof this.getLocationFn === 'function') {
            this.getLocationFn();
        }
    }
    this.locationChecked = !this.locationChecked;
  }

  // control when switch to another map view, clone from sclMapViews.addRadioButton and have modify
  switchMapView(uiLabel, compId) {
    const radioButtonId = compId + uiLabel;
    const radioButton = document.getElementById(radioButtonId);
    radioButton?.click();
  }
  addRadioButton(document, element, compId) {
    this.mapViewLayers.forEach((layer, i) => {
      const uiLabel = layer.get('title');
      const radio = sclMapViews.createRadio(document, compId + uiLabel, layer.getVisible(), compId);
      radio.onclick = () => {
        this.mapViewLayers.forEach(async (mapViewLayer, j) => {
          let value = mapViewLayer.get('title');
          if (!value || value === 'Vector') {
            return;
          }
          const newTil = compId + uiLabel;
          value = compId + value;
          if (value === newTil) {
            const isGroup = mapViewLayer.get('isGroup');
            if (isGroup === false) {
              this.currentTileSource = mapViewLayer.getSource();
              if (this.currentTileSource != null) {
                this.currentUrl = this.currentTileSource.get('originalTileUrl');
                this.isPBF = (this.currentTileSource.get('serverType') === 'tilePBF');
              }
              this.supportedZoom = Math.round(this.view.getZoom());
              this.destinateZoom = this.supportedZoom; // reset
    
              // console.log(`*** switch map view, current zoom: ${this.supportedZoom}`);
    
              if (this.isPBF) {
                // console.log(`*** switch map view -> find supported zoom`);
                // find support zoom
                await this.findSupportZoom('switch map view');
              }
              
            }
            
    
    
            //
            mapViewLayer.setVisible(true);
            if (mapViewLayer instanceof Group) {
              mapViewLayer.getLayers().forEach((sublayer, k) => {
                sublayer.setVisible(true);
              });
            }
          } else {
            mapViewLayer.setVisible(false);
          }
        });
      };


      element.appendChild(radio);
      // label for this radio
      const label =  sclMapViews.createLabel(document, compId + uiLabel, '');
      // sLabel is a span inside label
      const sLabel = document.createElement('span');
      sLabel.innerHTML = uiLabel;
      sLabel.style.verticalAlign = '-webkit-baseline-middle';
      sLabel.style.color = 'black';
      label.appendChild(sLabel);
      element.appendChild(label);
    });
  }

  addMapViewControl(element, compId, layerIds) {
    const elementMapView = document.createElement('div');
    elementMapView.className = 'select-action ol-control custom-control';
    elementMapView.style.top = '10px'; // map view control always on top of map
    if (typeof this.mapViewLayers !== 'undefined' || this.mapViewLayers !== null) {
      const radioElement = document.createElement('div');
      radioElement.className = 'radio-group';
      this.addRadioButton(document, radioElement, compId);
      elementMapView.appendChild(radioElement);
      this.mapViewLayers.forEach((layer, i) => {
        const title = compId + layer.get('title');
        layerIds.push(title);
      });
    }

    element.append(elementMapView);
  }

  addControlDraw(compId, pOptions, cb) {
    let layerIds = [];
    const self = this;
    const ActionControl = function(ctrlOptions) {
      const options = ctrlOptions || {};

      const element = document.createElement('div');

      if (pOptions != null) {
        self.addMapViewControl(element, compId, layerIds);
      }

      self.drawingMenu = document.createElement('div');
      self.drawingMenu.id = compId + '_Drawing_Menu_';
      self.drawingMenu.className = 'select-action ol-control custom-control';

      self.elementWrapperForBottomPosition = null;
      if (self.isBottom) {
        self.elementWrapperForBottomPosition = self.mapDiv;
      }
    
      

      self.drawStylingButtonCss = {
        'background-color': 'white'
        , color: 'black'
        , width: self.drawToolButtonSize + 'px'
        , height: self.drawToolButtonSize + 'px'
        , border: 'white 0px' 
      };
      
      self.cssIconDiv = {
        'height': `40px`, 
        'width': `40px`,
        'position': `relative`,
      };


      self.addDrawButtons(layerIds, compId, null, (self.isBottom ? 'draw-menu-bottom' : 'draw-menu'));

      if (self.menuBoxBtn) {
        self.drawButtonsForOnlySingleMode.push(self.menuBoxBtn);
      }
      

      self.elementCtrl = self.drawingMenu;
      

      element.appendChild(self.drawingMenu);

      Control.call(this, {
        element,
        target: options.target
      });
    };
    olInherits(ActionControl, Control);
    this.map.addControl(new ActionControl({}));

    cb({layerIds, menuSelectBtn: this.menuSelectBtn, menuSelectLabel: this.menuSelectLabel});
  }

  testRedraw(e) {
    const idx = parseInt(e.currentTarget.id, 10);
    this.clearAllFeaturesLayer(idx);
    setTimeout(() => {
      if (idx in this.assetOfLayers) {
        for (let i = 0; i < this.assetOfLayers[idx].length; i++) {
          if (!this.layerAssets[idx].getSource()) { continue; }
          this.layerAssets[idx].getSource().addFeature(this.assetOfLayers[idx][i]);
        }
      }
    }, 1000);

  }

  addTestBtn(element) {
    const testDiv = document.createElement('div');
    testDiv.className = 'select-action ol-control custom-control';
    let idx = 1;
    for (let i = 0; i < this.layersRedrawCount; i++) {
      const testBtn = sclMapViews.createUIButton(document, this.testRedraw.bind(this), 'ol-has-tooltip', (idx + ''), null );
      testBtn.setAttribute('id', idx);
      const iSpan = document.createElement('i');
      iSpan.innerHTML = idx + '';
      testBtn.appendChild(iSpan);

      testDiv.appendChild(testBtn);
      idx++;
    }
    this.testDiv = testDiv;
    element.appendChild(testDiv);
  }

  addControl(ActionControl, element, options) {
    if (this.layersRedraw) {
      this.addTestBtn(element);
    }
    Control.call(ActionControl, {
      element,
      target: options.target
    });
  }

  setupControl(ActionControl) {
    olInherits(ActionControl, Control);
  }

  drawTextBox(mapPoint, latLng) {
    const id = uuid.v1();
    this.createTextBoxFeature(mapPoint, latLng, '', id, true, this.fontCurrentSelected
    , this.fontSizeCurrentSelected);
  }

  drawArrowAtFirst() {
    if (!this.sketch) { return; }
    const newStyle = [];
    const styles = this.sketch.getStyle();
    if (styles?.length > 0) {
      newStyle.push(styles[0]);
    }
    const st = this.styleArrow(this.sketch, this.sketch.getProperties()
    , (this.isDrawModeSingle ? this.singleColorDraging : this.multiColorDraging), true);
    if (st.length > 0) {
      newStyle.push(st[0]);
    }
    this.sketch.setStyle(newStyle);
  }
  
  setTextBoxFeatureContent(feature, textContent, textId, fontFamily, fontSize) {
    if (feature === null) {
      return;
    }
    this.setFeatureProperties(feature,
      {
        text: textContent,
        icon: null,
        isCluster: null,
        textId,
        font: fontFamily,
        fontSize
      }
    );
  }

  createTextBoxLineOffset(featureLine, id, coor, textContent, fontFamily, fontSize) {
    const parentPos = this.mapDiv.getBoundingClientRect();
    const childId = `${this.keyName}__text-content__${id}}`;
    const childElement = document.getElementById(childId);
    const childPos = childElement.getBoundingClientRect();
    const top = childPos?.top - parentPos?.top;
    const left = childPos?.left - parentPos?.left;
    const destCoor = this.map.getCoordinateFromPixel([left, top]);
    const destLatLng = proj.transform(destCoor
      , this.EPSG, SclMapConstantService.EPSG_4326); // check lat long of destCoor

    // console.log(`***** createTextBoxLineOffset
    // , top = ${top}, left = ${left}
    // , coor = ${JSON.stringify(coor)}
    // , destCoor = ${JSON.stringify(destCoor)}
    // , latLng2 = ${JSON.stringify(destLatLng)}
    // , parentPos = ${JSON.stringify(parentPos)}
    // , childPos = ${JSON.stringify(childPos)}`);

    const lineCoor = [coor, destLatLng];
    featureLine = this.sclAssetLayersCreateFeatureByType(lineCoor, MapDrawType.LINE_STRING, this.EPSG, null);
    this.vector.getSource().addFeature(featureLine);
    this.setTextBoxFeatureContent(featureLine, textContent, id, fontFamily, fontSize);
    return featureLine;
  }
  
  textBoxDragable(dragElement, destElement, featurePoint, featureLine, id) {
    let xOffset = 0;
    let yOffset = 0;

    /*sets offset parameters and starts listening for mouse-move*/
    const startDrag = (e) => {
      if (this.actionType !== MapDrawAction.SELECT) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      this.textBoxAnchorLineCoor = null; // reset
      this.textBoxAnchorPointCoor = null; // reset

      /* Drag object */
      const dragObject = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if(e.type == 'mousemove') {
          // console.log(`***** mouse move`);
          dragElement.style.left = `${(e.clientX - xOffset)}px`; // adjust location of dragged object so doesn't jump to mouse position
          dragElement.style.top = `${(e.clientY - yOffset)}px`;

          // update line position
          const parentPos = this.mapDiv.getBoundingClientRect();
          const dragHandlePos = dragElement.getBoundingClientRect();
          const top1 = dragHandlePos?.top - parentPos?.top;
          const left1 = dragHandlePos?.left - parentPos?.left;
          this.textBoxAnchorPointCoor = this.map.getCoordinateFromPixel([left1, top1]);
          const latLng: any = proj.transform(this.textBoxAnchorPointCoor
            , this.EPSG, SclMapConstantService.EPSG_4326); // lagLng to debug coor


          
          const destPos = destElement.getBoundingClientRect();
          const top2 = destPos?.top - parentPos?.top;
          const left2 = destPos?.left - parentPos?.left;
          const destCoor = this.map.getCoordinateFromPixel([left2, top2]);
          const latLng2 = proj.transform(destCoor
            , this.EPSG, SclMapConstantService.EPSG_4326); // latLng2 to debug destCoor

          // console.log(`***** mouse move, xOffset = ${xOffset}, yOffset = ${yOffset}
          // , e.clientX = ${e.clientX}, e.clientY = ${e.clientY}
          // , top1 = ${top1}, left1 = ${left1}
          // , top2 = ${top2}, left2 = ${left2}
          // , coor = ${JSON.stringify(coor)}
          // , latLng = ${JSON.stringify(latLng)}
          // , destCoor = ${JSON.stringify(destCoor)}
          // , latLng2 = ${JSON.stringify(latLng2)}`);
      
          this.textBoxAnchorLineCoor = [this.textBoxAnchorPointCoor, destCoor];
          if (featureLine == null) {
            this.vector.getSource().getFeatures().forEach((f) => {
              const p = f.getProperties();
              const type = f.getGeometry().getType();
              if (p.textId === id) {
                if (type === MapDrawType.POINT) {
                  featurePoint = f;
                } else if (type === MapDrawType.LINE_STRING) {
                  featureLine = f;
                }
              }
            });
          }
          featureLine.getGeometry().setCoordinates(this.textBoxAnchorLineCoor);
          featurePoint.getGeometry().setCoordinates(this.textBoxAnchorPointCoor);

        }
      }
      /*End dragging*/

      this.textBoxOnMouseUp = () => {
        // console.log(`***** mouse up, featurePoint = ${featurePoint}
        // , featureLine = ${featureLine}, this.textBoxAnchorPointCoor = ${this.textBoxAnchorPointCoor}
        // , this.textBoxAnchorLineCoor = ${this.textBoxAnchorLineCoor}`);
        this.hasDocumentChangeValue = false;
        this.vector.getSource().getFeatures().forEach((f) => {
          const p = f.getProperties();
          const type = f.getGeometry().getType();
          if (p.textId === id) {
            if (type === MapDrawType.POINT) {
              if (this.textBoxAnchorPointCoor) {
                f.getGeometry().setCoordinates(this.textBoxAnchorPointCoor);
              }
              featurePoint = f;
            } else if (type === MapDrawType.LINE_STRING) {
              if (this.textBoxAnchorLineCoor) {
                f.getGeometry().setCoordinates(this.textBoxAnchorLineCoor);
              }
              featureLine = f;
            }
          }
        });

        window.removeEventListener('mousemove', dragObject, true);
        window.removeEventListener('touchmove', dragObject, true);

        if (this.setDirtyFunction && typeof this.setDirtyFunction === 'function') {
          this.setDirtyFunction();
        }
      };

      if (e.type == 'mousedown') {
        xOffset = e.clientX - parseInt(window.getComputedStyle(dragElement).left);
        yOffset = e.clientY - parseInt(window.getComputedStyle(dragElement).top);

        window.addEventListener('mousemove', dragObject, true);
      }
    };

    dragElement.addEventListener("mousedown", startDrag, true);

    
  }

  createTextBoxFeature(mapClickPoint, coor, textContent, id, isEdit, fontFamily, fontSize) {
    let overlayIsAdded = false;
    if (this.map.getOverlayById(id)) {
      overlayIsAdded = true;
    }
    if (overlayIsAdded) {
      console.log(`This textbox ${id} is added in map before`);
      return;
    }
    const mapHeight = this.mapDiv?.offsetHeight;
    const mapWidth = this.mapDiv?.offsetWidth;
    let textBoxSize = mapHeight;
    if (mapHeight > mapWidth) { textBoxSize = mapWidth; }
    textBoxSize /= 2;
    if (textBoxSize <= 0) { textBoxSize = 100; }

    const container = document.createElement('div');
    container.id = `${this.keyName}__text-container__${id}}`;
    container.className = 'ol-popup';
    container.setAttribute('draggable', 'true');

    const elemContent = document.createElement('div');
    elemContent.id = `${this.keyName}__text-content__${id}}`;
    elemContent.className = 'draw-text-content';
    elemContent.style.display = (isEdit ? 'none': 'block');
    
    container.appendChild(elemContent);

    const elemTextBox = document.createElement('textarea');
    elemTextBox.id = `${this.keyName}__text-input__${id}}`;
    elemTextBox.className = 'draw-text-area';
    elemTextBox.style.width = `${textBoxSize}px`;
    elemTextBox.style['z-index'] = 100;
    elemTextBox.style.display = (isEdit ? 'block': 'none');
    elemTextBox.setAttribute('placeholder', '...');
    container.appendChild(elemTextBox);

    if (textContent) {
      elemContent.innerHTML = textContent;
      elemTextBox.value = textContent;
    }
    if (fontFamily) {
      elemContent.style['font-family'] = fontFamily;
      elemTextBox.style['font-family'] = fontFamily;
    }
    if (fontSize) {
      elemContent.style['font-size'] = fontSize;
      elemTextBox.style['font-size'] = fontSize;
    }
    
    
    const overlay = new Overlay({
      element: container,
      id,
      autoPan: {
        animation: {
          duration: 250,
        },
      },
      offset: [0, 0]
    });
    
    this.map.addOverlay(overlay);
    overlay.setPosition(mapClickPoint);

    let featurePoint = null;
    let featureLine = null;
    this.vector.getSource().getFeatures().forEach((f) => {
      const p = f.getProperties();
      const type = f.getGeometry().getType();
      if (p.textId === id) {
        if (type === MapDrawType.POINT) {
          featurePoint = f;
        } else if (type === MapDrawType.LINE_STRING) {
          featureLine = f;
        }
      }
    });
    if (featurePoint == null) {
      featurePoint = this.sclAssetLayersCreateFeatureByType(coor, MapDrawType.POINT
        , this.EPSG, null);
      this.vector.getSource().addFeature(featurePoint);
      this.setTextBoxFeatureContent(featurePoint, textContent, id, fontFamily, fontSize);
    }
    if (featureLine == null && isEdit == false) {
      featureLine = this.createTextBoxLineOffset(featureLine, id, coor, textContent, fontFamily, fontSize);
    }


    const closeTextBoxFn = (e) => {
      elemContent.innerHTML = elemTextBox.value;
      elemContent.style.display = 'block';
      elemTextBox.style.display = 'none';
      this.hasDocumentChangeValue = false;
      this.setTextBoxFeatureContent(featurePoint, elemTextBox.value, id, fontFamily, fontSize);
      this.setTextBoxFeatureContent(featureLine, elemTextBox.value, id, fontFamily, fontSize);

      this.closeTextBox.style.display = 'none';
      this.currentCloseTextBoxFn = null; // reset
      this.currentTextBoxId = null;

      if (elemContent.innerHTML.trim().length == 0) {
        // console.log(`**** remove overlay`);
        this.map.getOverlays().remove(overlay);
        this.map.removeOverlay(overlay);
        if (featurePoint !== null) {
          this.vector.getSource().removeFeature(featurePoint);
        }
        if (featureLine != null) {
          this.vector.getSource().removeFeature(featureLine);
        }
      } else {
        if (featureLine == null) {
          featureLine = this.createTextBoxLineOffset(featureLine, id, coor, textContent, fontFamily, fontSize);
        }
      }

      if (this.setDirtyFunction && typeof this.setDirtyFunction === 'function') {
        this.setDirtyFunction();
      }
      
    }
    this.currentCloseTextBoxFn = (isEdit ? closeTextBoxFn : null);
    this.currentTextBoxId = (isEdit ? id : null);

    elemTextBox.onblur = ((e) => {
      closeTextBoxFn(e);
    });

    container.onclick = ((e) => {
      if (this.actionType == MapDrawAction.DELETE) {
        const ov = this.map.getOverlayById(id);
        if (ov) {
          this.map.removeOverlay(ov);
        }
        let feaPoint = null;
        let feaLine = null;
        this.vector.getSource().getFeatures().forEach((f) => {
          const p = f.getProperties();
          const type = f.getGeometry().getType();
          if (p.textId === id) {
            if (type === MapDrawType.POINT) {
              feaPoint = f;
            } else if (type === MapDrawType.LINE_STRING) {
              feaLine = f;
            }
            
            console.log(`*** This feature with textId = ${id} has already added to map`);
          }
        });
        if (feaPoint !== null) {
          this.vector.getSource().removeFeature(feaPoint);
        }
        if (feaLine !== null) {
          this.vector.getSource().removeFeature(feaLine);
        }
        this.hasDocumentChangeValue = false;
        if (typeof this.setDirtyFunction === 'function') {
          this.setDirtyFunction();
        }
      } else {
        elemTextBox.style.display = 'block';
        this.closeTextBox.style.display = 'block';
        elemContent.style.display = 'none';
  
        this.currentCloseTextBoxFn = closeTextBoxFn;
        this.currentTextBoxId = id;
      }
    });


    this.textBoxDragable(container, elemContent, featurePoint, featureLine, id);
    


    this.closeTextBox.style.display = (isEdit ? 'block': 'none');
    this.closeTextBox.style.width = `${mapWidth}px`;
    this.closeTextBox.style.height = `${mapHeight}px`;
    this.closeTextBox.style['z-index'] = 1;
    this.closeTextBox.onclick = ((e) => {
      closeTextBoxFn(e);
    });


  }

  mapClickEvent(cb) {
    this.map.on('click', (evt) => {
      // console.log(`**** map click event, this.drawType = ${this.drawType}
      // , this.currentLine = `, this.currentLine);
      const coor: any = proj.transform(evt.coordinate, this.EPSG, SclMapConstantService.EPSG_4326);
      this.mapClickCount++;
      this.hasClickMap = true;
      if (this.drawType === MapDrawTypeSpecial.TEXT_BOX) {
        this.hasDocumentChangeValue = false; // reset
        this.drawTextBox(evt.coordinate, coor);

      } else if (this.drawTypeSpecific === MapDrawTypeSpecial.ARROW_AT_FIRST_POINT
         && this.sketch !== null) {
        this.drawArrowAtFirst();
      } else {
        
        evt.latLng = { lat: parseFloat(coor[1]), lng: parseFloat(coor[0])};
        const featureOnClick = this.map.forEachFeatureAtPixel(evt.pixel, (feature, layer) => {
          const fs = feature.get('features');
          if (fs) {
            return fs;
          }
          return feature;
        });
        if (featureOnClick) {
          if (Array.isArray(featureOnClick) && featureOnClick.length > 0) {
            if (this.clusterClick && typeof this.clusterClick === 'function') {
              this.clusterClick(featureOnClick, evt.pixel);
            }
          } else {
            if (cb && typeof cb === 'function') {
              cb(evt);
            }
          }
        } else {
          if (cb && typeof cb === 'function') {
            cb(evt);
          }
        }
        // if (cb && typeof cb === 'function') {
        //   cb(evt);
        // }
      }
      
    });
  }
  mapPointerMoveEvent(cb) {
    let previousMousePosition: any = null;
    this.map.on('pointermove', (evt) => {
      if (this.drawType === MapDrawTypeSpecial.TEXT_BOX
        && this.drawTextCursor !== null) {
        const fea = this.vector.getSource().getFeatureById(this.drawTextCursorId);
        if (fea == null) {
          this.vector.getSource().addFeature(this.drawTextCursor);
        }
        this.drawTextCursor.getGeometry().setCoordinates(evt.coordinate);
      } else if (this.actionType === MapDrawAction.SELECT) {
        if (this.isMoving) {
          return;
        }

        let feature = this.select.getFeatures().item(0);
        if (!feature) {
          feature = this.selectedFeature;
        }
        if (feature) {
          const mousePosition = this.map.getEventCoordinate(evt.originalEvent);// Get the current mouse position
          const closestPoint = feature.getGeometry().getClosestPoint(mousePosition);

          const mousePositionWGS84 = proj.toLonLat(mousePosition);
          const closestPointWGS84 = proj.toLonLat(closestPoint);
  
          const distance = sclUtilMap.haversine(mousePositionWGS84, closestPointWGS84);


          // console.log(`**** pointermove, distance = ${distance}`);
          
          if (this.boundingRectangleFeature == null) {
            this.createDebugShapeBoundingBoxFeature();
          }

          if (this.boundingRectangle.intersectsCoordinate(mousePosition)
            && !feature.getGeometry().intersectsCoordinate(mousePosition)) {
            // console.log(`**** VALID AREA`);
            // If the distance is less than a certain threshold, show the rotate icon
            if (distance > this.THRESHOLD_MIN && distance < this.THRESHOLD_MAX) {
              // Show the rotate icon
              this.rotateObject.setPosition(mousePosition);
            } else {
              // Hide the rotate icon
              this.rotateObject.setPosition(undefined);
            }
          } else {
            // Hide the rotate icon
            this.rotateObject.setPosition(undefined);
          }
  
          // console.log(`*** allowRotate = ${this.allowRotate}`);
          if (this.allowRotate) {
            const angle = Math.atan2(mousePosition[1] - this.selectedFeatureCenter[1]
              , mousePosition[0] - this.selectedFeatureCenter[0]);
            const adjustedAngle = angle * this.rotateSpeed;
  
            if (previousMousePosition) {
              const dx = mousePosition[0] - previousMousePosition[0];
  
              if (dx < 0) {
                // Rotate clockwise
                feature.getGeometry().rotate(-adjustedAngle, this.selectedFeatureCenter);
              } else {
                // Rotate anti-clockwise
                feature.getGeometry().rotate(adjustedAngle, this.selectedFeatureCenter);
              }
              this.hasRotate = true;
            }
            
            previousMousePosition = mousePosition;

            this.createShapeBoundingBox(feature);

            this.updateDebugShapeBoundingBoxFeature();
          }
        }
      } else {
        if (cb && typeof cb === 'function') {
          cb(evt);
        }
      }
      
    });
  }

  getPointFeature(location , image, name, id, relatedAsset, color, layerDisplayOnly, tooltip, anchor, type, layerName) {
    const graphPoint = new Feature(new Point(location));
    if (arguments.length === 2) {
      graphPoint.setProperties({
        icon: image
      });
    } else {
      const properties: any = {
        icon : image,
        name,
        id
      };
      if (color) {properties.color = color; }
      if (tooltip) {properties.tooltip = tooltip; }
      if (layerDisplayOnly) {properties.layerDisplayOnly = layerDisplayOnly; }
      if (type) {properties.type = type; }
      if (anchor) {properties.anchor = anchor; }
      if (layerName) {properties.layerName = layerName; }
      if (relatedAsset) {
        for (const field in relatedAsset) {
          if (relatedAsset.hasOwnProperty(field)) {
            const value = relatedAsset[field];
            properties[field] = value;
          }
        }
      }
      graphPoint.setProperties(properties);
    }
    return graphPoint;
  }

  drawPointWithAddress(location) {
    let fea = this.parseToPoint(location, null, null);
    fea = this.drawFeature(fea, null, null);
    this.vector.getSource().addFeature(fea);
  }
  drawMultiPointWithAddress(location) {
    let fea = this.parseToMultiPoint([location], null, null);
    fea = this.drawFeature(fea, null, null);
    this.vector.getSource().addFeature(fea);
  }
  drawLineStringWithAddress(location, hasUpdateSketch) {
    if (this.sketch) {
      this.draw.appendCoordinates([location]);
      if (this.drawTypeSpecific === MapDrawTypeSpecial.ARROW_AT_FIRST_POINT) {
        this.drawArrowAtFirst();
      }
    } else {
      this.sketchPoints.push(location);
      if (this.sketch == null) {
        if (this.sketchPoints.length == 1) {
          this.sketch = this.parseToLine(this.sketchPoints, null, null);
          this.sketch = this.drawFeature(this.sketch, null, null);
          this.draw.extend(this.sketch);

        }
      } else {
        // update geom
        hasUpdateSketch = true;

        const geometry = this.sketch.getGeometry();
        const coordinates = geometry.getCoordinates();

        coordinates.push(location);
        geometry.setCoordinates(coordinates);
        this.sketch.setGeometry(geometry);
      }
    }
    return hasUpdateSketch;
  }

  drawPolygonWithAddress(location, hasUpdateSketch) {
    if (this.sketch) {
      this.draw.appendCoordinates([location]);
    } else {
      if (this.sketchPoints.length == 0) {
        this.sketchPoints.push(location);
        this.sketchPoints.push(location);
      } else {
        this.sketchPoints.splice(this.sketchPoints.length - 1, 0, location);
      }

      if (this.sketch == null) {
        if (this.sketchPoints.length == 2) {
          // console.log(`***** create new POLYGON`);
          
          this.sketch = this.parseToPolygon([this.sketchPoints], null, null);

          this.sketch = this.drawFeature(this.sketch, null, null);
          this.draw.extend(this.sketch);
        }
      } else {
        hasUpdateSketch = true;
        
        const geometry = this.sketch.getGeometry();
        const coordinates = geometry.getCoordinates();

        coordinates[0].splice(coordinates[0].length - 1, 0, location);
        geometry.setCoordinates(coordinates);
        this.sketch.setGeometry(geometry);
      }
    }
    return hasUpdateSketch;
  }
  drawCircleWithAddress(location) {
    this.sketchPoints.push(location);
    if (this.sketch == null) {
      if (this.sketchPoints.length == 1) {
        this.draw.appendCoordinates([location]);
      }
    } else {
      if (this.sketchPoints.length < 2) {
        this.sketchPoints.push(this.sketch.getGeometry().getCenter());
      }
      const radius = sclUtilMap.totalLen(this.sketchPoints);
      this.sketch.getGeometry().setRadius(radius);
      this.sketchPoints = [];
      this.draw.finishDrawing();
    }
  }
  drawSquareWithAddress(location) {
    this.sketchPoints.push(location);
    if (this.sketch == null) {
      if (this.sketchPoints.length == 1) {
        this.draw.appendCoordinates([location]);
      }
    } else {
      if (this.sketchPoints.length < 2) {
        const firstPoint = this.sketch.getGeometry().getCoordinates();
        this.sketchPoints.push(firstPoint[0][0]);
      }
      const radius = sclUtilMap.totalLen(this.sketchPoints);
      const x = this.sketchPoints[1][0] - this.sketchPoints[0][0];
      const y = this.sketchPoints[1][1] - this.sketchPoints[0][1];
      const angle = Math.atan2(y, x);

      makeRegular(this.sketch.getGeometry(), this.sketchPoints[0], radius, angle);

      this.sketchPoints = [];
      this.draw.finishDrawing();
    }

  }

  drawBoxWithAddress(location) {
    this.sketchPoints.push(location);
    if (this.sketch == null) {
      if (this.sketchPoints.length == 1) {
        this.draw.appendCoordinates([location]);
      }
    } else {
      if (this.sketchPoints.length < 2) {
        const firstPoint = this.sketch.getGeometry().getCoordinates();
        this.sketchPoints.unshift(firstPoint[0][0]);
      }
      const point3 = [this.sketchPoints[0][0], this.sketchPoints[1][1]];
      const point4 = [this.sketchPoints[1][0], this.sketchPoints[0][1]];
      
      const newCoords = [
        this.sketchPoints[0],
        point3,
        this.sketchPoints[1],
        point4,
        this.sketchPoints[0]
      ];
      this.sketch.getGeometry().setCoordinates([newCoords]);
      this.draw.finishDrawing();
    }
  }

  updateLocation(lat, lon, id, image, name, proId, isMapClick) {
    const location = proj.transform([lon, lat], SclMapConstantService.EPSG_4326, this.EPSG);

    if (this.mapType === MapComponentName.BOUNDARY
       && this.drawType != null) {
      this.hasDocumentChangeValue = false;
      let hasUpdateSketch = false;
      switch(this.drawType) {
        case MapDrawType.POINT:
          this.drawPointWithAddress(location);
          break;
        case MapDrawType.MULTI_POINT:
          this.drawMultiPointWithAddress(location);
          break;
        case MapDrawType.LINE_STRING:
        case MapDrawType.MULTI_LINE_STRING:
          hasUpdateSketch = this.drawLineStringWithAddress(location, hasUpdateSketch);
          break;
        case MapDrawType.POLYGON:
        case MapDrawType.MULTI_POLYGON:
          hasUpdateSketch = this.drawPolygonWithAddress(location, hasUpdateSketch);
          break;
        case MapDrawType.CIRCLE:
          this.drawCircleWithAddress(location);
          break;
        case MapDrawType.SQUARE:
          this.drawSquareWithAddress(location);
            break;
        case MapDrawType.BOX:
          this.drawBoxWithAddress(location);
            break;
        case MapDrawType.TEXT:
          this.drawTextBox(location, [lon, lat]);
          break;
        default: break;
      }
      

      if (hasUpdateSketch && typeof this.setDirtyFunction === 'function') {
        this.setDirtyFunction();
      }
    } else {
      // add address marker
      
      if (isMapClick === false) {
        this.view.setCenter(location);
        this.view.setResolution(1);
      }

      if (proId != null && this.marker != null && this.marker.getId() === proId) {
        // let checkFeature = this.getFeatureById(proId);//13835 // this.source.getFeatureById(proId);
        // if(checkFeature){
        //    this.removeFeature(checkFeature);//13835 //this.source.removeFeature(checkFeature);
        //    this.removeFeature(this.marker);
        //    this.marker = null;
        // }
        this.marker.getGeometry().setCoordinates(location);
      } else {
        if (typeof image === 'string') {
          if (image.trim().length == 0) {
            image = SclMapConstantService.MAP_MARKER;
          } else {
            image = this.sclUtilMapService.handleImageFileNo(image);
          }
        } else {
          console.log(`**** image is not a string, image = `, image);
        }
        this.marker = this.getPointFeature(location, image, name, proId, null, null, null, null, null, null, null);

        this.marker.setId(proId);

        // this.source.addFeature(this.marker);//13835
        this.marker.setStyle(this.stylePinAddress(this.marker)); // 15886: set static style instead of using style from layer to prevent high CPU
        this.layerAssets[this.layerIndexAddress].getSource().addFeature(this.marker);
      }
    }

    
  }

  removeLocation(feature) {
    if (feature && this.layerAssets[this.layerIndexAddress] && this.layerAssets[this.layerIndexAddress].getSource()) {
      this.layerAssets[this.layerIndexAddress].getSource().removeFeature(feature);
    }
    this.marker = null;
  }

  zoomToLocation(lat, lon) {
    // let currentZoom = Math.round(this.view.getZoom()); // debug
    // console.log(`**** zoom to location, current zoom BEFORE = ${currentZoom}`); // debug

    const location = proj.transform([lon, lat], SclMapConstantService.EPSG_4326, this.EPSG);
    this.view.setCenter(location);
    
    // currentZoom = Math.round(this.view.getZoom()); // debug
    // console.log(`**** zoom to location, current zoom AFTER = ${currentZoom}`); // debug
  }

  zoomToValue(zoomValue) {
    // if (!zoomValue && this.defaultZoom ) { zoomValue = this.defaultZoom; }// 14707
    if (zoomValue) {
      this.view.setZoom(zoomValue);
    }

  }
  // 14781
  centerDefault() {
    this.zoomToLocation(this.defaultLat, this.defaultLon);
  }
  // 14781
  fitLayers(layersIndexFit, hasDefaultCoord) {
    const extent = olExtent.createEmpty();
    if (hasDefaultCoord) {
      const location = proj.transform([this.defaultLon, this.defaultLat], SclMapConstantService.EPSG_4326, this.EPSG);
      const fExtent = [location[0], location[1], location[0], location[1]];
      olExtent.extend(extent, fExtent);
    }
    let padding = 0; // 15141: #4
    for (let i = 0; i < layersIndexFit.length; i++) {
        const idx = layersIndexFit[i];
        if (!this.layerAssets[idx].getSource()) { continue; }
        const fs = this.layerAssets[idx].getSource().getFeatures();
        if (fs == null || fs.length === 0) { continue; }

        this.layerAssets[idx].getSource().getFeatures().forEach(function(feature) {
          const fExt = feature.getGeometry().getExtent();
          olExtent.extend(extent, fExt);
          if (feature.getGeometry().getType() === MapDrawType.POINT) {
            padding = 32; // 15141: #4
          }
        }.bind(this));
    }
    if (extent !== null && extent.length === 4 && isFinite(extent[0]) && isFinite(extent[1])
     && isFinite(extent[2]) && isFinite(extent[3]) ) {
      // console.log(`%c **** fitLayers, FIT`, 'color:red');
      // console.log(`\t\t padding = `, padding);
      this.view.fit(extent, {padding: [padding, padding, padding, padding]}); // 15141: #4
    }
    // setInterval(() => {
    const currentZoom = Math.round(this.view.getZoom());
    this.view.setZoom(currentZoom);
    // }, 200);
    
  }

  createMarkerAsset(lat, lon, id, image, name , type) {
    const location = proj.transform([lon, lat], SclMapConstantService.EPSG_4326, this.EPSG);


    const f = this.getPointFeature(location, image, name, id, null, null, null, null, null, null, null);
    if (type) { f.set('assetType', type); }
    f.setId(id);
    
    // this.source.addFeature(f);//13835
    if (type === MapSelectAssetType.PRIMARY) {
      f.setStyle(this.stylePrimaryAssetFunc(f, null));
      this.layerAssets[this.layerIndexPrimary].getSource().addFeature(f);
      this.storeSelectedAssets(f, true);
    } else if (type === MapSelectAssetType.SECONDARY) {
      f.setStyle(this.styleSecondaryAssetFunc(f, null));
      this.layerAssets[this.layerIndexSecondary].getSource().addFeature(f);
      this.storeSelectedAssets(f, false);
    } else { 
      f.setStyle(this.stylePinAddress(f));
      this.layerAssets[this.layerIndexAddress].getSource().addFeature(f); 
    }

    

    return location;
  }
  getGEOJSON(cb) {
    const features = this.vector.getSource().getFeatures();
    // console.log(`***** getGEOJSON, features.len = ${features?.length}, features = `, features);
    const format = new GeoJSON();
    if (this.mapType === MapComponentName.BOUNDARY) {// sc-boundary
      const fp = SclMapConstantService.EPSG_4326;
      const data = format.writeFeaturesObject(features, {featureProjection: this.EPSG, dataProjection: fp });
      const finalData = { type: GEOJSON_TYPE.FEATURE_COLLECTION, features: [] };
      const multiPoint = { type: FEATURE_TYPE.FEATURE, properties: null, geometry: { type: MapDrawType.MULTI_POINT, coordinates: []}};
      const multiPolygon = {type: FEATURE_TYPE.FEATURE, properties: null, geometry: {type: MapDrawType.MULTI_POLYGON, coordinates: []}};
      const multiLineString = {type: FEATURE_TYPE.FEATURE, properties: null, geometry: {type: MapDrawType.MULTI_LINE_STRING, coordinates: []}};
      const sharedIdGroups: Record<string, any> = {};
      
      // console.log(`***** getGEOJSON, data = `, data);

      for (let i = 0; i < data.features.length; i++) {
        const geom: any = data.features[i].geometry;
        const props = data.features[i].properties;
        if (!geom || props?.isDebug == true) { continue; }

        let emptyProperty = false;
        if (data.features[i].properties == null ||
           this.isEmptyObject(data.features[i].properties)) {
          delete data.features[i].properties;
          emptyProperty = true;
        }

        const sharedId = props?.sharedId;

        if (typeof sharedId === 'string') {
          if (!sharedIdGroups[sharedId]) {
            sharedIdGroups[sharedId] = {
              type: FEATURE_TYPE.GEOMETRY_COLLECTION,
              properties: { ...props },
              geometries: []
            };
          }

          if (geom.type === FEATURE_TYPE.GEOMETRY_COLLECTION && props?.subType === MapDrawType.CIRCLE) {
            const circleGeom = features[i].getGeometry();
            const radius = circleGeom.getRadius();
            let center = circleGeom.getCenter();
            center = proj.transform(center, this.EPSG, SclMapConstantService.EPSG_4326);
            if (this.isDrawCircleAsPolygon) {
              const coords = sclUtilMap.circleToPolygon(center, radius);
              sharedIdGroups[sharedId].geometries.push({
                type: MapDrawType.POLYGON,
                coordinates: coords
              });
            } else {
              sharedIdGroups[sharedId].geometries.push({
                type: MapDrawType.POINT,
                coordinates: center
              });
            }
          } else {
            sharedIdGroups[sharedId].geometries.push(geom);
          }

        } else {
          if (geom.type === MapDrawType.MULTI_POINT) {
            for (let j = 0; j < geom.coordinates.length; j++) {
              multiPoint.geometry.coordinates.push(geom.coordinates[j]);
            }
            if (emptyProperty == false) {
              multiPoint.properties = data.features[i].properties;
            }
            
          } else if (geom.type === MapDrawType.MULTI_POLYGON) {
            for (let j = 0; j < geom.coordinates.length; j++) {
              multiPolygon.geometry.coordinates.push(geom.coordinates[j]);
            }
            if (emptyProperty == false) {
              multiPolygon.properties = data.features[i].properties;
            }
          } else if (geom.type === MapDrawType.MULTI_LINE_STRING) {
            for (let j = 0; j < geom.coordinates.length; j++) {
              multiLineString.geometry.coordinates.push(geom.coordinates[j]);
            }
            if (emptyProperty == false) {
              multiLineString.properties = data.features[i].properties;
            }
          } else if (geom.type === FEATURE_TYPE.GEOMETRY_COLLECTION) {
            // console.log(`***** getGEOJSON, circle here`);
            const geom = features[i].getGeometry();
            const radius = geom.getRadius();
            let center = geom.getCenter();
            center = proj.transform(center, this.EPSG, SclMapConstantService.EPSG_4326);
            const shapeJson: any = {
              type: FEATURE_TYPE.FEATURE,
              geometry: {},
              properties: {
                radius,
                subType: MapDrawType.CIRCLE,
              }
            };
            if (this.isDrawCircleAsPolygon) {
              const coords = sclUtilMap.circleToPolygon(center, radius);
              shapeJson.geometry.type = MapDrawType.POLYGON;
              shapeJson.geometry.coordinates = coords;
            } else {
              shapeJson.geometry.type = MapDrawType.POINT;
              shapeJson.geometry.coordinates = center;
            }
            for (let key in data.features[i].properties) {
              shapeJson.properties[key] = data.features[i].properties[key];
            }
            finalData.features.push(shapeJson);
            // console.log(`*** shapeJson = `, shapeJson );
            // console.log(JSON.stringify(shapeJson) );
          } else if (geom.type === MapDrawType.LINE_STRING
             && typeof data.features[i].properties?.textId === 'string'
             && data.features[i].properties?.textId.trim().length > 0) {
            continue; // ignore short line that draws from the click point to the top left corner of the box 
          } else {
            finalData.features.push(data.features[i]);
          }
        }

        
      }
      if (multiPoint.geometry.coordinates.length > 0) {
        finalData.features.push(multiPoint);
      }
      if (multiPolygon.geometry.coordinates.length > 0) {
        finalData.features.push(multiPolygon);
      }
      if (multiLineString.geometry.coordinates.length > 0) {
        finalData.features.push(multiLineString);
      }

      for (const key in sharedIdGroups) {
        const group = sharedIdGroups[key];
        delete group.properties.sharedId;

        finalData.features.push(group);
      }

      if (cb && typeof cb === 'function') {
        cb(finalData);
      }
    } else {
      const data = format.writeFeaturesObject(features);
      if (cb && typeof cb === 'function') {
        cb(data);
      }
    }
  }

  transformEPSG(long, lat, from, to) {
    const location = proj.transform([parseFloat(long), parseFloat(lat)], from, to);
    return location;
  }

  checkMapEmpty(pCanvas) {
    if (pCanvas == null) { return; }
    try {
      const ctx = pCanvas.getContext('2d');
      const imageData = ctx.getImageData(0, 0, pCanvas.width, pCanvas.height);
      const data = imageData.data;
      const imageDataLength = data.length;

      let totalAlpha = 0; let countTransparent = 0;
      for (let i = 3; i < imageDataLength; i += 4) {
        totalAlpha++;
        if (data[i] === 0) { countTransparent++; }
      }
      if (totalAlpha === countTransparent && totalAlpha > 0) {
        // console.log('%c map is empty', 'color:green');
        // if(NotificationService) NotificationService.warning('The map is empty !');
        if (this.fromFitData) {
          console.log('We have no map tiles to display.  '
          + 'Your map is centered at LAT, LONG which may not be with in your map tile service.'
          + '  Please check that location and the data you are trying to display.');
        }
      }
      this.fromFitData = false;
    } catch (err) {
      if (this.checkMapEmptyLogError) {
        console.log('*** checkMapEmpty error = ', err);
      } else {
        console.log(`checkMapEmpty error - Not all tiles yet drawn`);
      }
      
    }

  }

  fit(ConfigService, maxZoom, initialZoomChange, isCheckEmpty) {
    // console.log('OL, fit');

    if (this.mapType !== MapComponentName.ADDRESS_MAP) {
      let maxZoom1 = 15;
      if (maxZoom) { maxZoom1 = maxZoom;
      } else {
        if (ConfigService.clientConfig().maxZoomLevel) {
          maxZoom1 = ConfigService.clientConfig().maxZoomLevel;
        }
      }
      const featuresExtent = this.source.getExtent() ;
      if (featuresExtent != null && featuresExtent.length === 4 && isFinite(featuresExtent[0]) && isFinite(featuresExtent[1])
        && isFinite(featuresExtent[2]) && isFinite(featuresExtent[3]) ) {
          // console.log(`%c **** fit, FIT 1`, 'color:red');
        this.view.fit(featuresExtent, {size: this.map.getSize(), maxZoom1});
      }
      if (this.layerAssets != null && this.layerAssets.length > 0) {
        for (let i = 0; i < this.layerAssets.length; i++) {
          const extent = this.layerAssets[i].getSource().getExtent();
          if (extent != null && extent.length === 4 && isFinite(extent[0]) && isFinite(extent[1]) && isFinite(extent[2]) &&
            isFinite(extent[3]) ) {
              // console.log(`%c **** fit, FIT 2`, 'color:red');
            this.view.fit(extent, this.map.getSize());
          }
        }
      }
    } else {
      const extent = olExtent.createEmpty();
      if (this.layerAssets != null && this.layerAssets.length > 0) {
        for (let i = 0; i < this.layerAssets.length; i++) {
          if (!this.layerAssets[i].getSource()) { continue; }
          const fs = this.layerAssets[i].getSource().getFeatures();
          if (fs == null || fs.length === 0) { continue; }

          this.layerAssets[i].getSource().getFeatures().forEach(function(feature) {
            try {
              olExtent.extend(extent, feature.getGeometry().getExtent());
            } catch (err) {
              console.log(err);
            }
          });

        }
      }
      if (extent != null && extent.length === 4 && isFinite(extent[0]) && isFinite(extent[1]) && isFinite(extent[2]) &&
        isFinite(extent[3]) ) {
        // console.log(`%c **** fit, FIT 3`, 'color:red');
        this.view.fit(extent);
      }

    }
    let currentZoom = Math.round(this.view.getZoom());
    if (initialZoomChange != null && initialZoomChange !== 0) {
      currentZoom += initialZoomChange;
      this.view.setZoom(currentZoom);
    }

    // 13885
    if (this.mapType === MapComponentName.ADDRESS_MAP && currentZoom > 12) {
      this.view.setZoom(12);
    }

    if (isCheckEmpty === undefined || isCheckEmpty === null || isCheckEmpty === true) { 
      // this.checkMapEmpty(this.canvas); 
      this.fromFitData = true;
    }
    // console.log(`%c *** DONE fit`, 'color:red');
    this.clampZoomFloor();
  }

  fitCoords(coords) {
    // calculate bounds base on collection of coordinates
    if (!coords || coords.length === 0) { return; }
    this.bounds = olExtent.createEmpty();
    this.fitCoordCount = coords.length;
    for (let i = 0; i < coords.length; i++) {
      const iCoord = proj.transform(coords[i], SclMapConstantService.EPSG_4326, this.EPSG) ;
      const geom = new Point(iCoord);
      olExtent.extend(this.bounds, geom.getExtent());
    }
    console.log(`%c *** fitCoords, FIT`, 'color:blue');
    // console.log(`\t\t====> zoom BEFORE = ${this.view.getZoom()}, this.bounds = `, this.bounds);
    this.view.fit(this.bounds);
    // console.log(`\t\t====> zoom AFTER = ${this.view.getZoom()}, this.bounds = `, this.bounds);

    let currentZoom = Math.round(this.view.getZoom());
    // console.log(`\t\t====> currentZoom BEFORE = ${currentZoom}, coords.length = ${coords.length}`);
    if (coords.length === 1) {
      currentZoom = currentZoom - 2;
      if (currentZoom < 0) { currentZoom = 1; }
    }
    // console.log(`\t\t====> currentZoom AFTER = ${currentZoom}, coords.length = ${coords.length}`);
    this.view.setZoom(currentZoom);
    // console.log(`\t\t====> zoom AFTER 2 = ${this.view.getZoom()}`);
    this.clampZoomFloor();
  }

  mapReadOnly(isReadOnly) {
    if (isReadOnly) {
      this.map.removeInteraction(this.modify);
      this.map.removeInteraction(this.draw);
      this.map.removeInteraction(this.translate);
    } else {
      if (this.actionType) {
        if (this.actionType === MapDrawAction.SELECT) {
          this.map.addInteraction(this.modify);
        } else if (this.actionType !== MapDrawAction.DELETE) {
          this.addInteraction();
        }
      }
    }
  }

  getAllFeatures() {
    let features = [];
    if (this.vector.getSource()) { features = this.vector.getSource().getFeatures(); }
    if (this.layerAssets != null && this.layerAssets.length > 0) {
      for (let i = 0; i < this.layerAssets.length; i++) {
        if (!this.layerAssets[i].getSource()) { continue; }
        const fs = this.layerAssets[i].getSource().getFeatures();
        if (fs != null && fs.length > 0) {
          fs.forEach(function(f) {
            features.push(f);
          });
        }
      }
    }

    return features;
  }

  getFeaturesFromMap(features, pixel, type, assetSelectionsAvailable, sType) {
    const existedFeatures = [];
    
    this.map.forEachFeatureAtPixel(pixel,
      (feature, layer) => {
        if (feature && layer) {
          if (layer.get('isCluster')) {
            const lstFeature = feature.get('features');
            for (let i = 0; i < lstFeature.length; i++) {
              const result = this.getAFeatureFromMap(lstFeature[i], features, type, assetSelectionsAvailable, sType);
              if (result.f) { features.push(result.f); }
              if (result.existedFeature) { existedFeatures.push(result.existedFeature); }
            }
          }
          else {
            const result = this.getAFeatureFromMap(feature, features, type, assetSelectionsAvailable, sType);  
            if (result.f) { features.push(result.f); }
            if (result.existedFeature) { existedFeatures.push(result.existedFeature); }
          }
        }
      });
    // find features in the same layer index with the same sharedId ( if have )
    const existingKeys = new Set<string>();

    for(let i = 0; i < features.length; i++) {
      const pSharedId = features[i].get('sharedId');
      if (typeof pSharedId === 'string') {
        const pId = features[i].get('id');

        const key = `${pSharedId}|${pId}`;
        if (existingKeys.has(key)) {
          continue;
        }
        existingKeys.add(key);

        
        const pLayerIndex = features[i].get('zIndex');
        const lst = this.layerAssets[pLayerIndex].getSource().getFeatures();
        if (lst == null || lst.length === 0) { continue; }
        lst.forEach(f => {
          const fId = f.get('id');
          const fSharedId = f.get('sharedId');
          const fKey = `${fSharedId}|${fId}`;
          
          if (typeof fSharedId === 'string' && fId !== pId && fSharedId === pSharedId
            && !existingKeys.has(fKey)
          ) {
            features.push(f);
            existingKeys.add(fKey);
          }
        });
      }
    }
    


    return existedFeatures;
  }
  getAFeatureFromMap(feature, features, type, assetSelectionsAvailable, sType) {
    let existedFeature, f;
    if (!feature.getProperties() || feature.getProperties().id === undefined) { 
      return {existedFeature, feature}; 
    }
    const p = feature.getProperties();
    // if(p.layerDisplayOnly) return;
    if ( assetSelectionsAvailable == null && p.layerDisplayOnly) { 
      return {existedFeature, feature};
    } else {
      const iAssetSelectionsAvailable = assetSelectionsAvailable[((p.zIndex - 1) < 0 ? 0 : (p.zIndex - 1))];
      if ( iAssetSelectionsAvailable != null && iAssetSelectionsAvailable.indexOf(sType) < 0 ) {
        let sType2 = sType;
        if (sType != null && sType.trim().length > 0) {
          sType = sType.charAt(0).toUpperCase() + ( (sType != null && sType.trim().length > 1 ) ? sType.slice(1) : '' ); }
        console.log('sc-selected-asset: The assetSelectionsAvailable field is not set to allow ' + sType +
          ' selections for this layer');
        return {existedFeature, feature};
      }
    }
    if (p.id === 'address') { return {existedFeature, feature}; }
    if ( (type === MapSelectAssetType.PRIMARY && p.id && p.id.indexOf('_secondary') > -1 )
     || (type === MapSelectAssetType.SECONDARY && p.id && p.id.indexOf('_primary') > -1 ) ) {
       return {existedFeature, feature};
    }
    if (p.assetType !== type) {
      // if (p.assetType.indexOf(type) < 0) {
      let isExist = false;
      for (let i = 0; i < features.length; i++) {
        if (features[i].getProperties().name === p.name) {
          isExist = true;
          break;
        }
      }
      if (!isExist) { f = feature; }
    } else {
      existedFeature = feature;
    }
    return {existedFeature, f};
  }

  getAssetProperties(feature, relatedFields, coordinates, typeAsset, typeSelection) {
    let name = '';
    let id = '';
    let radius = null;
    const p = feature.getProperties();
    if (p) {
      name = p.name;
      id = p.id;
      radius = p.radius;
    }

    const propertiesLinkAsset = {
      documentId: id,
      name
    };
    const asset: any = {
      type: FEATURE_TYPE.FEATURE,
      properties : {
        type: typeAsset,
        linkAssets: []
      }
    };
    if (radius) {
      asset.properties.radius = radius;
      asset.properties.subType = MapDrawType.CIRCLE;
    }

    if (!typeSelection || typeSelection === 'featureCollection') {
      asset.geometry = {
        type : MapDrawType.POINT,
        coordinates
      };
    } else if (typeSelection !== 'undefined'
     && typeSelection === MapSelectAssetMode.ASSET) {
      let t = feature.getGeometry().getType();
      if ( t == MapDrawType.CIRCLE) { t = MapDrawType.POINT; }
      asset.geometry = {
        type : t,
        coordinates
      };
    }

    if (!id) {
      return '';
    }
    if (relatedFields) {
      for (const field in relatedFields) {
        if (relatedFields.hasOwnProperty(field)) {
          const value = p[field];
          if (value) {
            propertiesLinkAsset[field] = value;
          }
        }
      }
    }
    asset.properties.linkAssets.push(propertiesLinkAsset);
    return asset;
  }

  removeUnselectedAssetItem(existAsset, assets, assetType) {
    if (existAsset) {
      let isExist = false;
      let idExistAsset = existAsset.properties.linkAssets[0].documentId;
      if (idExistAsset && idExistAsset.indexOf('_') > -1) { idExistAsset = idExistAsset.split('_')[0]; }
      for (let j = 0; j < assets.length; j++) {
        const item = assets[j];
        let idItem = item.properties.linkAssets[0].documentId;
        if (idItem == null) { continue; }
        if (idItem.indexOf('_') > -1) { idItem = idItem.split('_')[0]; }
        const id = item.properties.linkAssets[0].documentId + '_' + assetType;
        if (idItem === idExistAsset) {
          assets.splice(j, 1);
          isExist = true;
        }
      }
      const len = this.selectedAssets.length;
      for (let i = len - 1; i > -1; i--) {
        let iId = this.selectedAssets[i].getId();
        if (iId && iId.indexOf('_') > -1) { iId = iId.split('_')[0]; }
        if (iId === idExistAsset) {
          const f = this.selectedAssets[i];
          if (f == null || f.getId() == null) { continue; }
          if (assetType === MapSelectAssetType.PRIMARY) {
            const source = this.layerAssets[this.layerIndexPrimary].getSource();
            const fea = source.getFeatureById(f.getId());
            if (fea && source) {
              source.removeFeature(fea);
              this.selectedAssets.splice(i, 1);
            }
          } else if (assetType === MapSelectAssetType.SECONDARY) {
            const source = this.layerAssets[this.layerIndexSecondary].getSource();
            const fea = source.getFeatureById(f.getId());
            if (fea && source) {
              source.removeFeature(fea);
              this.selectedAssets.splice(i, 1);
            }
          }

          isExist = true;
        }
      }
      return isExist;
    }
    return false;
  }

  parseAssetsFromFeatures(features, assetField, coor, typeAsset, mode) {
    if (mode === MapSelectAssetMode.ASSET
       || !Array.isArray(features)) {
      const asset = this.getAssetProperties(features, assetField.relatedFields, coor, typeAsset, mode);
      return asset;
    } else {
      const assets = [];
      for (let i = 0; i < features.length; i++) {
        const asset = this.getAssetProperties(features[i], assetField.relatedFields, coor[i], typeAsset, null);
        if (!asset) { continue; }
        const sharedId = features[i].get('sharedId');
        if (typeof sharedId === 'string') {
          if (assets.length === 0) {
            asset.type = FEATURE_TYPE.GEOMETRY_COLLECTION;
            asset.geometries = [
              asset.geometry
            ];
            delete asset.geometry;
            assets.push(asset);
          } else {
            assets[0].geometries.push(asset.geometry);
            delete asset.geometry;
          }
        } else {
          assets.push(asset);
        }
        
      }
      return assets;
      
    }
    
  }

  getAllFeaturesSelected() {
    if (this.selectMultiple) {
      return this.selectMultiple.getFeatures();
    } else { return []; }
  }

  addInteractionSelect(currentSelected) {
    if (this.selectMultiple) {
      this.map.addInteraction(this.selectMultiple);
    }
  }

  removeInteractionSelect() {
    if (this.selectMultiple) {
      this.map.removeInteraction(this.selectMultiple);
    }
  }

  showLayer(options) {
    if (options.isShow) {
      this.layerAssets[options.layerIndex].setVisible(true);
    } else {
      this.layerAssets[options.layerIndex].setVisible(false);
    }
  }

  activeInteractionSelect(isActive) {
    if (this.selectMultiple) {
      this.selectMultiple.setActive(isActive);
    }
  }

  drawActionDelete(evt) {
    this.map.forEachFeatureAtPixel(evt.pixel, (f, l) => {
      if (!f) { return; }
      const p = f.getProperties();
      if (p && p.zIndex) { return; }
      this.vector.getSource().removeFeature(f);
      if (typeof p.dimensionId === 'string') {
        const ov = this.map.getOverlayById(p.dimensionId);
        if (ov) {
          this.map.removeOverlay(ov);
        }
      }
      this.hasDocumentChangeValue = false;
      if (this.mapType === MapComponentName.BOUNDARY && typeof this.setDirtyFunction === 'function' ) {
        this.setDirtyFunction();
      }
    });
  }

  drawActionProperties(evt) {
    const feature = this.map.forEachFeatureAtPixel(evt.pixel,
      function(feature1, layer) {
        return feature1;
      });
  }

  setPointProperties(relatedAsset, color, layerDisplayOnly, tooltip, anchor, type, layerName, url) {
    const properties: any = {};

    if (color) {properties.color = color; }
    if (tooltip) {properties.tooltip = tooltip; }
    if (layerDisplayOnly) {properties.layerDisplayOnly = layerDisplayOnly; }
    if (type) {properties.type = type; }
    if (anchor) {properties.anchor = anchor; }
    if (layerName) {properties.layerName = layerName; }
    if (url) {properties.url = url; }
    if (relatedAsset) {
      for (const field in relatedAsset) {
        if (relatedAsset.hasOwnProperty(field)) {
          const value = relatedAsset[field];
          properties[field] = value;
        }
      }
    }
    return properties;
  }

  sclAssetLayersGetPointFeature(location , image, name, id, relatedAsset, color, layerDisplayOnly, tooltip
    , anchor, type, layerName, url) {
    let graphPoint;
    if (type === MapDrawType.MULTI_POINT) { graphPoint = new Feature(new MultiPoint(location));
    } else { graphPoint = new Feature(new Point(location)); }

    const properties: any = this.setPointProperties(relatedAsset, color, layerDisplayOnly, tooltip, anchor
      , type, layerName, url);
    properties.icon = image;
    properties.name = name;
    properties.id = id;
    

    graphPoint.setProperties(properties);

    return graphPoint;
  }

  parseToLine(coor, id, toEPSG) {
    const feature = new Feature(new LineString(coor));
    if (typeof toEPSG == 'string' && toEPSG.trim().length > 0) {
      feature.getGeometry().transform(SclMapConstantService.EPSG_4326, toEPSG);
    }
    
    if (id) {
      feature.setId(id);
    }
    return feature;
  }

  parseToMultiLine(coor, id, toEPSG) {
    const feature = new Feature(new MultiLineString(coor));
    if (typeof toEPSG == 'string' && toEPSG.trim().length > 0) {
      feature.getGeometry().transform(SclMapConstantService.EPSG_4326, toEPSG);
    }
    if (id) {
      feature.setId(id);
    }
    return feature;
  }

  parseToPolygon(coor, id, toEPSG) {
    const feature = new Feature(new Polygon(coor));
    if (typeof toEPSG == 'string' && toEPSG.trim().length > 0) {
      feature.getGeometry().transform(SclMapConstantService.EPSG_4326, toEPSG);
    }
    if (id) {
      feature.setId(id);
    }
    return feature;
  }

  parseToMultiPolygon(coor, id, toEPSG) {
    const feature = new Feature(new MultiPolygon(coor));
    if (typeof toEPSG == 'string' && toEPSG.trim().length > 0) {
      feature.getGeometry().transform(SclMapConstantService.EPSG_4326, toEPSG);
    }
    if (id) {
      feature.setId(id);
    }
    return feature;
  }

  parseToPoint(coor, id, toEPSG) {
    const feature = new Feature(new Point(coor));
    if (typeof toEPSG == 'string' && toEPSG.trim().length > 0) {
      feature.getGeometry().transform(SclMapConstantService.EPSG_4326, toEPSG);
    }
    if (id) {
      feature.setId(id);
    }
    return feature;
  }

  parseToMultiPoint(coor, id, toEPSG) {
    const feature = new Feature(new MultiPoint(coor));
    if (typeof toEPSG == 'string' && toEPSG.trim().length > 0) {
      feature.getGeometry().transform(SclMapConstantService.EPSG_4326, toEPSG);
    }
    if (id) {
      feature.setId(id);
    }
    return feature;
  }
  parseToCircle(coor, radius, id, toEPSG) {
    const feature = new Feature(new CircleShape(coor, radius));

    if (typeof toEPSG == 'string' && toEPSG.trim().length > 0) {
      feature.getGeometry().transform(SclMapConstantService.EPSG_4326, toEPSG);
    }
    if (id) {
      feature.setId(id);
    }
    return feature;
  }

  sclAssetLayersCreateFeatureByType(coordinates, type, EPSG, id) {
    let feature;
    if (type === MapDrawType.POINT) {
      feature = this.parseToPoint(coordinates, id, EPSG);
    } else if (type === MapDrawType.MULTI_POINT) {
      feature = this.parseToMultiPoint(coordinates, id, EPSG);
    } else if (type === MapDrawType.LINE_STRING) {
      feature = this.parseToLine(coordinates, id, EPSG);
    } else if (type === MapDrawType.MULTI_LINE_STRING) {
      feature = this.parseToMultiLine(coordinates, id, EPSG);
    } else if (type === MapDrawType.POLYGON) {
      feature = this.parseToPolygon(coordinates, id, EPSG);
    } else if (type === MapDrawType.MULTI_POLYGON) {
      feature = this.parseToMultiPolygon(coordinates, id, EPSG);
    }

    return feature;
  }

  traverseCoor(coor, obj) {
    if (Array.isArray(coor)) {
      for (let i = 0; i < coor.length; i++) {
        if (Array.isArray(coor[i])) {
          this.traverseCoor(coor[i], obj);
        } else {
          if (isNaN(coor[i]) ) { obj.hasNaN = true; } else { coor[i] = Number(coor[i]); }
        }
      }
    }
  }

  createFeatureCircle(coord, type, options) {
    
    const relatedAssets = (options.relatedAsset ? options.relatedAsset : '');
    const url = (options.url ? options.url : '');
    const primaryMultiPopup = (options.primaryMultiPopup ? options.primaryMultiPopup : '');
    const secondaryMultiPopup = (options.secondaryMultiPopup ? options.secondaryMultiPopup : '');

    const lon = Number(coord[0]); const lat = Number(coord[1]) ;
    if (isNaN(lon) || isNaN(lat)) { return null; }

    const center = proj.transform([lon, lat], SclMapConstantService.EPSG_4326, options.EPSG);

    let feature = new Feature(new CircleShape(center, options.radius));

    const p: any = this.setPointProperties(relatedAssets, options.color, options.layerDisplayOnly
      , options.tooltip, null, type, '', url);
    p.name = options.name;
    p.id = options.id;
    p.radius = options.radius;

    if (options.layer) {
      const layer = options.layer;
      if (layer.fill) { p.fillColor = layer.fill; }
      if (isNumber(layer.fillOpacity)) { p.fillOpacity = layer.fillOpacity; }
      if (isNumber(layer.lineWidth)) {p.lineWidth = layer.lineWidth; }
    }
    
    
    if (options.label != null) {
      p.label = options.label;
    }
    p.sharedId = options.sharedId;

    feature.setProperties(p);
    feature.setId(options.id);
    return feature;
  }

  createFeaturePoint(coord, type, options) {
    let feature;
    const relatedAssets = (options.relatedAsset ? options.relatedAsset : '');
    const url = (options.url ? options.url : '');
    const primaryMultiPopup = (options.primaryMultiPopup ? options.primaryMultiPopup : '');
    const secondaryMultiPopup = (options.secondaryMultiPopup ? options.secondaryMultiPopup : '');

    const lon = Number(coord[0]); const lat = Number(coord[1]) ;
    if (isNaN(lon) || isNaN(lat)) { return null; }

    const location = proj.transform([lon, lat], SclMapConstantService.EPSG_4326, options.EPSG);

    let point = SclMapConstantService.MAP_MARKER;
    if (options.point) { point = options.point; }
    if (options.imageFileNo) {
      if (options.imageFileNo === SclMapConstantService.MAP_MARKER
        || options.imageFileNo === SclMapConstantService.MAP_PRIMARY_ASSET
        || options.imageFileNo === SclMapConstantService.MAP_SECONDARY_ASSET) {
        point = options.imageFileNo;
      } else { 
        point = options.imageFileNo; // 15783 '/api/getFile/' + options.imageFileNo; 
      }
    }
    if (options.image) { point = options.image; }
    feature = this.sclAssetLayersGetPointFeature(location, point, options.name, options.id, relatedAssets,
      options.color, options.layerDisplayOnly,
      options.tooltip, options.anchor, '', '', url);
    const p = feature.getProperties();
    if (options.layerType === 'cluster') {
      p.isCluster = true;
    }
    if (options.label != null) {
      p.label = options.label;
    }
    if (options.rotation) { p.rotation = options.rotation; }
    if (options.scale) {p.scale = options.scale; }
    if (options.sharedId) {p.sharedId = options.sharedId; }

    feature.setProperties(p);
    feature.setId(options.id);
    return feature;
  }

  createFeatureByType(coord, type, options) {
    let feature;
    const relatedAssets = (options.relatedAsset ? options.relatedAsset : '');
    const url = (options.url ? options.url : '');
    const primaryMultiPopup = (options.primaryMultiPopup ? options.primaryMultiPopup : '');
    const secondaryMultiPopup = (options.secondaryMultiPopup ? options.secondaryMultiPopup : '');
    const radius = options.radius;

    if (type === MapDrawType.POINT) {
      if (radius) {
        feature = this.createFeatureCircle(coord, type, options);
      } else {
        feature = this.createFeaturePoint(coord, type, options);
      }
      
    } else {
      if (options.layerType === 'cluster') {
        type = MapDrawType.POINT;
        const centerPoint = options.centerPoint;
        delete options.centerPoint;
        feature = this.createFeaturePoint(centerPoint, type, options);
      } else {
        const hasNaN = false;
        const obj = { hasNaN};
        this.traverseCoor(coord, obj);
        if (obj.hasNaN) { return null; }
  
        feature = this.sclAssetLayersCreateFeatureByType(coord, type, options.EPSG, options.id);
  
        if (feature == null) { return null; }
  
        let color = 'purple';
        // Changed to use color setup in selected asset for handlebars
        if (options.color) {color = options.color; }
        const properties: any = sclAssetLayers.createLineProperties(options.layer, options.name, color,
          options.id, options.tooltip, primaryMultiPopup, secondaryMultiPopup,
          options.layerDisplayOnly, relatedAssets, url, options.sharedId);
        if (options.label != null) { properties.label = options.label; }
        
        feature.setProperties(properties);
      }
      
    }
    return feature;
  }

  setFeatureProperties(feature, properties) {
    for (const p in properties) {
      if (properties.hasOwnProperty(p)) {
        feature.set(p, properties[p]);
      }
    }
  }

  resetFeatureProperties(feature, properties) {
    feature.setProperties(properties);
  }

  getFeatureProperty(feature, propertyName) {
    const pros = feature.getProperties();
    return pros[propertyName];
  }

  getFeatureProperties(feature, fieldNames) {
    const p = {};
    const pro = feature.getProperties();
    for (let i = 0; i < fieldNames.length; i++) {
      p[fieldNames[i]] = pro[fieldNames[i]];
    }
    return p;
  }

  getFeatureId(feature) {
    return feature.getId();
  }

  setFeatureId(feature, id) {
    feature.setId(id);
  }

  getFeatureGeomType(feature) {
    const geom = feature.getGeometry();
    const type = geom.getType();
    return type;
  }

  getFeatureById(id) {
    let f = null;
    for (let i = 0; i < this.layerAssets.length; i++) {
      if (!this.layerAssets[i].getSource()) { continue; }
      if (this.layerAssets[i].get('isCluster') ) {
        const src = this.layerAssets[i].getSource().getSource();
        f = src.getFeatureById(id);
      } else {
        f = this.layerAssets[i].getSource().getFeatureById(id);
      }
      
      if (f != null) { break; }
    }
    return f;
  }

  getFeatureByLayer(id, layerIndex) {
    if (layerIndex > this.layerAssets.length - 1) { return null; }
    let f = null;
    if (!this.layerAssets[layerIndex].getSource()) { return null; }
    f = this.layerAssets[layerIndex].getSource().getFeatureById(id);
    return f;
  }

  getFeatureByPixel(pixel) {
    return this.map.forEachFeatureAtPixel(pixel, function(feature, layer) {
      if (layer == null) {
        return null;
      } else {
        if (layer.get('isCluster')) {
          const fs = feature.get('features');
          if (fs && fs.length > 0) {
            return { feature: fs[0], layerIdx: layer.getZIndex()};
          } else {
            return { feature: null, layerIdx: layer.getZIndex()};
          }
        } else {
          return { feature, layerIdx: layer.getZIndex()};
        }
      }
    }, {
      hitTolerance: 10
    });
  }

  featureClone(fea, layerIndex) {
    const fClone = fea.clone();
    const pClone = fClone.getProperties();
    pClone.id = this.getFeatureId(fea);
    pClone.zIndex = layerIndex;
    fClone.setProperties(pClone);
    fClone.setId(pClone.id);
    return fClone;
  }

  getEventByPixel(pixel) {
    return this.map.getEventPixel(pixel);
  }

  getFeaturesCollection(options) {
    let fs = [];
    this.map.forEachFeatureAtPixel(options.pixel, (feature, layer) => {
      if (layer && !layer.get('isHeatMap') && layer.get('layerDisplayOnly') === false) { // 13521
        const layerIdx = layer.getZIndex();
        if (layerIdx && layerIdx < this.layerAssets.length) {
          if (this.layerAssets[layerIdx].get('isCluster')) {
            const lst = this.layerAssets[layerIdx].getSource().getSource().getFeatures();
            const p = feature.getProperties();
            const lstClicked = p.features;
            for (let i = 0; i < lstClicked.length; i++) {
              fs.push({feature: lstClicked[i], layerIdx: layerIdx });
              const fId = this.getFeatureId(lstClicked[i]);
              let id = fId;
              if (id.indexOf('_') > -1) { id = id.split('_')[0]; }
              for (let j = 0; j < lst.length; j++) {
                const jId = this.getFeatureId(lst[j]);
                if (jId === fId) { continue; }
                if (jId.indexOf(id) > -1) {
                  fs.push({ feature: lst[j], layerIdx: layerIdx });
                }
              }
            }
          } else if (this.layerAssets[layerIdx].getSource()) {
            const id = feature.getId();
            if (id) {
              fs.push({feature, layerIdx});
            }
            if (id && id.indexOf('_') > -1) {
              const id0 = id.split('_')[0];
  
              const lst = this.layerAssets[layerIdx].getSource().getFeatures();
              if (lst == null || lst.length === 0) { return fs; }
              lst.forEach((f, j) => {
                const fId = f.getId();
                if (fId && fId.indexOf(id0) > -1 && fId !== id ) {
                  fs.push({feature: f, layerIdx: layer.getZIndex()});
                }
              });
            }
          }
          

          if (typeof options.mode === 'undefined' || options.mode === null) {
            return fs;
          }
        }

      }
    }, {
      hitTolerance: 10
    });
    return fs;
  }

  getFeaturesCollectionId(id) {
    const fs = [];
    for (let i = 0; i < this.layerAssets.length; i++) {
      if (!this.layerAssets[i].getSource()) { continue; }
      const lst = this.layerAssets[i].getSource().getFeatures();
      if (lst == null || lst.length === 0) { continue; }
      lst.forEach(function(f, j) {
        const fId = f.getId();
        if (fId && fId.indexOf(id) > -1) {
          // make sure this feature was not added in array
          let isExist = false;
          for (let k = 0; k < fs.length; k++) {
            if (fs[k].getId() === fId) {
              isExist = true;
              break;
            }
          }
          if (!isExist) { fs.push(f); }
        }
      });
    }
    return fs;
  }

  addFeature(feature, layerIndex) {
    if (feature == null) { return; }
    const p = feature.getProperties();
    p.zIndex = 0;
    if (layerIndex && layerIndex < this.layerAssets.length && this.layerAssets[layerIndex].getSource()) {
      p.zIndex = layerIndex;
      
      if (this.layerAssets[layerIndex].get('isCluster')) {
        const src = this.layerAssets[layerIndex].getSource().getSource();
        src.addFeature(feature);
      } else {
        if (this.mapType === MapComponentName.BOUNDARY
           || this.mapType === MapComponentName.ADDRESS_MAP
            || this.mapType === MapComponentName.STREET_ADDRESS) {
          feature.setStyle(this.styleAddress(feature, null));
        } else if (this.mapType === MapComponentName.SELECTED_ASSET
           && layerIndex !== this.layerIndexPrimary && layerIndex !== this.layerIndexSecondary) { // sc-selected-asset
            feature.setStyle(this.styleAsset(feature, layerIndex));
        }
        this.layerAssets[layerIndex].getSource().addFeature(feature);
      } 
    }
    feature.setProperties(p);
  }

  removeFeature(feature, layerIndex) {
    if (layerIndex) {
      if (layerIndex > this.layerAssets.length || !this.layerAssets[layerIndex].getSource()) { return; }
      this.layerAssets[layerIndex].getSource().removeFeature(feature);
    } else {
      const fId = feature.getId();
      this.removeItemFromMap(fId);
    }
  }

  removeItemFromMap(id) {
    for (let i = 0; i < this.layerAssets.length; i++) {
      if (!this.layerAssets[i].getSource()) { continue; }
      if (this.layerAssets[i].get('isCluster')) {
        const src = this.layerAssets[i].getSource().getSource();
        const f = src.getFeatureById(id);
        if (f) {
          src.removeFeature(f);
          break;
        }
      } else {
        const f = this.layerAssets[i].getSource().getFeatureById(id);
        if (f) {
          this.layerAssets[i].getSource().removeFeature(f);
          break;
        }
      }
      
      
    }
  }

  getMapSize() {
    return this.map.getSize();
  }

  getBoundingBox(options) {
    // get coordinate of view port
    if (this.view === null || typeof this.view === 'undefined') {
      return null;
    }
    const zoom = Math.round(this.view.getZoom());
    const extent = this.view.calculateExtent(this.map.getSize());
    const bottomLeft = proj.transform(olExtent.getBottomLeft(extent), options.EPSG, SclMapConstantService.EPSG_4326);
    const topRight = proj.transform(olExtent.getTopRight(extent), options.EPSG, SclMapConstantService.EPSG_4326);

    if (isNaN(bottomLeft[0]) || isNaN(bottomLeft[1]) || isNaN(topRight[0]) ||  isNaN(topRight[1])) { return null; }

    const left = bottomLeft[0];
    const bottom = bottomLeft[1];
    const right = topRight[0];
    const top = topRight[1];

    // console.log(`*** left = ${left}, bottom = ${bottom}, right = ${right}, top = ${top}`);

    let minLon = left; let maxLon = right;
    if (left > right) {
      minLon = right; maxLon = left;
    }

    let minLat = bottom;
    let maxLat = top;
    if (bottom > top) {
      minLat = top; maxLat = bottom;
    }

    return { minLon, maxLat, maxLon, minLat, zoom }
  }

  getLayerSourceBoundingBox(layerIndex, systemMapLimit, EPSG) {
    const extent = this.layerAssets[this.layerIndexFilter].getSource().getExtent();
    const bottomLeft = proj.transform(olExtent.getBottomLeft(extent), EPSG, SclMapConstantService.EPSG_4326);
    const topRight = proj.transform(olExtent.getTopRight(extent), EPSG, SclMapConstantService.EPSG_4326);

    if (isNaN(bottomLeft[0]) || isNaN(bottomLeft[1]) || isNaN(topRight[0]) ||  isNaN(topRight[1])) { return null; }

    let l = bottomLeft[0]; // left
    let b = bottomLeft[1]; // bottom
    let r = topRight[0]; // right
    let t = topRight[1]; // top

    // systemMapLimit : [ [ top, left ], [bottom, right ] ] 
    const boxLimit = {
      left: systemMapLimit[0][1],
      bottom: systemMapLimit[1][0],
      right: systemMapLimit[1][1],
      top: systemMapLimit[0][0],
    }

    if (l < boxLimit.left) { l = boxLimit.left; }
    if (r > boxLimit.right) { r = boxLimit.right; }
    if (b < boxLimit.bottom) { b = boxLimit.bottom; }
    if (t > boxLimit.top) { t = boxLimit.top; }
    const box = this.validateBoxInBound({l, b, r, t}, boxLimit);
    return proj.transformExtent(box, SclMapConstantService.EPSG_4326, EPSG);
  }

  validateBoxInBound(box, boxLimit) {
    if (box.l < boxLimit.left) { box.l = boxLimit.left; }
    if (box.r > boxLimit.right) { box.r = boxLimit.right; }
    if (box.b < boxLimit.bottom) { box.b = boxLimit.bottom; }
    if (box.t > boxLimit.top) { box.t = boxLimit.top; }

    return [box.l, box.b, box.r, box.t];
  }

  validateBox(box, systemMapLimit, EPSG) {
    const box4326 = proj.transformExtent(box, EPSG, SclMapConstantService.EPSG_4326);
    const bbox = {
      l: box4326[0],
      b: box4326[1],
      r: box4326[2],
      t: box4326[3]
    }
    // systemMapLimit : [ [ top, left ], [bottom, right ] ] 
    const boxLimit = {
      left: systemMapLimit[0][1],
      bottom: systemMapLimit[1][0],
      right: systemMapLimit[1][1],
      top: systemMapLimit[0][0],
    }
    const boxEPSG = this.validateBoxInBound(bbox, boxLimit);
    return proj.transformExtent(boxEPSG, SclMapConstantService.EPSG_4326, EPSG);  
  }

  addSearchAddress(apiKey, wrapper, cb) {
    console.log('Need to bring back GoogleMapLoader ?');

    // GoogleMapsLoader.KEY = apiKey;
    // GoogleMapsLoader.LIBRARIES = 'places';
    // GoogleMapsLoader.SENSOR = true;
    // GoogleMapsLoader.load(function(google) {
    //     const autocomplete = new google.maps.places.Autocomplete(
    //         wrapper,
    //         { types: ['geocode'] });

    //     google.maps.event.addListener(autocomplete, 'place_changed', function() {
    //         const place = autocomplete.getPlace();
    //         const lat = place.geometry.location.lat();
    //         const lon = place.geometry.location.lng();

    //         if (cb && typeof cb == 'function') {
    //             cb(place, lat, lon);
    //         }
    //     });
    // });

  }

  clearAllFeatures() {
    // this.source.clear();//13835
    for (let i = 1; i < this.layerAssets.length; i++) { // start with layer index of asset from 1 to n
      this.layerAssets[i].getSource().clear(); // 13835
    }
  }

  clearAllFeaturesLayer(layerIndex) {
    if (layerIndex > this.layerAssets.length || !this.layerAssets[layerIndex].getSource()
     || this.layerAssets[layerIndex].get('isCluster')) { return; }
    this.layerAssets[layerIndex].getSource().clear();
  }

  updateSize() {
    this.map.updateSize();
  }

  getLatLngFromPixel(pixel) {
    const coordinate = this.map.getCoordinateFromPixel(pixel);
    const coor = proj.transform(coordinate, this.EPSG, SclMapConstantService.EPSG_4326);
    return coor;
  }

  getPixelFromCoordinate(coordinate) {
    const coor = proj.transform(coordinate, this.EPSG, SclMapConstantService.EPSG_4326);
    const pixel = this.map.getPixelFromCoordinate(coordinate);
    return {coor, pixel};
  }

  findFeatureByClick(evt, assetType, assetSelectionsAvailable, sType) {
    const features = [];
    const coordinate = evt.feature.getGeometry().getCoordinates();

    const obj = this.getPixelFromCoordinate(coordinate);

    const existedFeature = this.getFeaturesFromMap(features, obj.pixel, assetType, assetSelectionsAvailable, sType);

    return { coor: obj.coor, pixel: obj.pixel, features, existedFeature };
  }

  storeSelectedAssets(feature, isPrimary) {
    const fId = feature.getId();

    const fPro = feature.getProperties();
    const assetType = feature.get('assetType');


    if (this.selectedAssets == null) { this.selectedAssets = []; }
    const len = this.selectedAssets.length;
    for (let i = 0; i < len; i++) {
      const iId = this.selectedAssets[i].getId();

      if (iId === fId) {
        if (isPrimary) {
          const f = this.layerAssets[this.layerIndexPrimary].getSource().getFeatureById(iId);
          if (f == null) {
            this.addSelectedAssetsIcon(feature, this.layerIndexPrimary, this.stylePrimaryAssetFunc.bind(this));
          }
        } else {
          const f = this.layerAssets[this.layerIndexSecondary].getSource().getFeatureById(iId);
          if (f == null) {
            this.addSelectedAssetsIcon(feature, this.layerIndexSecondary, this.styleSecondaryAssetFunc.bind(this));
          }
        }
        this.selectedAssets[i] = feature;
        return;
      }
    }
    this.selectedAssets.push(feature);

    // 13835
    if (isPrimary) {
      this.addSelectedAssetsIcon(feature, this.layerIndexPrimary, this.stylePrimaryAssetFunc.bind(this));
    } else {
      this.addSelectedAssetsIcon(feature, this.layerIndexSecondary, this.styleSecondaryAssetFunc.bind(this));
    }

    // this.source.addFeature(feature); // 13835
  }
  addSelectedAssetsIcon(feature, layerIndex, styleFunc) {
    feature.set('zIndex', layerIndex);
    feature.setStyle(styleFunc(feature, null));
    this.layerAssets[layerIndex].getSource().addFeature(feature);
    this.layerAssets[layerIndex].setVisible(true);
  }

  async updateStoredSelectedAssetVisualize(id, handlebarsContext, primaryIcon
    , primaryAssetSelection, secondaryIcon, secondaryAssetSelection, handlebarAssetFn) {
    if (!this.selectedAssets) { return; }
    const len = this.selectedAssets.length;
    for (let i = 0; i < len; i++) {
      const feature = this.selectedAssets[i];
      let fId = feature.getId();
      if (fId.indexOf('_') > -1) { fId = fId.split('_')[0]; }
      if (id.indexOf(fId) > -1) {
        const p = feature.getProperties();
        let isPrimary = false;
        if (p.assetType === MapSelectAssetType.PRIMARY) { isPrimary = true; }
        
        if (isPrimary) {
          
          const primary = await handlebarAssetFn(handlebarsContext, primaryIcon
            , primaryAssetSelection, true);
        
          this.setFeatureProperties(feature, { primary});
          feature.setStyle(this.stylePrimaryAssetFunc(feature, null));
        } else {
          const secondary = await handlebarAssetFn(handlebarsContext, secondaryIcon
            , secondaryAssetSelection, false);

          this.setFeatureProperties(feature, { secondary});
          feature.setStyle(this.styleSecondaryAssetFunc(feature, null));
        }
        
        break;
      }
    }

  }

  removeSelectedAssetsById(id) {
    let fId = id;
    let mode = 'NA';
    if (fId && fId.indexOf('primary') > -1) { mode = 'primary';
    } else if (fId && fId.indexOf('secondary') > -1) { mode = 'secondary'; }

    if (fId && fId.indexOf('_') > -1) { fId = fId.split('_')[0]; }
    const len = this.selectedAssets.length;
    for (let i = len - 1; i > -1; i--) {
      const iId = this.selectedAssets[i].getId();
      if ((iId && iId.indexOf(mode) > -1 && iId.indexOf(fId) > -1) || iId === fId ) {
        this.selectedAssets.splice(i, 1);
        this.removeItemFromMap(iId);
      }
    }

  }

  removeLayerFeatures() {
    // console.log('***********************open layer removeLayerFeatures***************************');
    // this.source.clear();//will re-write for mantis 13835
    this.clearAllFeatures(); // as same as this.clearAllFeatures() will remove removeLayerFeatures function

  }

  // copy from sclAssetLayers.removeUnselectedAsset
  removeUnselectedAsset(assets, unSelectedAssetIds, type) {
    for (let i = 0; i < unSelectedAssetIds.length; i++) {
      const priAsset = unSelectedAssetIds[i];
      for (let j = 0; j < assets.length; j++) {
        const id = assets[j].properties.linkAssets[0].documentId;
        if (id === priAsset) {
          this.removeItemFromMap(id + '_' + type);
          assets.splice(j, 1);
        }
      }
    }
  }

  updateLayers(pLayerAssets) {
    // remove feature in all layersz
    this.removeLayerFeatures();
    // remove old layers
    for (let i = 1; i < this.layerAssets.length; i++) {// start with layer index of asset from 1 to n
      this.map.removeLayer(this.layerAssets[i]);
    }

    // add new layers
    const obj = {layerAssets: pLayerAssets};
    this.createLayers(obj);
    if (this.layerAssets.length > 0) {
      for (let iLa = 1; iLa < this.layerAssets.length; iLa++) {// start with layer index of asset from 1 to n
        this.map.addLayer(this.layerAssets[iLa]);
      }
    }

  }

  // ************** use for psma layer reverse function *******************************************
  psmaStyleFunction(feature, resolution) {
    if (typeof feature !== 'object' || typeof feature.getProperties() === 'undefined') { return null; }
    const p = feature.getProperties();
    const description = feature.getProperties().description;
    const label = (typeof description === 'undefined' || description === null) ? '' : description + '';
    let image: any = new Circle({
      radius: 3,
      fill: new Fill({
        color: [255, 127, 39, 1]
      }),
      stroke: new Stroke({
        color: [255, 0, 0, 1],
        width: 1.5
      })
    });
    if (p.icon) {
      const anchor = [0.5, 0.5];
      image = new Icon(({
        src: p.icon,
        anchor
      }));
    }

    const style = new Style({
      fill: new Fill({
        color: 'rgba(255,255,255,0.4)'
      }),
      stroke: new Stroke({
        color: '#3399CC',
        width: 1.25
      }),
      text: new Text({
        font: '12px Arial',
        fill: new Fill({ color: '#000' }),
        stroke: new Stroke({
          color: '#fff', width: 2
        }),
        textBaseline: 'top',
        // get the text from the feature - `this` is ol.Feature
        // and show only under certain resolution
        text: label
      }),
      image,
      // zIndex: 10000 //13835
    });
    return style;
  }

  psmaCreateLayer(psmaPoints) {
    if (typeof this.psmaReverse === 'undefined' || this.psmaReverse === null) {
      this.psmaReverse = {};

      this.layerAssets[this.layerIndexAddress].getSource().addFeatures(psmaPoints); // 13835
      this.psmaReverse.psmaSourceVector = this.layerAssets[this.layerIndexAddress].getSource();

      this.layerAssets[this.layerIndexAddress].setStyle(this.psmaStyleFunction.bind(this)); // 13835
      this.psmaReverse.psmaLayer = this.layerAssets[this.layerIndexAddress]; // 13835

    }

    return this.psmaReverse;
  }

  psmaCreatePoint(coor, properties, psmaPoints) {
    const coorMap = proj.transform(coor, SclMapConstantService.EPSG_4326, this.EPSG ); // 'EPSG:3111'
    const iconFeature = new Feature(new Point(coorMap));
    iconFeature.setProperties(properties);
    // this.psmaReverse.psmaSourceVector.addFeature(iconFeature);//13835
    this.layerAssets[this.layerIndexAddress].getSource().addFeature(iconFeature); // 13835

    psmaPoints.push(iconFeature);
    return psmaPoints;
  }

  psmaCreatePointClick(coor, radius, psmaPoints) {
    const circle4326 = circular(coor, radius); // openlayer 5
    const circle3857 = circle4326.clone().transform(SclMapConstantService.EPSG_4326, this.EPSG); // 'EPSG:3111'
    const clickFeature = new Feature(circle3857);
    // this.psmaReverse.psmaSourceVector.addFeature(clickFeature);//13835
    this.layerAssets[this.layerIndexAddress].getSource().addFeature(clickFeature); // 13835

    psmaPoints.push(clickFeature);
    return psmaPoints;

  }

  psmaRemovePoint(psmaPoints, psmaSourceVector) {
    for (let i = 0; i < psmaPoints.length; i++) {
      if (psmaPoints[i] == null) { continue; }
      psmaSourceVector.removeFeature(psmaPoints[i]);
    }

    return { psmaPoints, psmaSourceVector };
  }

  psmaDistanceCoords(coorA, coorB) {
    const distance = getDistance(coorA, coorB); // openlayer 5
    return distance;
  }

  // copy from sclUtilMap.positionView
  positionView(lat, lon, zoom, EPSG) {
    // if(this.wmsState.finishLoad == false || this.wmsState.tileCount == 0){
    //     this.positionObject = { hasCall: true, lat: lat, lon: lon, zoom: zoom, epsg: EPSG };
    //     return;
    // }

    lat = (typeof lat !== 'undefined') ? lat : 0;
    lon = (typeof lon !== 'undefined') ? lon : 0;
    zoom = (typeof zoom !== 'undefined') ? zoom : 2;
    EPSG = (typeof EPSG !== 'undefined') ? EPSG : SclMapConstantService.EPSG_3857;
    this.view.setCenter(proj.transform([lon, lat], SclMapConstantService.EPSG_4326, EPSG));
    this.view.setZoom(zoom);
  }

  //
  setCenterMapViewByCoordinates(bbox) {
    // new bounding box
    const bottom = bbox[1][1]; const left = bbox[0][0]; const top = bbox[0][1]; const right = bbox[1][0];
    let ext = [left, bottom, right, top]; // [minlon, minlat, maxlon, maxlat];
    ext = olExtent.applyTransform(ext, proj.getTransform(SclMapConstantService.EPSG_4326, this.EPSG));

    // console.log(`%c **** setCenterMapViewByCoordinates, FIT`, 'color:blue');
    this.view.fit(ext,
      {   size: this.map.getSize()
        , constrainResolution: false
      });

  }
  // 15262
  setCenter(lat, lon) {
    const center = proj.transform([lon, lat], SclMapConstantService.EPSG_4326, this.EPSG);
    this.view.setCenter(center);
  }
  setSelectAssetCluster (features, currentSelected) {
    for (let i = 0; i < features.length; i++) {
      currentSelected.push(features[i].feature);
    }
  }

  extendToCoordinate(coord) {
    const currentLoc = proj.transform(this.map.getView().getCenter(), this.EPSG, SclMapConstantService.EPSG_4326);
    let ext = boundingExtent([coord, currentLoc]);
    ext = proj.transformExtent(ext, proj.get(SclMapConstantService.EPSG_4326), proj.get(this.EPSG));
    // console.log(`%c **** extendToCoordinate, FIT`, 'color:blue');
    this.map.getView().fit(ext, {
      size: this.map.getSize(),
      padding: [50, 0, 50, 0]
    });
  }

  getFeatureCoordinate(feature) {
    let geom = cloneDeep(feature.getGeometry());
    geom = geom.transform(this.EPSG, SclMapConstantService.EPSG_4326);
    const type = geom.getType();
    const coords = geom.getCoordinates();
    let coordArray = cloneDeep(coords);
    const finalCoords = [];
    if (type === MapDrawType.LINE_STRING) {
      for (let i = 0; i < coords.length - 1; i++) {
        finalCoords.push([ coords[i], coords[i + 1] ]);
      }
      coordArray = [];
      for (let i = 0; i < coords.length; i++) {
        coordArray.push(coords[i]);
      }
      
    } else if (type === MapDrawType.POLYGON) {
      for (let i = 0; i < coords[0].length - 1; i++) {
        finalCoords.push([ coords[0][i], coords[0][i + 1] ]);
      }
      coordArray = [];
      for ( let i = 0; i < coords[0].length; i++) {
        coordArray.push(coords[0][i]);
      }
    } else if (type === MapDrawType.MULTI_LINE_STRING) {
      for (let i = 0; i < coords.length; i++) {
        for (let j = 0; j < coords[i].length - 1; j++) {
          finalCoords.push([coords[i][j], coords[i][j + 1]])
        }
      }
      coordArray = [];
      for (let i = 0; i < coords.length; i++) {
        for (let j = 0; j < coords[i].length; j++) {
          coordArray.push(coords[i][j]);
        }
      }
    } else if (type === MapDrawType.MULTI_POLYGON) {
      for (let i = 0; i < coords.length; i++) {
        for (let j = 0; j < coords[i][0].length - 1; j++) {
          finalCoords.push([ coords[i][0][j], coords[i][0][j + 1] ]);
        }
      }
      coordArray = [];
      for (let i = 0; i < coords.length; i++) {
        for (let j = 0; j < coords[i][0].length; j++) {
          coordArray.push(coords[i][0][j]);
        }
      }
    }

    return { coords: finalCoords, type, coordArray };
  }
}
